/* Woordenboek FR→NL van de app (gegenereerd, na te lezen). */
export const nlApp = {
  "!items?.length ? null : (": "!items?.length? null: (",
  "% TVA": "% btw",
  "% d'acompte": "% voorschot",
  "% du HTVA": "% van het bedrag excl. btw",
  "% · ouvrier": "% · arbeider",
  "(achat": "(aankoop",
  "(chaque jour ouvrable par défaut, réglable dans le Dashboard Mollie → Virements). Devisto ne détient jamais vos fonds et ne prend aucune commission : seuls les frais Mollie s'appliquent (≈ 0,39 € par paiement Bancontact, sans abonnement). Pour recevoir les virements, votre compte Mollie doit être vérifié (identité + IBAN).": "(standaard elke werkdag, aanpasbaar in het Mollie-dashboard → Uitbetalingen). Devisto houdt uw geld nooit in beheer en rekent geen commissie aan: alleen de kosten van Mollie zijn van toepassing (≈ 0,39 € per Bancontact-betaling, zonder abonnement). Om uitbetalingen te ontvangen, moet uw Mollie-account geverifieerd zijn (identiteit + IBAN).",
  "(dans": "(in",
  "(display-mode: standalone)": "(display-mode: standalone)",
  "(en vigueur le": "(van kracht op",
  "(estimation IA)": "(AI-schatting)",
  "(markdown léger : ## titre, - liste, **gras**)": "(lichte markdown: ## titel, - lijst, **vet**)",
  "(pro)": "(pro)",
  "(précédemment": "(voorheen",
  "(rappel client 15 j avant, push la veille, intervention + facture créées automatiquement)": "(herinnering aan de klant 15 dagen vooraf, pushmelding de dag voordien, interventie + factuur automatisch aangemaakt)",
  "(réf.": "(ref.",
  "(variable d'environnement)": "(omgevingsvariabele)",
  ") — vérifiez votre compte puis enregistrez le paiement.": ") — controleer uw account en registreer daarna de betaling.",
  "), sous votre objectif de": "), onder uw doel van",
  "). Vérifiez avant d'appliquer.": "). Controleer dit voordat u het toepast.",
  "+ Nouvelle option…": "+ Nieuwe optie…",
  "+32 4xx xx xx xx": "+32 4xx xx xx xx",
  "+33 6 xx xx xx xx": "+33 6 xx xx xx xx",
  "+34 6xx xxx xxx": "+34 6xx xxx xxx",
  "+352 6xx xxx xxx": "+352 6xx xxx xxx",
  ", en attente": ", in afwachting",
  ", minmax(0, 1fr))": ", minmax(0, 1fr))",
  ", reconduction tacite ·": ", stilzwijgende verlenging ·",
  ", sans carte bancaire.": ", zonder kredietkaart.",
  ", toutes répondues": ", allemaal beantwoord",
  ", à partir du": ", vanaf",
  ". Déposez un nouveau document ci-dessous.": ". Voeg hieronder een nieuw document toe.",
  ". Signez ci-dessous pour poursuivre votre entretien sans interruption.": ". Onderteken hieronder om uw onderhoud zonder onderbreking voort te zetten.",
  ". Vous validez tout avant envoi.": ". U keurt alles goed vóór verzending.",
  "0 % / exonéré": "0 % / vrijgesteld",
  "1 visite / an": "1 bezoek / jaar",
  "1 visite par an": "1 bezoek per jaar",
  "1 · Que voulez-vous mesurer ?": "1 · Wat wilt u meten?",
  "100 % belge · Peppol UBL": "100 % Belgisch · Peppol UBL",
  "15 jours": "15 dagen",
  "1er janvier 2026": "1 januari 2026",
  "2 visites / an": "2 bezoeken / jaar",
  "2 visites par an": "2 bezoeken per jaar",
  "2 · Indication (facultatif)": "2 · Toelichting (optioneel)",
  "25 € / mois par société": "25 € / maand per bedrijf",
  "30 jours": "30 dagen",
  "30 jours gratuits": "30 dagen gratis",
  "30 jours gratuits · sans carte · Peppol inclus · 25 € HTVA/mois ensuite": "30 dagen gratis · zonder kredietkaart · Peppol inbegrepen · daarna 25 € excl. btw/maand",
  "4 visites / an": "4 bezoeken / jaar",
  "4 visites par an": "4 bezoeken per jaar",
  "6 caractères minimum": "Minstens 6 tekens",
  "6 caractères minimum.": "Minstens 6 tekens.",
  "7 jours": "7 dagen",
  ": !buys.length ? (": ":!buys.length? (",
  ": !sales.length ? (": ":!sales.length? (",
  ": \"\"],\n                  [\"Année de construction\", site.year_built],\n                  [\"Surface chauffée\", site.heated_area ?": ": \"\"],\n                  [\"Bouwjaar\", site.year_built],\n                  [\"Verwarmde oppervlakte\", site.heated_area?",
  ": \"Votre abonnement est en cours.\"\n                : expired\n                  ? \"Activez l'abonnement pour préparer de nouveaux devis. Vos dossiers restent accessibles.\"\n                  :": ": \"Uw abonnement is actief.\": expired? \"Activeer uw abonnement om nieuwe offertes op te stellen. Uw dossiers blijven toegankelijk.\":",
  ": dictation.recording ?": ": dictation.recording?",
  ": facturé": ": gefactureerd",
  ": form.template_id ?": ": form.template_id?",
  ": le bouton « Laisser un avis » y renverra.": ": de knop « Een beoordeling achterlaten » verwijst ernaar.",
  ": on ?": ": on?",
  ": recording ?": ": recording?",
  ": travaux, matériel, constat et recommandations mis à jour. Relisez et ajustez.": ": werkzaamheden, materiaal, vaststellingen en aanbevelingen bijgewerkt. Lees na en pas aan.",
  ": vous validez, le client signe sur place.": ": u keurt goed, de klant ondertekent ter plaatse.",
  ": withAi ?": ": withAi?",
  "? Cette action est définitive.": "? Deze actie is definitief.",
  "?force=true": "?force=true",
  "?instruction=": "?instruction=",
  "?invoice_id=": "?invoice_id=",
  "?month=": "?month=",
  "?mt=": "?mt=",
  "?renouveler=1": "?renouveler=1",
  "AV123456": "AV123456",
  "AXA, Ethias, AG, Baloise…": "AXA, Ethias, AG, Baloise…",
  "Abonnement": "Abonnement",
  "Abonnement Devisto (prix local / mois)": "Devisto-abonnement (lokale prijs / maand)",
  "Abonnement actif": "Actief abonnement",
  "Abonnement activé. Merci !": "Abonnement geactiveerd. Bedankt!",
  "Abonné": "Abonnee",
  "Abonnés payants": "Betalende abonnees",
  "Abos actifs": "Actieve abonnementen",
  "Absente": "Afwezig",
  "Accepter et signer": "Aanvaarden en ondertekenen",
  "Accepté": "Aanvaard",
  "Accès chantier": "Toegang tot de werf",
  "Accès comptable": "Toegang voor de boekhouder",
  "Accès comptable : consultation des factures, achats et exports uniquement": "Toegang voor de boekhouder: alleen facturen, aankopen en exports raadplegen",
  "Accès de la société": "Bedrijfstoegang",
  "Accès en consultation : vous ne pouvez ni créer ni modifier de document. Les CSV de l'export utilisent le séparateur « ; » (Excel, WinBooks, Exact, Yuki, Billit, Odoo).": "Alleen-lezen toegang: u kunt geen documenten aanmaken of wijzigen. De CSV-bestanden in de export gebruiken het scheidingsteken «; » (Excel, WinBooks, Exact, Yuki, Billit, Odoo).",
  "Accès introuvable": "Toegang niet gevonden",
  "Accès retiré.": "Toegang ingetrokken.",
  "Accès à l'application pour votre comptable": "Toegang tot de applicatie voor uw boekhouder",
  "Accès, clés, code, étage, emplacement de la chaufferie…": "Toegang, sleutels, code, verdieping, locatie van de stookruimte…",
  "Achats": "Aankopen",
  "Acompte, finale ou libre": "Voorschotfactuur, eindfactuur of vrije factuur",
  "Acomptes et factures finales reliés à vos devis. Les notes de crédit sont dans Avoirs.": "Voorschotfacturen en eindfacturen gekoppeld aan uw offertes. De creditnota's vindt u onder Creditnota's.",
  "Actif": "Actief",
  "Actif ·": "Actief ·",
  "Actif · clé": "Actief · sleutel",
  "Actif · prochaine visite": "Actief · volgend bezoek",
  "Actif · résumé du soir à 18h": "Actief · avondoverzicht om 18h",
  "Actifs": "Actief",
  "Action impossible.": "Actie niet mogelijk.",
  "Actions rapides": "Snelle acties",
  "Activation impossible.": "Activeren niet mogelijk.",
  "Activer": "Activeren",
  "Activer la facturation": "Facturatie activeren",
  "Activer mon abonnement": "Mijn abonnement activeren",
  "Activer mon accès": "Mijn toegang activeren",
  "Activez Bancontact/Payconiq dans votre Dashboard Mollie.": "Schakel Bancontact/Payconiq in via uw Mollie-dashboard.",
  "Activez l'abonnement pour continuer à préparer vos devis.": "Activeer het abonnement om offertes te blijven opstellen.",
  "Activez l'abonnement pour préparer de nouveaux devis. Vos dossiers restent accessibles.": "Activeer het abonnement om nieuwe offertes op te stellen. Uw dossiers blijven toegankelijk.",
  "Activez votre facturation Peppol": "Activeer uw Peppol-facturatie",
  "Activité mensuelle": "Maandelijkse activiteit",
  "Actualiser": "Vernieuwen",
  "Administration ID Yuki": "Yuki-administratie-ID",
  "Adresse": "Adres",
  "Adresse de l'assureur": "Adres van de verzekeraar",
  "Adresse des travaux": "Adres van de werken",
  "Adresse du chantier": "Adres van de werf",
  "Adresse indisponible.": "Adres niet beschikbaar.",
  "Adresse mise à jour.": "Adres bijgewerkt.",
  "Adresse non renseignée": "Adres niet ingevuld",
  "Afficher l'assurance sur mes documents": "Mijn verzekering op mijn documenten vermelden",
  "Afficher les articles achetés": "De aangekochte artikelen weergeven",
  "Afficher mes avis clients dans les devis": "Mijn klantbeoordelingen in offertes weergeven",
  "Afficher mon logo dans les emails clients": "Mijn logo in e-mails naar klanten weergeven",
  "Afficher « Devis gratuit – 0 € » dans l'email": "« Gratis offerte – 0 € » in de e-mail weergeven",
  "Affiner avec mes réponses": "Verfijnen met mijn antwoorden",
  "Agenda 7 jours": "Agenda 7 dagen",
  "Ajout impossible": "Toevoegen niet mogelijk",
  "Ajout impossible.": "Toevoegen niet mogelijk.",
  "Ajoute deux heures de main-d'œuvre": "Voeg twee uur werkuren toe",
  "Ajoute l'évacuation des déchets": "Voeg de afvoer van het afval toe",
  "Ajoute le déplacement et la mise en service": "Voeg de verplaatsing en de inbedrijfstelling toe",
  "Ajoute un acompte de 30 % à la commande": "Voeg een voorschot van 30 % bij bestelling toe",
  "Ajouter": "Toevoegen",
  "Ajouter au devis": "Aan de offerte toevoegen",
  "Ajouter aux remarques": "Aan de opmerkingen toevoegen",
  "Ajouter depuis mes tarifs…": "Toevoegen vanuit mijn tarieven…",
  "Ajouter du matériel à un chantier": "Materiaal aan een werf toevoegen",
  "Ajouter l'équipement": "Het toestel toevoegen",
  "Ajouter mon logo": "Mijn logo toevoegen",
  "Ajouter un destinataire": "Een ontvanger toevoegen",
  "Ajouter un pays": "Een land toevoegen",
  "Ajouter un taux": "Een tarief toevoegen",
  "Ajouter une intervention ce jour": "Vandaag een interventie toevoegen",
  "Ajouter une ligne": "Een regel toevoegen",
  "Ajouter une question": "Een vraag toevoegen",
  "Ajoutez Devisto à votre écran d'accueil": "Voeg Devisto toe aan uw startscherm",
  "Ajoutez au moins une ligne au devis": "Voeg minstens één regel toe aan de offerte",
  "Ajoutez au moins une ligne avec une description": "Voeg minstens één regel met een beschrijving toe",
  "Ajoutez au moins une ligne avec une description.": "Voeg minstens één regel met een beschrijving toe.",
  "Ajoutez chaque passage : la prochaine échéance se recalcule": "Voeg elk bezoek toe: de volgende vervaldatum wordt opnieuw berekend",
  "Ajoutez d'abord votre lien d'avis (Google, etc.) dans": "Voeg eerst uw beoordelingslink (Google, enz.) toe bij",
  "Ajoutez des photos ci-dessous pour que l'IA les décrive dans le rapport": "Voeg hieronder foto's toe zodat de AI ze in het verslag kan beschrijven",
  "Ajoutez l'email du client avant d'envoyer la planification": "Voeg het e-mailadres van de klant toe voordat u de planning verstuurt",
  "Ajoutez l'email du client avant de relancer": "Voeg het e-mailadres van de klant toe voordat u een herinnering stuurt",
  "Ajoutez l'email du client avant l'envoi": "Voeg het e-mailadres van de klant toe voordat u het bericht verstuurt",
  "Ajoutez l'email du client dans le dossier avant l'envoi": "Voeg het e-mailadres van de klant toe aan het dossier voordat u het bericht verstuurt",
  "Ajoutez la chaudière, la PAC, la ventilation ou le boiler. Vous obtiendrez un QR code à coller sur l'appareil et un rappel d'entretien automatique.": "Voeg de verwarmingsketel, warmtepomp, ventilatie of boiler toe. U krijgt een QR-code om op het toestel te kleven en een automatische onderhoudsherinnering.",
  "Ajoutez un PDF : l'IA lit le fournisseur, les montants et l'échéance.": "Voeg een PDF toe: AI leest de leverancier, de bedragen en de vervaldatum.",
  "Ajoutez un PDF ou écrivez la liste du matériel": "Voeg een PDF toe of schrijf de materiaallijst",
  "Ajoutez un PDF ou écrivez la liste du matériel.": "Voeg een PDF toe of schrijf de materiaallijst.",
  "Ajoutez une consigne (facultatif) puis envoyez : l'assistant identifie le matériel.": "Voeg eventueel een instructie toe en verstuur: de assistent herkent het materiaal.",
  "Ajoutez une date d'installation à vos équipements pour planifier les entretiens.": "Voeg een installatiedatum toe aan uw toestellen om het onderhoud te plannen.",
  "Ajoutez une mesure avec les boutons ci-dessous.": "Voeg een meting toe met de onderstaande knoppen.",
  "Ajoutez votre assurance": "Voeg uw verzekering toe",
  "Ajoutez votre lien d'avis (Google) dans votre profil avant d'envoyer une demande d'avis": "Voeg de link naar uw Google-beoordelingen toe aan uw profiel voordat u een beoordelingsverzoek verstuurt",
  "Ajoutez votre logo et choisissez vos couleurs : devis, rapports et factures les reprendront automatiquement. Vous pourrez modifier tout ça à tout moment dans votre profil.": "Voeg uw logo toe en kies uw kleuren: uw offertes, rapporten en facturen nemen die automatisch over. U kunt dit alles op elk moment wijzigen in uw profiel.",
  "Ajoutées en dernière page de vos devis et factures PDF, et visibles sur les pages en ligne. Une ligne commençant par « Article » devient un titre.": "Toegevoegd op de laatste pagina van uw offertes en facturen in PDF-formaat, en zichtbaar op de online pagina's. Een regel die begint met « Artikel » wordt een titel.",
  "Alarme": "Alarm",
  "Alertes sur ce téléphone": "Meldingen op deze telefoon",
  "Alimentation électrique": "Elektrische voeding",
  "Aller directement à": "Ga rechtstreeks naar",
  "Aller à mes factures": "Ga naar mijn facturen",
  "Amendes de 1 500 € à 5 000 € en cas de non-conformité répétée après avertissement.": "Boetes van 1 500 € tot 5 000 € bij herhaalde niet-naleving na een waarschuwing.",
  "Analyse de la dictée impossible. Réessayez.": "Analyse van het dictaat niet mogelijk. Probeer het opnieuw.",
  "Analyse de la photo…": "Foto wordt geanalyseerd…",
  "Analyse en cours…": "Analyse bezig…",
  "Analyse impossible.": "Analyse niet mogelijk.",
  "Analyse…": "Analyse…",
  "Ancienneté approximative": "Geschatte ouderdom",
  "Annuler": "Annuleren",
  "Annuler l'invitation": "Uitnodiging annuleren",
  "Annulée": "Geannuleerd",
  "Année": "Jaar",
  "Année approximative": "Geschat jaar",
  "Année de construction": "Bouwjaar",
  "Août": "Augustus",
  "Aperçu": "Voorbeeld",
  "Aperçu PDF": "PDF-voorbeeld",
  "Aperçu d'un devis": "Voorbeeld van een offerte",
  "Aperçu du document": "Voorbeeld van het document",
  "Aperçu du résumé du soir": "Voorbeeld van het avondoverzicht",
  "Aperçu impossible.": "Voorbeeld niet mogelijk.",
  "Aperçu indisponible.": "Voorbeeld niet beschikbaar.",
  "Apparence": "Uiterlijk",
  "Apparence de l'espace Studio": "Uiterlijk van de Studio-omgeving",
  "Apparence de vos devis et factures, pied de page et modèles d'emails envoyés à vos clients.": "Uiterlijk van uw offertes en facturen, voettekst en e-mailsjablonen voor uw klanten.",
  "Apparent": "Opbouw",
  "Apple Pay": "Apple Pay",
  "Appliquer": "Toepassen",
  "Appliquer à la fiche": "Toepassen op de fiche",
  "Apposée dans le cadre « Signature de l'entreprise » de vos devis, contrats et rapports PDF.": "Wordt geplaatst in het vak « Handtekening van het bedrijf » op uw offertes, contracten en PDF-rapporten.",
  "Appuyez sur Partager, en bas de Safari": "Tik op Delen, onderaan in Safari",
  "Après travaux": "Na de werken",
  "Archivé": "Gearchiveerd",
  "Arrivé sur place": "Ter plaatse aangekomen",
  "Arrivée estimée": "Verwachte aankomst",
  "Arrivée estimée 09:15": "Verwachte aankomst 09:15",
  "ArrowDown": "ArrowDown",
  "ArrowUp": "ArrowUp",
  "Arrêter": "Stoppen",
  "Arrêter la dictée": "Dicteren stoppen",
  "Article 1 – Champ d'application Les présentes conditions s'appliquent à… Article 2 – Paiement …": "Artikel 1 – Toepassingsgebied Deze voorwaarden zijn van toepassing op… Artikel 2 – Betaling …",
  "Article 1 – Champ d'application\\nLes présentes conditions s'appliquent à…\\n\\nArticle 2 – Paiement\\n…": "Artikel 1 – Toepassingsgebied\\nDeze voorwaarden zijn van toepassing op…\\n\\nArtikel 2 – Betaling\\n…",
  "Article créé.": "Artikel aangemaakt.",
  "Article mis à jour.": "Artikel bijgewerkt.",
  "Article supprimé.": "Artikel verwijderd.",
  "Artisan :": "Vakman:",
  "Artisans": "Vakmensen",
  "Ascenseurs et monte-charges": "Liften en goederenliften",
  "Assistant": "Assistent",
  "Assistant Devisto": "Devisto-assistent",
  "Assistant IA": "AI-assistent",
  "Assistant vocal et lecture de plaque": "Spraakassistent en nummerplaatherkenning",
  "Assujetti": "Btw-plichtig",
  "Attendu :": "Verwacht:",
  "Attention : ce devis est à perte (": "Opgelet: deze offerte is verlieslatend (",
  "Attention : ce devis est à perte en l'état.": "Opgelet: deze offerte is momenteel verlieslatend.",
  "Au": "Op",
  "Au sujet d'un devis": "Over een offerte",
  "Au sujet d'une facture": "Over een factuur",
  "Aucun": "Geen",
  "Aucun accès comptable pour l'instant.": "Voorlopig geen toegang voor de boekhouder.",
  "Aucun article pour le moment.": "Voorlopig geen artikelen.",
  "Aucun autre dossier ne correspond.": "Geen enkel ander dossier komt overeen.",
  "Aucun avoir fournisseur": "Geen creditnota van een leverancier",
  "Aucun avoir pour l'instant": "Voorlopig geen creditnota",
  "Aucun bâtiment enregistré": "Geen gebouw geregistreerd",
  "Aucun chantier lié": "Geen gekoppelde werf",
  "Aucun client enregistré.": "Geen klanten geregistreerd.",
  "Aucun client ne correspond à votre recherche.": "Geen enkele klant komt overeen met uw zoekopdracht.",
  "Aucun contrat": "Geen contracten",
  "Aucun devis ne correspond": "Geen enkele offerte komt overeen",
  "Aucun devis pour l'instant": "Voorlopig geen offertes",
  "Aucun devis signé sur": "Geen ondertekende offertes voor",
  "Aucun document d'achat sur cette année": "Geen aankoopdocumenten voor dit jaar",
  "Aucun document ne correspond": "Geen enkel document komt overeen",
  "Aucun document pour le moment.": "Momenteel geen documenten.",
  "Aucun dossier ne correspond": "Geen enkel dossier komt overeen",
  "Aucun dossier pour l'instant": "Voorlopig geen dossiers",
  "Aucun dossier soumis pour le moment.": "Momenteel geen ingediende dossiers.",
  "Aucun entretien cette semaine, aucun contrat à renouveler.": "Deze week geen onderhoud, geen contracten te verlengen.",
  "Aucun entretien à replacer": "Geen onderhoud opnieuw in te plannen",
  "Aucun logo": "Geen logo",
  "Aucun matériel reconnu. Précisez la liste ou vérifiez le PDF.": "Geen materiaal herkend. Verduidelijk de lijst of controleer de PDF.",
  "Aucun modèle — devis vierge ou IA": "Geen sjabloon — lege offerte of AI",
  "Aucun oubli détecté, le devis est prêt à partir.": "Niets vergeten, de offerte is klaar om te versturen.",
  "Aucun ouvrier ni comptable pour l'instant. Donnez votre premier accès ci-dessus.": "Voorlopig geen arbeider of boekhouder. Verleen hierboven voor het eerst toegang.",
  "Aucun rappel à envoyer pour le moment.": "Momenteel geen herinneringen te versturen.",
  "Aucun repère fiable détecté : valeurs indicatives. Confirmez une dimension connue ci-dessous.": "Geen betrouwbaar referentiepunt gedetecteerd: de waarden zijn indicatief. Bevestig hieronder een bekende afmeting.",
  "Aucun règlement": "Geen betalingen",
  "Aucun règlement enregistré.": "Geen betalingen geregistreerd.",
  "Aucun résultat pour «": "Geen resultaten voor «",
  "Aucun travail listé. Ajoutez une ligne.": "Geen werkzaamheden vermeld. Voeg een regel toe.",
  "Aucun équipement": "Geen toestellen",
  "Aucune": "Geen",
  "Aucune (article indépendant)": "Geen (afzonderlijk artikel)",
  "Aucune conversation pour l'instant.": "Voorlopig geen gesprekken.",
  "Aucune demande pour l'instant": "Voorlopig geen aanvragen",
  "Aucune facture d'achat": "Geen aankoopfacturen",
  "Aucune facture de vente sur cette année": "Geen verkoopfacturen voor dit jaar",
  "Aucune facture en": "Geen facturen in",
  "Aucune facture pour cette période.": "Geen facturen voor deze periode.",
  "Aucune facture pour l'instant": "Voorlopig geen facturen",
  "Aucune facture émise.": "Geen facturen uitgereikt.",
  "Aucune information lisible sur cette plaque.": "Geen leesbare informatie op dit typeplaatje.",
  "Aucune intervention enregistrée": "Geen interventies geregistreerd",
  "Aucune intervention enregistrée pour le moment.": "Momenteel geen interventies geregistreerd.",
  "Aucune intervention enregistrée.": "Geen interventies geregistreerd.",
  "Aucune intervention ne correspond": "Geen overeenkomende interventies",
  "Aucune intervention pour ce chantier.": "Geen interventies voor deze werf.",
  "Aucune intervention pour l'instant": "Voorlopig geen interventies",
  "Aucune ligne pour l'instant": "Voorlopig geen regels",
  "Aucune mesure proposée : ajoutez vos points à la main ou reprenez la photo avec une référence (feuille A4, mètre).": "Geen afmetingen voorgesteld: voeg uw punten handmatig toe of maak de foto opnieuw met een referentie (A4-blad, meetlat).",
  "Aucune modification : paramètres initiaux (à vérifier) en place.": "Geen wijzigingen: de oorspronkelijke instellingen (te controleren) blijven van toepassing.",
  "Aucune note de crédit sur cette année": "Geen creditnota's voor dit jaar",
  "Aucune notification pour l'instant.": "Voorlopig geen meldingen.",
  "Aucune notification.": "Geen meldingen.",
  "Aucune parole détectée dans l'enregistrement": "Geen spraak gedetecteerd in de opname",
  "Aucune prestation. Importez un jeu de tarifs types pour démarrer.": "Geen prestaties. Importeer een set standaardtarieven om te beginnen.",
  "Aucune question en attente": "Geen openstaande vragen",
  "Aucune question pour l'instant": "Voorlopig geen vragen",
  "Aucune réponse envoyée": "Geen antwoord verzonden",
  "Aucune signature": "Geen handtekening",
  "Aucune société pour le moment.": "Voorlopig geen bedrijven.",
  "Aucune visite planifiée": "Geen bezoeken gepland",
  "Aujourd'hui 09:00": "Vandaag 09:00",
  "Auto si vide": "Automatisch indien leeg",
  "Autoliquidation": "Btw verlegd",
  "Autoliquidation : TVA à acquitter par le cocontractant (art. 20 de l'A.R. n° 1 du 29/12/1992). Cette mention\n          est reprise automatiquement sur le devis PDF.": "Btw verlegd: btw te voldoen door de medecontractant (art. 20 van het KB n° 1 van 29/12/1992). Deze vermelding\n          wordt automatisch overgenomen op de offerte in pdf-formaat.",
  "Autoliquidation : TVA à acquitter par le cocontractant (art. 20 de l'A.R. n° 1 du 29/12/1992). Cette mention est reprise automatiquement sur le devis PDF.": "Btw verlegd: btw te voldoen door de medecontractant (art. 20 van het KB n° 1 van 29/12/1992). Deze vermelding wordt automatisch overgenomen op de offerte in pdf-formaat.",
  "Autoliquidation possible dans ce pays": "Btw verlegd mogelijk in dit land",
  "Autorisation refusée.": "Toestemming geweigerd.",
  "Autre": "Andere",
  "Autre métier technique": "Ander technisch vakgebied",
  "Autre réponse…": "Ander antwoord…",
  "Autres idées": "Andere ideeën",
  "Autres postes": "Andere posten",
  "Avant / après, plaque, raccordements : jusqu'à 6 photos dans le rapport.": "Voor / na, typeplaatje, aansluitingen: maximaal 6 foto's in het verslag.",
  "Avant d'envoyer": "Voor het verzenden",
  "Avant de créer votre première facture, vérifiez votre numéro de TVA (base VIES) et déposez un extrait BCE ou une facture de frais.": "Controleer vóór u uw eerste factuur aanmaakt uw btw-nummer (VIES-databank) en upload een KBO-uittreksel of een kostenfactuur.",
  "Avant travaux": "Vóór de werken",
  "Avec option": "Met optie",
  "Avis client": "Klantbeoordeling",
  "Avoir": "Creditnota",
  "Avoir fournisseur": "Creditnota van leverancier",
  "Avoirs": "Creditnota's",
  "Avoirs fournisseurs": "Creditnota's van leveranciers",
  "Avr": "Apr",
  "Avril": "April",
  "BE 0123.456.789": "BE 0123.456.789",
  "BE0123456789": "BE0123456789",
  "Ballon": "Warmwaterboiler",
  "Bancontact": "Bancontact",
  "Bancontact · Payconiq": "Bancontact · Payconiq",
  "Base": "Basis",
  "Bearer": "Bearer",
  "Belfius": "Belfius",
  "Belgique": "België",
  "Belgique, Benelux…": "België, Benelux…",
  "Besoin d'un devis après cette intervention ?": "Heeft u na deze interventie een offerte nodig?",
  "Bibliothèque de prix": "Prijzenbibliotheek",
  "Bien": "Goed",
  "Bienvenue": "Welkom",
  "Bienvenue ! Voici l'espace comptable.": "Welkom! Dit is de boekhoudomgeving.",
  "Bienvenue dans Devisto Studio.": "Welkom bij Devisto Studio.",
  "Bienvenue dans le Studio !": "Welkom in de Studio!",
  "Billit": "Billit",
  "Billit injoignable. Réessayez dans un instant.": "Billit is niet bereikbaar. Probeer het zo meteen opnieuw.",
  "Bleu nuit": "Nachtblauw",
  "Bloquant": "Blokkerend",
  "Bloquées dans le navigateur : autorisez-les dans ses réglages.": "Geblokkeerd in de browser: sta ze toe via de browserinstellingen.",
  "Boiler": "Boiler",
  "Boiler électrique": "Elektrische boiler",
  "Bon": "Goed",
  "Bon après-midi": "Goedemiddag",
  "Bonjour": "Goedendag",
  "Bonjour, je suis l'assistant Devisto. Comment puis-je vous aider ?": "Goedendag, ik ben de Devisto-assistent. Waarmee kan ik u helpen?",
  "Bonsoir": "Goedenavond",
  "Borne de recharge": "Laadpaal",
  "Brouillon": "Concept",
  "Brouillon de chantier": "Conceptwerf",
  "Brouillon enregistré. Reprenez-le quand vous voulez depuis le dossier ou la liste des devis.": "Concept opgeslagen. U kunt het op elk moment verder bewerken vanuit het dossier of de lijst met offertes.",
  "Brouillon généré — relisez et ajustez avant publication.": "Concept aangemaakt — lees het na en pas het aan vóór publicatie.",
  "Brouillon rédigé : relisez puis envoyez.": "Concept opgesteld: lees het na en verstuur het daarna.",
  "Brouillons": "Concepten",
  "Bureaux Parc Nord": "Bureaux Parc Nord",
  "Bâtiment": "Gebouw",
  "Bâtiment supprimé": "Gebouw verwijderd",
  "Bâtiment «": "Gebouw «",
  "Bâtiments": "Gebouwen",
  "Bâtiments & équipements": "Gebouwen & toestellen",
  "Bâtiments ·": "Gebouwen ·",
  "Bénéficiaire": "Begunstigde",
  "Bénéficiaire :": "Begunstigde:",
  "Béton et fondations": "Beton en funderingen",
  "C'est fait": "Dat is gebeurd",
  "C'est prêt, aller au Studio": "Het is klaar, ga naar de Studio",
  "CA HT": "Omzet excl. btw",
  "Caméra intelligente": "Slimme camera",
  "Candidatez aux missions B2B des entreprises": "Stel u kandidaat voor B2B-opdrachten van bedrijven",
  "Capacité (litres)": "Inhoud (liter)",
  "Capture terrain, photos, mesures": "Vastlegging ter plaatse, foto's, metingen",
  "Carreleur": "Tegelzetter",
  "Carte": "Kaart",
  "Catégorie": "Categorie",
  "Catégorie (fournitures, sous-traitance…)": "Categorie (benodigdheden, onderaanneming…)",
  "Causes probables": "Waarschijnlijke oorzaken",
  "Ce PDF ne contient pas de texte lisible (scan ou photo). Prenez-le en photo dans le dossier ": "Deze pdf bevat geen leesbare tekst (scan of foto). Maak er een foto van in het dossier ",
  "Ce bouton est ajouté automatiquement sous votre texte, avec votre logo en en-tête.": "Deze knop wordt automatisch onder uw tekst toegevoegd, met uw logo bovenaan.",
  "Ce client n'a pas d'adresse email": "Deze klant heeft geen e-mailadres",
  "Ce contrat n'est plus disponible. Contactez votre entrepreneur.": "Dit contract is niet meer beschikbaar. Neem contact op met uw aannemer.",
  "Ce devis a déjà reçu une réponse": "Op deze offerte is al gereageerd",
  "Ce devis a déjà été facturé : supprimez d'abord la facture": "Deze offerte is al gefactureerd: verwijder eerst de factuur",
  "Ce devis est clôturé : dupliquez-le pour le modifier": "Deze offerte is afgesloten: dupliceer ze om ze te wijzigen",
  "Ce devis n'a aucune ligne à enregistrer": "Deze offerte bevat geen regels om op te slaan",
  "Ce devis n'est pas en attente de réponse": "Deze offerte wacht niet op een antwoord",
  "Ce devis propose": "Deze offerte biedt",
  "Ce devis propose plusieurs options : attendez le choix du client (signature) avant de facturer un acompte": "Deze offerte biedt meerdere opties: wacht tot de klant zijn keuze heeft gemaakt (ondertekening) voordat u een voorschot factureert",
  "Ce document n'est plus disponible. Contactez votre entrepreneur.": "Dit document is niet meer beschikbaar. Neem contact op met uw aannemer.",
  "Ce domaine rejoint bientôt la plateforme": "Dit vakgebied wordt binnenkort aan het platform toegevoegd",
  "Ce lien d'export a expiré. Demandez un nouvel envoi à l'entreprise.": "Deze exportlink is verlopen. Vraag het bedrijf om een nieuwe verzending.",
  "Ce lien n'est plus valide.": "Deze link is niet meer geldig.",
  "Ce mois": "Deze maand",
  "Ce mois :": "Deze maand:",
  "Ce navigateur ne gère pas les notifications push.": "Deze browser ondersteunt geen pushmeldingen.",
  "Ce numéro de TVA n'est pas actif dans la base européenne.": "Dit btw-nummer is niet actief in de Europese databank.",
  "Ce passeport technique est introuvable.": "Dit technisch paspoort is niet gevonden.",
  "Ce que disent les artisans": "Wat de vakmensen zeggen",
  "Ce que dit la loi": "Wat de wet zegt",
  "Ce que vous avez constaté…": "Wat u hebt vastgesteld…",
  "Ce qui a été constaté et réalisé…": "Wat werd vastgesteld en uitgevoerd…",
  "Ce qui a été fait, pièces remplacées, valeurs de combustion…": "Wat werd gedaan, vervangen onderdelen, verbrandingswaarden…",
  "Ce rapport décrit les travaux réalisés. Les montants éventuels font l'objet d'un document séparé\n            (devis ou facture).": "Dit verslag beschrijft de uitgevoerde werken. Eventuele bedragen worden vermeld in een afzonderlijk document\n            (offerte of factuur).",
  "Ce rapport décrit les travaux réalisés. Les montants éventuels font l'objet d'un document séparé (devis ou facture).": "Dit verslag beschrijft de uitgevoerde werken. Eventuele bedragen worden vermeld in een afzonderlijk document (offerte of factuur).",
  "Ce rapport est déjà signé": "Dit verslag is al ondertekend",
  "Centralisez et gérez tout votre parc immobilier.": "Beheer uw volledige vastgoedpatrimonium op één plek.",
  "Centralisez immeubles, lots, équipements et interventions dans un seul espace, et créez des demandes liées à chaque unité en quelques clics.": "Beheer gebouwen, eenheden, toestellen en interventies op één plek en maak in enkele klikken aanvragen aan voor elke eenheid.",
  "Ces informations apparaissent en en-tête de vos devis PDF.": "Deze gegevens verschijnen bovenaan uw offertes in pdf-formaat.",
  "Ces informations sont obligatoires sur une facture.": "Deze gegevens zijn verplicht op een factuur.",
  "Ces tarifs sont déjà présents.": "Deze tarieven zijn al aanwezig.",
  "Cette facture est déjà réglée": "Deze factuur is al betaald",
  "Cette intervention est déjà liée à un dossier": "Deze interventie is al aan een dossier gekoppeld",
  "Cette page n'est plus disponible. Contactez votre entrepreneur.": "Deze pagina is niet meer beschikbaar. Neem contact op met uw aannemer.",
  "Cette page n'existe pas.": "Deze pagina bestaat niet.",
  "Champs fiscaux obligatoires : ": "Verplichte fiscale velden: ",
  "Changer le logo": "Logo wijzigen",
  "Changez d'année ou utilisez l'export pour une autre période.": "Kies een ander jaar of gebruik de export voor een andere periode.",
  "Chantier": "Werf",
  "Chantier :": "Werf:",
  "Chantier en cours": "Lopende werf",
  "Chantier terminé": "Afgeronde werf",
  "Chantiers": "Werven",
  "Chantiers en cours": "Lopende werven",
  "Chantiers sur ce bâtiment": "Werven in dit gebouw",
  "Chapiste": "Chapper",
  "Chaque 1er janvier, avril, juillet et octobre, Devisto envoie à votre comptable le ZIP du trimestre écoulé (ventes, achats, règlements, UBL) avec un lien valable 90 jours. Vous pouvez aussi lui donner": "Elke 1e januari, april, juli en oktober stuurt Devisto uw boekhouder een ZIP-bestand van het afgelopen kwartaal (verkopen, aankopen, betalingen, UBL) via een link die 90 dagen geldig is. U kunt hem ook toegang geven",
  "Chaque appareil garde son passeport et son historique": "Elk toestel behoudt zijn paspoort en historiek",
  "Chaque entretien enregistré sur un équipement apparaît ici.": "Elk onderhoud dat bij een toestel is geregistreerd, verschijnt hier.",
  "Chaque facture doit avoir au moins une ligne décrite": "Elke factuur moet minstens één regel met een omschrijving bevatten",
  "Chaque facture est générée au format Peppol BIS Billing 3.0 (UBL 2.1), obligatoire en Belgique entre assujettis. Téléchargez le XML pour l'envoyer via votre access point Peppol ou votre comptable.": "Elke factuur wordt aangemaakt in het formaat Peppol BIS Billing 3.0 (UBL 2.1), dat in België verplicht is tussen btw-plichtigen. Download de XML om die via uw Peppol-toegangspunt of uw boekhouder te verzenden.",
  "Chargement de votre activité…": "Uw activiteit wordt geladen…",
  "Chargement des dossiers…": "Dossiers worden geladen…",
  "Chargement impossible.": "Laden niet mogelijk.",
  "Chargement…": "Bezig met laden…",
  "Charpentier": "Timmerman",
  "Chaudière au sol": "Vloerketel",
  "Chaudière existante": "Bestaande ketel",
  "Chaudière murale": "Wandketel",
  "Chauffage": "Verwarming",
  "Chauffage + eau chaude": "Verwarming + warm water",
  "Chauffage Dupont SRL": "Chauffage Dupont SRL",
  "Chauffage seul": "Alleen verwarming",
  "Chauffage sol": "Vloerverwarming",
  "Chauffage électrique": "Elektrische verwarming",
  "Chauffagiste": "Verwarmingsinstallateur",
  "Chauffe-eau": "Waterverwarmer",
  "Checklist métier": "Checklist voor uw vak",
  "Checklist métier générée.": "Checklist voor uw vak aangemaakt.",
  "Cheminement": "Verloop",
  "Cheminée tubée": "Schoorsteen met voering",
  "Chiffrage en cours…": "Prijsberekening loopt…",
  "Chiffre d'affaires": "Omzet",
  "Chiffrer le devis": "Offerte berekenen",
  "Chiffres à prendre avec prudence : coût d'achat manquant sur": "Cijfers met de nodige voorzichtigheid interpreteren: aankoopkost ontbreekt voor",
  "Choisir la mesure…": "Kies de meting…",
  "Choisir le chantier…": "Kies de werf…",
  "Choisir le client…": "Kies de klant…",
  "Choisir le devis…": "Kies de offerte…",
  "Choisir un fichier": "Een bestand kiezen",
  "Choisissez au moins un journal": "Selecteer minstens één dagboek",
  "Choisissez au moins un journal.": "Selecteer minstens één dagboek.",
  "Choisissez l'option qui vous convient avant de signer.": "Kies de optie die u wenst voordat u ondertekent.",
  "Choisissez l'option retenue avant de signer": "Kies de gewenste optie voordat u ondertekent",
  "Choisissez l'option retenue par le client.": "Kies de optie die de klant heeft gekozen.",
  "Choisissez la date de la visite": "Kies de datum van het plaatsbezoek",
  "Choisissez la date de la visite.": "Kies de datum van het plaatsbezoek.",
  "Choisissez le chantier et indiquez le matériel.": "Kies de werf en vermeld het materiaal.",
  "Choisissez le dossier concerné (chantier en cours ou devis enregistré) : le matériel rejoint sa liste et apparaît ici.": "Kies het betrokken dossier (lopende werf of opgeslagen offerte): het materiaal wordt aan de lijst toegevoegd en verschijnt hier.",
  "Choisissez un client ou indiquez son nom.": "Kies een klant of geef diens naam op.",
  "Choisissez un client ou tapez son nom. Le dossier chantier est créé automatiquement.": "Kies een klant of typ diens naam. Het werfdossier wordt automatisch aangemaakt.",
  "Choisissez un client.": "Kies een klant.",
  "Choisissez un devis.": "Kies een offerte.",
  "Choisissez une mesure et indiquez sa valeur réelle.": "Kies een meting en geef de werkelijke waarde op.",
  "Choisissez une note.": "Kies een notitie.",
  "Choisissez une photo JPEG ou PNG.": "Kies een foto in JPEG- of PNG-formaat.",
  "Choisissez votre mot de passe pour accéder aux dossiers de chantier de la société.": "Kies uw wachtwoord om toegang te krijgen tot de werfdossiers van het bedrijf.",
  "Choisissez votre mot de passe pour consulter les factures de vente (PDF + UBL), les achats et l'export comptable de la société.": "Kies uw wachtwoord om de verkoopfacturen (PDF + UBL), de aankopen en de boekhoudexport van het bedrijf te raadplegen.",
  "Choisissez « Sur l'écran d'accueil »": "Kies « Op het beginscherm »",
  "Chèque": "Cheque",
  "Clair": "Licht",
  "Classe PEB": "EPC-label",
  "Classe PEB inconnue": "EPC-label onbekend",
  "Classique": "Klassiek",
  "Classique (avec empattements)": "Klassiek (met schreven)",
  "Clauses": "Bepalingen",
  "Clauses du contrat": "Contractbepalingen",
  "Client": "Klant",
  "Client (optionnel)": "Klant (optioneel)",
  "Client :": "Klant:",
  "Client détecté dans la phrase": "Klant herkend in de zin",
  "Client enregistré.": "Klant opgeslagen.",
  "Client et chantier": "Klant en werf",
  "Client introuvable": "Klant niet gevonden",
  "Client particulier": "Particuliere klant",
  "Client professionnel": "Professionele klant",
  "Client professionnel assujetti : l'autoliquidation peut s'appliquer aux travaux immobiliers. Confirmez le traitement (lignes en « AC ») ou facturez avec TVA.": "Btw-plichtige professionele klant: btw verlegd kan van toepassing zijn op werken in onroerende staat. Bevestig de verwerking (regels met « AC ») of factureer met btw.",
  "Client, dossier, devis, facture…": "Klant, dossier, offerte, factuur…",
  "Client, lignes, envoi": "Klant, regels, verzending",
  "Clients": "Klanten",
  "Clients accompagnés": "Begeleide klanten",
  "Climatisation": "Airconditioning",
  "Climatisation / PAC": "Airconditioning / warmtepomp",
  "Clé API Billit": "API-sleutel voor Billit",
  "Clé API Mollie (test_… ou live_…)": "API-sleutel voor Mollie (test_… of live_…)",
  "Clé API Odoo": "API-sleutel voor Odoo",
  "Clé API Recommand": "API-sleutel voor Recommand",
  "Clé API à générer dans Odoo → Préférences → Sécurité du compte → Nouvelle clé API. La facture est créée en brouillon, vous la validez dans Odoo.": "Maak een API-sleutel aan in Odoo → Voorkeuren → Accountbeveiliging → Nieuwe API-sleutel. De factuur wordt als concept aangemaakt; u keurt ze goed in Odoo.",
  "Clé active": "Actieve sleutel",
  "Clé d'accès Web Service Yuki + identifiant d'administration (import automatique des ventes activé).": "Toegangssleutel voor Yuki Web Service + beheerders-ID (automatische import van verkopen ingeschakeld).",
  "Clé d'accès Yuki": "Toegangssleutel voor Yuki",
  "Clé d'accès Yuki refusée. Vérifiez votre clé dans Mon entreprise.": "Toegangssleutel voor Yuki geweigerd. Controleer uw sleutel in Mijn bedrijf.",
  "Clé enregistrée — connexion Recommand vérifiée.": "Sleutel opgeslagen — verbinding met Recommand gecontroleerd.",
  "Clé enregistrée.": "Sleutel opgeslagen.",
  "Clé refusée par Mollie.": "Sleutel geweigerd door Mollie.",
  "Clé retirée.": "Sleutel verwijderd.",
  "Clôtures et portails": "Afsluitingen en poorten",
  "Clôturés": "Afgesloten",
  "Code postal": "Postcode",
  "Coller une question reçue par e-mail / SMS": "Een vraag ontvangen via e-mail / SMS plakken",
  "Collez ici le message du client…": "Plak hier het bericht van de klant…",
  "Collez votre clé API et votre PartyID Billit (MyBillit → Intégrations) : vos devis acceptés partiront directement en facture, sans copier-coller.\n            Laissez l'URL sandbox pour tester, puis passez à l'URL de production.": "Plak uw API-sleutel en uw Billit PartyID (MyBillit → Integraties): uw aanvaarde offertes worden rechtstreeks omgezet in facturen, zonder kopiëren en plakken.\n            Gebruik de sandbox-URL om te testen en schakel daarna over naar de productie-URL.",
  "Collez votre clé API et votre PartyID Billit (MyBillit → Intégrations) : vos devis acceptés partiront directement en facture, sans copier-coller. Laissez l'URL sandbox pour tester, puis passez à l'URL de production.": "Plak uw API-sleutel en uw Billit PartyID (MyBillit → Integraties): uw aanvaarde offertes worden rechtstreeks omgezet in facturen, zonder kopiëren en plakken. Gebruik de sandbox-URL om te testen en schakel daarna over naar de productie-URL.",
  "Combien ça coûte ?": "Hoeveel kost het?",
  "Combustible": "Brandstof",
  "Commandes spéciales": "Speciale bestellingen",
  "Commencer": "Beginnen",
  "Commencer gratuitement": "Gratis beginnen",
  "Comment Devisto vous met en règle": "Hoe Devisto ervoor zorgt dat u aan de regels voldoet",
  "Comment ajouter un immeuble ?": "Hoe voegt u een gebouw toe?",
  "Comment choisir un technicien ?": "Hoe kiest u een technicus?",
  "Comment créer une demande pour un lot ?": "Hoe maakt u een aanvraag voor een kavel aan?",
  "Comment devenir partenaire pro ?": "Hoe wordt u professionele partner?",
  "Comment décrire mon projet ?": "Hoe beschrijf ik mijn project?",
  "Comment envoyer un devis ?": "Hoe verstuurt u een offerte?",
  "Comment faire": "Hoe doet u dat",
  "Comment fonctionne le Devisto Score ?": "Hoe werkt de Devisto Score?",
  "Comment gérer mes demandes ?": "Hoe beheer ik mijn aanvragen?",
  "Comment publier une mission ?": "Hoe publiceert u een opdracht?",
  "Comment s'est passée notre intervention ?": "Hoe is onze interventie verlopen?",
  "Comment se passe le paiement ?": "Hoe verloopt de betaling?",
  "Comment suivre ma demande ?": "Hoe volg ik mijn aanvraag op?",
  "Comment suivre une intervention ?": "Hoe volgt u een interventie op?",
  "Comment ça fonctionne ?": "Hoe werkt het?",
  "Comment ça marche": "Hoe werkt het",
  "Commune": "Gemeente",
  "Communication": "Mededeling",
  "Communication :": "Mededeling:",
  "Compact": "Compact",
  "Comparez les profils, échangez avec les professionnels et choisissez la meilleure solution pour votre projet.": "Vergelijk de profielen, overleg met de vakmensen en kies de beste oplossing voor uw project.",
  "Compléter": "Aanvullen",
  "Compléter ce devis": "Deze offerte aanvullen",
  "Compléter mes coûts d'achat et durées": "Mijn aankoopkosten en tijdsduur aanvullen",
  "Complétez les informations fiscales du client avant d'envoyer ce document.": "Vul de fiscale gegevens van de klant aan voordat u dit document verstuurt.",
  "Complétez seulement ce qui est utile — l'assistant utilise ces informations pour le devis.": "Vul alleen in wat relevant is — de assistent gebruikt deze informatie voor de offerte.",
  "Complétez votre profil pour générer le pied de page.": "Vul uw profiel aan om de voettekst te genereren.",
  "Complétion impossible.": "Aanvullen niet mogelijk.",
  "Comptabilité": "Boekhouding",
  "Comptable": "Boekhouder",
  "Comptable :": "Boekhouder:",
  "Comptable enregistré.": "Boekhouder opgeslagen.",
  "Compte actif ·": "Actief account ·",
  "Compte de démonstration": "Demoaccount",
  "Condensation": "Condensatie",
  "Conditions": "Voorwaarden",
  "Conditions Générales de Vente": "Algemene verkoopvoorwaarden",
  "Conditions d'application (vide = toujours)": "Toepassingsvoorwaarden (leeg = altijd)",
  "Conditions générales de vente": "Algemene verkoopvoorwaarden",
  "Conditions générales enregistrées.": "Algemene verkoopvoorwaarden opgeslagen.",
  "Conditions par défaut de vos devis": "Standaardvoorwaarden voor uw offertes",
  "Confiance": "Vertrouwen",
  "Conforme": "Conform",
  "Connecter mon site web": "Mijn website koppelen",
  "Connexion": "Aanmelden",
  "Consolidé ≈": "Geconsolideerd ≈",
  "Constats / pièces": "Vaststellingen / onderdelen",
  "Consulté": "Geraadpleegd",
  "Consultée par le client le": "Door de klant geraadpleegd op",
  "Contact": "Contact",
  "Contenu": "Inhoud",
  "Contenu du pied de page": "Inhoud van de voettekst",
  "Contrat": "Contract",
  "Contrat d'entretien": "Onderhoudscontract",
  "Contrat enregistré.": "Contract opgeslagen.",
  "Contrat envoyé au client pour signature.": "Contract ter ondertekening naar de klant verstuurd.",
  "Contrat introuvable.": "Contract niet gevonden.",
  "Contrat préparé avec": "Contract opgesteld met",
  "Contrat refusé": "Contract geweigerd",
  "Contrat rédigé par l'IA :": "Contract opgesteld door AI:",
  "Contrat signé": "Contract ondertekend",
  "Contrat signé. Merci !": "Contract ondertekend. Bedankt!",
  "Contrat supprimé.": "Contract verwijderd.",
  "Contrat terminé.": "Contract beëindigd.",
  "Contrats d'entretien": "Onderhoudscontracten",
  "Contrats, rapports d'intervention, factures et garanties liés à cet immeuble.": "Contracten, interventieverslagen, facturen en garanties voor dit gebouw.",
  "Contrôle réglementaire": "Wettelijke controle",
  "Conversations": "Gesprekken",
  "Convertir en facture": "Omzetten naar factuur",
  "Copie impossible : sélectionnez le lien": "Kopiëren niet mogelijk: selecteer de link",
  "Copie impossible — sélectionnez le texte manuellement.": "Kopiëren niet mogelijk — selecteer de tekst handmatig.",
  "Copier": "Kopiëren",
  "Copier la liste": "De lijst kopiëren",
  "Copier le devis": "De offerte kopiëren",
  "Copier le lien": "De link kopiëren",
  "Copier le lien client": "De klantenlink kopiëren",
  "Copier le lien public": "De openbare link kopiëren",
  "Copier tout et ouvrir mon app bancaire": "Alles kopiëren en mijn bankapp openen",
  "Copiez votre lien ci-dessus et placez-le sur votre site, vos réseaux ou votre fiche Google.": "Kopieer uw link hierboven en plaats die op uw website, uw sociale media of uw Google-bedrijfsprofiel.",
  "Copié": "Gekopieerd",
  "Copié.": "Gekopieerd.",
  "Courtois": "Beleefd",
  "Couvreur / toiture": "Dakwerker / dakwerken",
  "Coût": "Kostprijs",
  "Coût (€)": "Kostprijs (€)",
  "Coût d'achat": "Aankoopkost",
  "Coût d'achat €": "Aankoopkost €",
  "Coût fournisseur (facultatif)": "Leverancierskost (optioneel)",
  "Coût horaire de mon ouvrier (€/h)": "Uurkost van mijn arbeider (€/u)",
  "Coûts": "Kosten",
  "Création de l'intervention impossible.": "Interventie aanmaken niet mogelijk.",
  "Création du devis impossible.": "Offerte aanmaken niet mogelijk.",
  "Création du dossier impossible.": "Dossier aanmaken niet mogelijk.",
  "Création impossible": "Aanmaken niet mogelijk",
  "Création impossible.": "Aanmaken niet mogelijk.",
  "Création…": "Aanmaken…",
  "Créer": "Aanmaken",
  "Créer depuis le modèle": "Aanmaken op basis van het sjabloon",
  "Créer en brouillon": "Als concept aanmaken",
  "Créer et chiffrer avec l'IA": "Aanmaken en met AI begroten",
  "Créer et envoyer à signer": "Aanmaken en ter ondertekening versturen",
  "Créer l'intervention": "De interventie aanmaken",
  "Créer la facture": "De factuur aanmaken",
  "Créer le brouillon": "Het concept aanmaken",
  "Créer le bâtiment": "Het gebouw aanmaken",
  "Créer le compte démo": "Het demoaccount aanmaken",
  "Créer le contrat (brouillon)": "Het contract aanmaken (concept)",
  "Créer le devis": "De offerte aanmaken",
  "Créer le dossier": "Het dossier aanmaken",
  "Créer le dossier depuis cette intervention": "Het dossier aanmaken op basis van deze interventie",
  "Créer mon compte artisan": "Mijn account als vakman aanmaken",
  "Créer un compte": "Een account aanmaken",
  "Créer un compte Mollie gratuit et copier la clé API": "Een gratis Mollie-account aanmaken en de API-sleutel kopiëren",
  "Créer une facture": "Een factuur aanmaken",
  "Créer une facture vierge": "Een lege factuur aanmaken",
  "Créer une note de crédit": "Een creditnota aanmaken",
  "Créer une note de crédit pour annuler cette facture ?": "Een creditnota aanmaken om deze factuur te annuleren?",
  "Créez l'intervention : client, adresse, travaux et prix sont repris automatiquement du devis.": "Maak de interventie aan: klant, adres, werken en prijs worden automatisch overgenomen uit de offerte.",
  "Créez la fiche du bâtiment, puis ajoutez ses équipements. Vous garderez l'historique complet et vous pourrez replacer les entretiens automatiquement.": "Maak de gebouwfiche aan en voeg daarna de toestellen toe. U bewaart de volledige historiek en kunt onderhoudsbeurten automatisch opnieuw inplannen.",
  "Créez votre compte": "Maak uw account aan",
  "Créez votre premier dossier chantier : photos, notes et mesures sur place.": "Maak uw eerste werfdossier aan: foto's, notities en metingen ter plaatse.",
  "Créez-en une depuis un devis signé ou pour un client.": "Maak er een aan op basis van een ondertekende offerte of voor een klant.",
  "Créez-en une directement sur place, le rapport se signe au doigt.": "Maak er ter plaatse een aan; het verslag kan met een vinger worden ondertekend.",
  "Cuisiniste / salle de bains": "Keukenbouwer / badkamerinrichter",
  "Câblage": "Bekabeling",
  "Date": "Datum",
  "Date :": "Datum:",
  "Date d'entretien inconnue": "Onderhoudsdatum onbekend",
  "Date d'installation": "Installatiedatum",
  "Date de visite": "Bezoekdatum",
  "Date inconnue": "Datum onbekend",
  "Date invalide": "Ongeldige datum",
  "De la demande initiale jusqu'à la fin de l'intervention, Devisto centralise les informations essentielles pour faciliter la communication entre clients, professionnels, gestionnaires immobiliers et syndics.": "Van de eerste aanvraag tot het einde van de interventie brengt Devisto alle essentiële informatie samen om de communicatie tussen klanten, vakmensen, vastgoedbeheerders en syndici te vergemakkelijken.",
  "Demande d'avis": "Verzoek om een beoordeling",
  "Demande d'avis envoyée au client le": "Verzoek om een beoordeling naar de klant verstuurd op",
  "Demande envoyée": "Aanvraag verstuurd",
  "Demander un avis": "Een beoordeling vragen",
  "Demander un avis après chaque intervention": "Na elke interventie om een beoordeling vragen",
  "Demander un devis gratuit": "Een gratis offerte aanvragen",
  "Demandes actives": "Actieve aanvragen",
  "Demandes liées à un lot ou un équipement précis": "Aanvragen voor een specifieke kavel of een specifiek toestel",
  "Demandes qualifiées": "Gekwalificeerde aanvragen",
  "Demandes reçues": "Ontvangen aanvragen",
  "Demandes web": "Aanvragen via de website",
  "Depuis 2026, chaque facture entre professionnels en Belgique doit passer par le réseau Peppol. Devisto l'envoie pour vous, au bon format, directement depuis votre devis signé.": "Sinds 2026 moet elke factuur tussen ondernemingen in België via het Peppol-netwerk worden verstuurd. Devisto verstuurt ze voor u in het juiste formaat, rechtstreeks vanuit uw ondertekende offerte.",
  "Depuis la liste des factures, le bouton « ? » permet de poser une question sur une facture précise. L'entreprise est notifiée et vous répond par e-mail.": "In de factuurlijst kunt u via de knop «? » een vraag stellen over een specifieke factuur. Het bedrijf krijgt een melding en antwoordt u per e-mail.",
  "Depuis le 1er janvier": "Sinds 1 januari",
  "Dernier entretien": "Laatste onderhoud",
  "Dernier rappel avant mise en demeure": "Laatste herinnering vóór ingebrekestelling",
  "Dernière remise à neuf réussie.": "Laatste renovatie geslaagd.",
  "Des demandes claires et précises pour des devis pertinents.": "Duidelijke en nauwkeurige aanvragen voor passende offertes.",
  "Des prix clairs, des devis détaillés et un suivi en temps réel.": "Duidelijke prijzen, gedetailleerde offertes en opvolging in realtime.",
  "Des professionnels vérifiés et évalués par la communauté.": "Geverifieerde vakmensen, beoordeeld door de community.",
  "Description": "Beschrijving",
  "Description standard reprise dans le devis": "Standaardbeschrijving overgenomen in de offerte",
  "Description à compléter": "Beschrijving aan te vullen",
  "Descriptions réécrites pour le client — pensez à enregistrer.": "Beschrijvingen herschreven voor de klant — vergeet niet op te slaan.",
  "Destinataires": "Ontvangers",
  "Deux minutes, et votre premier devis est prêt.": "Twee minuten, en uw eerste offerte is klaar.",
  "Deux minutes, sans carte bancaire. Votre numéro de TVA est vérifié automatiquement.": "Twee minuten, zonder kredietkaart. Uw btw-nummer wordt automatisch gecontroleerd.",
  "Deux minutes, une seule fois.": "Twee minuten, eenmalig.",
  "Devenir partenaire pro": "Professionele partner worden",
  "Devis": "Offertes",
  "Devis / chantiers": "Offertes / werven",
  "Devis :": "Offerte:",
  "Devis PDF, envoi et signature en ligne": "Offerte als PDF, online verzenden en ondertekenen",
  "Devis accepté": "Offerte aanvaard",
  "Devis accepté. L'entreprise est prévenue.": "Offerte aanvaard. Het bedrijf is op de hoogte gebracht.",
  "Devis brouillon créé avec": "Conceptofferte aangemaakt met",
  "Devis copié — collez-le dans votre logiciel.": "Offerte gekopieerd — plak ze in uw software.",
  "Devis créé": "Offerte aangemaakt",
  "Devis depuis un PDF ou une liste de matériel": "Offerte op basis van een PDF of een materiaallijst",
  "Devis dicté, signature en ligne, facture Peppol : tout le travail du bâtiment, du chantier à la facture.": "Offerte dicteren, online ondertekenen, factureren via Peppol: alles voor de bouw, van werf tot factuur.",
  "Devis du dossier": "Offerte van het dossier",
  "Devis déjà créé pour cette demande.": "Voor deze aanvraag is al een offerte aangemaakt.",
  "Devis en cours": "Offerte in behandeling",
  "Devis en quelques questions, conseils métier, textes clients : il garde le fil de chaque conversation.": "Offertes op basis van enkele vragen, vakadvies, teksten voor klanten: hij houdt de draad van elk gesprek vast.",
  "Devis enregistré.": "Offerte opgeslagen.",
  "Devis envoyé": "Offerte verzonden",
  "Devis envoyé au client.": "Offerte naar de klant verzonden.",
  "Devis envoyés": "Offertes verzonden",
  "Devis intelligent — à vérifier": "Slimme offerte — te controleren",
  "Devis introuvable": "Offerte niet gevonden",
  "Devis introuvable.": "Offerte niet gevonden.",
  "Devis mis à jour — pensez à enregistrer.": "Offerte bijgewerkt — vergeet niet op te slaan.",
  "Devis préparé avec Devisto ·": "Offerte opgesteld met Devisto ·",
  "Devis préparé par l'assistant.": "Offerte opgesteld door de assistent.",
  "Devis prêt en 90 secondes": "Offerte klaar in 90 seconden",
  "Devis rapides & transparents": "Snelle & transparante offertes",
  "Devis refusé": "Offerte geweigerd",
  "Devis refusés": "Geweigerde offertes",
  "Devis sans réponse": "Offertes zonder antwoord",
  "Devis signé sur place. Vous pouvez facturer.": "Offerte ter plaatse ondertekend. U kunt factureren.",
  "Devis signé — prochaine étape": "Offerte ondertekend — volgende stap",
  "Devis signé → facture en un clic": "Offerte ondertekend → factuur met één klik",
  "Devis signé, facture payée, résumé du soir à 18h… même app fermée.": "Offerte ondertekend, factuur betaald, avondoverzicht om 18h… zelfs als de app gesloten is.",
  "Devis signés": "Ondertekende offertes",
  "Devis à créer": "Op te stellen offertes",
  "Devis à préparer": "Voor te bereiden offertes",
  "Devis à relancer": "Offertes waarvoor een herinnering nodig is",
  "Devis à signer": "Te ondertekenen offertes",
  "Devise": "Valuta",
  "Devisto": "Devisto",
  "Devisto Building ID": "Devisto Building ID",
  "Devisto Property": "Devisto Property",
  "Devisto Score": "Devisto Score",
  "Devisto Studio :": "Devisto Studio:",
  "Devisto Studio est à 25 € HTVA par mois, Peppol inclus, sans limite de factures. Essai gratuit de 30 jours.": "Devisto Studio kost 25 € excl. btw per maand, inclusief Peppol en zonder limiet op het aantal facturen. Probeer het 30 dagen gratis.",
  "Devisto a été pensé pour répondre aux difficultés rencontrées quotidiennement dans le secteur : demandes mal orientées, manque de visibilité, échanges dispersés et suivi insuffisant.": "Devisto is ontwikkeld om de dagelijkse uitdagingen in de sector aan te pakken: aanvragen die niet bij de juiste vakman terechtkomen, gebrek aan overzicht, versnipperde communicatie en onvoldoende opvolging.",
  "Devisto commence avec JMX Énergie et s'ouvre progressivement à des professionnels vérifiés dans toutes les techniques spéciales du bâtiment : chauffage, plomberie, ventilation, climatisation, pompes à chaleur et traitement de l'eau.": "Devisto start met JMX Énergie en breidt geleidelijk uit naar geverifieerde vakmensen in alle speciale technieken van het gebouw: verwarming, sanitair, ventilatie, airconditioning, warmtepompen en waterbehandeling.",
  "Devisto détecte l'absence du destinataire, vous prévient et bascule automatiquement sur l'envoi par email, sans rien perdre.": "Devisto merkt wanneer de ontvanger niet beschikbaar is, verwittigt u en schakelt automatisch over op verzending per e-mail, zonder dat er iets verloren gaat.",
  "Devisto identifie les professionnels adaptés": "Devisto vindt de juiste vakmensen",
  "Devisto met en relation particuliers, professionnels, syndics et gestionnaires avec des spécialistes qualifiés des techniques du bâtiment, partout en Belgique.": "Devisto brengt particulieren, vakmensen, syndici en beheerders in heel België in contact met gekwalificeerde specialisten in gebouwtechnieken.",
  "Devisto réunit progressivement des professionnels dans toutes les techniques spéciales du bâtiment. Publiez votre demande : nous la transmettons au professionnel qualifié adapté.": "Devisto brengt geleidelijk vakmensen uit alle speciale technieken van het gebouw samen. Plaats uw aanvraag: wij bezorgen ze aan de geschikte gekwalificeerde vakman.",
  "Devisto vous accompagne à chaque étape de votre projet.": "Devisto begeleidt u bij elke stap van uw project.",
  "Devisto vérifie votre document sous 24 h ouvrées. Vous pouvez déjà créer et envoyer vos factures par email ; l'envoi Peppol s'activera à la validation.": "Devisto controleert uw document binnen 24 werkuren. U kunt uw facturen nu al opstellen en per e-mail versturen; verzending via Peppol wordt na goedkeuring geactiveerd.",
  "Devisto établit vos factures. Transmettez-les à votre comptable ou à votre ERP en un clic.": "Devisto stelt uw facturen op. Bezorg ze met één klik aan uw boekhouder of stuur ze naar uw ERP.",
  "Devisto — la plateforme des techniques spéciales du bâtiment": "Devisto — het platform voor speciale technieken van het gebouw",
  "Diagnostic IA": "AI-diagnose",
  "Diagnostic affiné avec vos réponses.": "Diagnose verfijnd op basis van uw antwoorden.",
  "Diagnostic impossible.": "Diagnose niet mogelijk.",
  "Diagnostic établi : causes, vérifications et réparation proposées.": "Diagnose gesteld: mogelijke oorzaken, controles en herstelling voorgesteld.",
  "Diamètre chauffage": "Diameter verwarmingsleiding",
  "Diamètre gaz": "Diameter gasleiding",
  "Diamètre tubage (mm)": "Diameter rookgasafvoerbuis (mm)",
  "Dicter": "Dicteren",
  "Dicter mes constats": "Mijn vaststellingen dicteren",
  "Dicter un devis": "Een offerte dicteren",
  "Dictez le chantier ou envoyez la photo de la plaque : l'assistant pose 2-3 questions, suggère la suite et prépare le devis avec vos prix.": "Dicteer de werfgegevens of stuur een foto van het typeplaatje: de assistent stelt 2-3 vragen, stelt de volgende stappen voor en bereidt de offerte voor met uw prijzen.",
  "Dictez le chantier à l'assistant ou cliquez sur « Modifier » pour ajouter des prestations.": "Dicteer de werfgegevens aan de assistent of klik op « Bewerken » om prestaties toe te voegen.",
  "Dictez le chantier, Devisto chiffre les lignes. Le client signe en ligne.": "Dicteer de werkzaamheden op de werf, Devisto berekent de prijs per post. De klant ondertekent online.",
  "Dictez ou tapez ce que vous avez fait, en vrac, et laissez l'IA lire vos photos : elle remplit les travaux, le matériel, les mesures, le constat et les recommandations, puis vous suggère ce qu'il manque.": "Dicteer of typ wat u hebt gedaan, zonder het te ordenen, en laat AI uw foto's bekijken: die vult de werkzaamheden, het materiaal, de afmetingen, de vaststellingen en de aanbevelingen in en geeft daarna aan wat nog ontbreekt.",
  "Dictez un chantier pour obtenir un devis, envoyez la photo d'une plaque signalétique, posez une question technique ou demandez un texte pour un client. Je garde le fil de chaque conversation.": "Dicteer de werkzaamheden op een werf om een offerte te krijgen, stuur een foto van een typeplaatje, stel een technische vraag of vraag een tekst voor een klant. Ik onthoud de context van elk gesprek.",
  "Dictez, ne tapez plus": "Dicteer, typ niet meer",
  "Dictée analysée par l'assistant.": "Dictaat geanalyseerd door de assistent.",
  "Dictées analysées": "Geanalyseerde dictaten",
  "Difficile": "Moeilijk",
  "Différentiels": "Differentieelschakelaars",
  "Dim": "Zo",
  "Dimensions disponibles": "Beschikbare afmetingen",
  "Dimensions et surface au sol": "Afmetingen en vloeroppervlakte",
  "Directement sur": "Rechtstreeks op",
  "Distance": "Afstand",
  "Distance depuis le tableau (m)": "Afstand vanaf de verdeelkast (m)",
  "Dites ce que vous voulez changer.": "Vertel wat u wilt veranderen.",
  "Dites ou écrivez ce que vous voulez changer": "Vertel of schrijf wat u wilt veranderen",
  "Dites-lui quoi changer": "Vertel de assistent wat er moet veranderen",
  "Dites-nous ce que nous pouvons améliorer (lu uniquement par l'entreprise)": "Vertel ons wat we kunnen verbeteren (alleen leesbaar voor het bedrijf)",
  "Document": "Document",
  "Document ajouté.": "Document toegevoegd.",
  "Document déposé.": "Document geüpload.",
  "Document joint — remplacer": "Document bijgevoegd — vervangen",
  "Document lu par l'IA : vérifiez les montants.": "Document gelezen door AI: controleer de bedragen.",
  "Document supprimé.": "Document verwijderd.",
  "Document émis avec": "Document opgesteld met",
  "Documents": "Documenten",
  "Documents de l'équipement": "Documenten van het toestel",
  "Dois-je ouvrir un compte Peppol moi-même ?": "Moet ik zelf een Peppol-account aanmaken?",
  "Domotique": "Domotica",
  "Domotique, alarme et caméras": "Domotica, alarm en camera's",
  "Donner l'accès": "Toegang geven",
  "Donner un accès": "Toegang verlenen",
  "Donnez un nom au modèle": "Geef het sjabloon een naam",
  "Donnez un nom au modèle.": "Geef het sjabloon een naam.",
  "Données du virement copiées — collez-les dans votre app bancaire": "Overschrijvingsgegevens gekopieerd — plak ze in uw bankapp",
  "Dossier": "Dossier",
  "Dossier enregistré sur l'appareil — il sera envoyé au retour du réseau.": "Dossier opgeslagen op het toestel — het wordt verzonden zodra de netwerkverbinding is hersteld.",
  "Dossier introuvable": "Dossier niet gevonden",
  "Dossier introuvable.": "Dossier niet gevonden.",
  "Dossier lié :": "Gekoppeld dossier:",
  "Dossier refusé, l'artisan est prévenu.": "Dossier geweigerd, de vakman is op de hoogte gebracht.",
  "Dossier soumis. La création de factures est débloquée.": "Dossier ingediend. U kunt nu facturen aanmaken.",
  "Dossiers": "Dossiers",
  "Dossiers d'activation": "Activatiedossiers",
  "Dossiers de chantier illimités": "Onbeperkt aantal werfdossiers",
  "Dossiers ouverts": "Open dossiers",
  "Dossiers, devis, interventions, planning. Pas la facturation.": "Dossiers, offertes, interventies, planning. Geen facturatie.",
  "Du": "Van",
  "Du chantier": "Van de werf",
  "Du dossier au devis signé": "Van dossier tot ondertekende offerte",
  "Duplication impossible.": "Dupliceren niet mogelijk.",
  "Dupliquer": "Dupliceren",
  "Dupliquer ce devis": "Deze offerte dupliceren",
  "Dupliquer en nouveau brouillon": "Dupliceren als nieuw concept",
  "Dupliquer le devis": "De offerte dupliceren",
  "Durée": "Duur",
  "Durée (années)": "Duur (jaren)",
  "Durée (min)": "Duur (min)",
  "Durée estimée (minutes)": "Geschatte duur (minuten)",
  "Dès qu'un équipement approche de sa date d'entretien, il apparaît ici — et votre client reçoit automatiquement un rappel 30 jours avant.": "Zodra de onderhoudsdatum van een toestel nadert, verschijnt het hier — en krijgt uw klant automatisch 30 dagen vooraf een herinnering.",
  "Dès que le rapport est signé, le client reçoit un e-mail pour noter l'intervention (1 à 5 étoiles). À partir de 4 étoiles, il est invité à laisser un avis Google via le lien ci-dessous ; en dessous, son commentaire vous est transmis en privé.": "Zodra het verslag ondertekend is, krijgt de klant een e-mail om de interventie te beoordelen (1 tot 5 sterren). Bij 4 sterren of meer wordt hij uitgenodigd om via onderstaande link een Google-review te plaatsen; bij minder dan 4 sterren wordt zijn commentaar privé aan u doorgestuurd.",
  "Début": "Begin",
  "Déc": "Dec",
  "Décembre": "December",
  "Décevant": "Teleurstellend",
  "Déconnexion": "Afmelden",
  "Découvrir Devisto": "Ontdek Devisto",
  "Découvrir Devisto Property": "Ontdek Devisto Property",
  "Décrire mon projet": "Mijn project beschrijven",
  "Décrivez l'entretien en une phrase : l'IA rédige le contrat, vous l'envoyez à signer.": "Beschrijf het onderhoud in één zin: de AI stelt het contract op, u stuurt het ter ondertekening.",
  "Décrivez l'entretien, l'IA rédige le contrat": "Beschrijf het onderhoud, de AI stelt het contract op",
  "Décrivez l'intervention en quelques mots (15 caractères minimum) ou ajoutez des photos": "Beschrijf de interventie in enkele woorden (minstens 15 tekens) of voeg foto's toe",
  "Décrivez l'intervention en quelques mots ou ajoutez des photos.": "Beschrijf de interventie in enkele woorden of voeg foto's toe.",
  "Décrivez l'équipement et l'entretien souhaité.": "Beschrijf het toestel en het gewenste onderhoud.",
  "Décrivez la panne (ou dictez-la, ou laissez l'IA lire vos photos) : l'assistant classe les causes probables, vous guide dans les vérifications, pose les bonnes questions et prépare la réparation chiffrée avec vos tarifs.": "Beschrijf de storing (of dicteer ze, of laat de AI uw foto's analyseren): de assistent rangschikt de mogelijke oorzaken, begeleidt u bij de controles, stelt de juiste vragen en maakt met uw tarieven een kostenraming voor de herstelling.",
  "Décrivez le chantier en une phrase complète": "Beschrijf de werf in een volledige zin",
  "Décrivez le chantier en une phrase complète.": "Beschrijf de werf in een volledige zin.",
  "Décrivez le chantier à voix haute : l'assistant transcrit, structure les informations et signale ce qui manque.": "Beschrijf de werf hardop: de assistent schrijft uw beschrijving uit, structureert de informatie en geeft aan wat nog ontbreekt.",
  "Décrivez le chantier à voix haute, l'assistant chiffre le devis avec vos prix.": "Beschrijf de werf hardop, de assistent berekent de offerte op basis van uw prijzen.",
  "Décrivez les travaux en une phrase complète.": "Beschrijf de werken in een volledige zin.",
  "Décrivez les travaux en une phrase, à l'écrit ou à la voix : l'assistant propose les postes, quantités et prix depuis votre bibliothèque": "Beschrijf de werken in één zin, getypt of ingesproken: de assistent stelt posten, hoeveelheden en prijzen uit uw bibliotheek voor",
  "Décrivez vos travaux : quoi, où, surface, âge du logement, délai souhaité… *": "Beschrijf uw werken: wat, waar, oppervlakte, ouderdom van de woning, gewenste termijn… *",
  "Décrivez vos travaux, ajoutez des photos : vous recevez un devis clair et rapide.": "Beschrijf uw werken en voeg foto's toe: u ontvangt snel een duidelijke offerte.",
  "Décrivez votre chantier": "Beschrijf uw werf",
  "Décrivez votre chantier ci-dessus : l'IA prépare le premier devis en quelques secondes.": "Beschrijf hierboven uw werf: de AI stelt in enkele seconden de eerste offerte op.",
  "Décrivez votre projet": "Beschrijf uw project",
  "Déjà payé": "Al betaald",
  "Déjà transféré dans": "Al overgezet naar",
  "Déjà un compte ?": "Hebt u al een account?",
  "Déjà à jour.": "Al bijgewerkt.",
  "Délai de paiement": "Betalingstermijn",
  "Démarrer l'activation": "Activering starten",
  "Démarrer l'intervention": "Interventie starten",
  "Démarrer le trajet": "Rit starten",
  "Démarrez votre trajet : le client verra votre position et votre heure d'arrivée estimée sur sa page de suivi.": "Start uw rit: de klant ziet uw locatie en uw geschatte aankomsttijd op zijn volgpagina.",
  "Démo Devisto Studio — le devis signé sur place": "Demo Devisto Studio — de offerte ter plaatse ondertekend",
  "Démolition": "Sloopwerken",
  "Dépannage": "Herstelling",
  "Dépannage, entretien, rapport signé": "Herstelling, onderhoud, ondertekend verslag",
  "Dépannages & entretiens": "Herstellingen & onderhoudsbeurten",
  "Déposer le document": "Document uploaden",
  "Déposez le devis de votre fournisseur ou écrivez simplement le matériel avec les prix. Indiquez votre main-d'œuvre : l'assistant rédige les lignes et le texte de main-d'œuvre pour vous.": "Upload de offerte van uw leverancier of noteer gewoon het materiaal met de prijzen. Vermeld uw arbeidskosten: de assistent stelt de posten en de omschrijving van de arbeidskosten voor u op.",
  "Déposez votre extrait BCE ou une facture de frais.": "Upload uw KBO-uittreksel of een kostenfactuur.",
  "Dépôt impossible.": "Uploaden niet mogelijk.",
  "Désactiver": "Deactiveren",
  "Désamiantage": "Asbestverwijdering",
  "Détails": "Details",
  "Détecteur": "Detector",
  "Développez votre activité avec Devisto.": "Laat uw zaak groeien met Devisto.",
  "Développez votre clientèle dans votre région": "Breid uw klantenbestand in uw regio uit",
  "E-mail": "E-mail",
  "E-mail (facultatif)": "E-mail (optioneel)",
  "E-mail de votre comptable": "E-mailadres van uw boekhouder",
  "E-mail du client": "E-mailadres van de klant",
  "E-mail du client (pour la signature)": "E-mailadres van de klant (voor de ondertekening)",
  "E-mail du client (sinon repris du document)": "E-mailadres van de klant (anders overgenomen uit het document)",
  "E-mail du client *": "E-mailadres van de klant *",
  "E-mail du comptable invalide": "E-mailadres van de boekhouder ongeldig",
  "E-mail du signataire (facultatif)": "E-mailadres van de ondertekenaar (optioneel)",
  "ESB12345678": "ESB12345678",
  "EUR HTVA / an": "EUR excl. btw / jaar",
  "EUR €": "EUR €",
  "Eau chaude": "Warm water",
  "Eau chaude sanitaire": "Sanitair warm water",
  "Eau froide": "Koud water",
  "Effacer": "Wissen",
  "Efficacité": "Efficiëntie",
  "Email": "E-mail",
  "Email (pour l'envoi et la signature)": "E-mail (voor verzending en ondertekening)",
  "Email *": "E-mail *",
  "Email du client": "E-mailadres van de klant",
  "Email du client (pour envoyer le rapport)": "E-mailadres van de klant (om het verslag te versturen)",
  "Email invalide": "Ongeldig e-mailadres",
  "Emails": "E-mails",
  "Emplacement": "Locatie",
  "Emplacement (cave, toiture, cuisine…)": "Locatie (kelder, dak, keuken…)",
  "Emplacement unité extérieure": "Locatie van de buitenunit",
  "En Belgique, la RC professionnelle couvre les dommages causés chez vos clients, et\n            l'assurance décennale est obligatoire (loi Peeters-Borsus) pour les travaux de gros œuvre sur habitations. Demandez une offre à votre\n            courtier ou comparez les assureurs belges (AXA, Ethias, AG, Baloise, Federale).": "In België dekt de beroepsaansprakelijkheidsverzekering schade die u bij uw klanten veroorzaakt, en\n            is de tienjarige aansprakelijkheidsverzekering verplicht (wet-Peeters-Borsus) voor ruwbouwwerken aan woningen. Vraag een offerte aan bij uw\n            makelaar of vergelijk Belgische verzekeraars (AXA, Ethias, AG, Baloise, Federale).",
  "En Belgique, la RC professionnelle couvre les dommages causés chez vos clients, et l'assurance décennale est obligatoire (loi Peeters-Borsus) pour les travaux de gros œuvre sur habitations. Demandez une offre à votre courtier ou comparez les assureurs belges (AXA, Ethias, AG, Baloise, Federale).": "In België dekt de beroepsaansprakelijkheidsverzekering schade die u bij uw klanten veroorzaakt, en is de tienjarige aansprakelijkheidsverzekering verplicht (wet-Peeters-Borsus) voor ruwbouwwerken aan woningen. Vraag een offerte aan bij uw makelaar of vergelijk Belgische verzekeraars (AXA, Ethias, AG, Baloise, Federale).",
  "En attente": "In afwachting",
  "En attente d'activation — aucune clé": "In afwachting van activering — geen sleutel",
  "En attente de réponse": "In afwachting van antwoord",
  "En cours": "In uitvoering",
  "En deux mots : que faut-il faire ?": "Kort gezegd: wat moet er gebeuren?",
  "En essai": "In proefperiode",
  "En ligne": "Online",
  "En préparation": "In voorbereiding",
  "En retard": "Te laat",
  "En route": "Onderweg",
  "En savoir plus": "Meer informatie",
  "En signant, vous confirmez que les travaux décrits ci-dessus ont bien été réalisés.": "Door te ondertekenen bevestigt u dat de hierboven beschreven werken zijn uitgevoerd.",
  "En vigueur le": "Van kracht op",
  "En-tête du document": "Documenthoofding",
  "Encaisser": "Innen",
  "Encaissé": "Geïnd",
  "Encaissé ce mois": "Deze maand geïnd",
  "Encastré": "Ingebouwd",
  "Enregistrement en cours… appuyez sur le carré pour terminer.": "Opname bezig… druk op het vierkant om te stoppen.",
  "Enregistrement impossible": "Opname niet mogelijk",
  "Enregistrement impossible.": "Opname niet mogelijk.",
  "Enregistrement impossible. Réessayez.": "Opnemen niet mogelijk. Probeer het opnieuw.",
  "Enregistrement trop court.": "Opname te kort.",
  "Enregistrement trop long (24 Mo max)": "Opname te lang (max. 24 MB)",
  "Enregistrement vide": "Lege opname",
  "Enregistrement…": "Opname…",
  "Enregistrer": "Opslaan",
  "Enregistrer comme modèle": "Opslaan als sjabloon",
  "Enregistrer dans l'historique": "Opslaan in de historiek",
  "Enregistrer et tester": "Opslaan en testen",
  "Enregistrer l'article": "Artikel opslaan",
  "Enregistrer la question": "Vraag opslaan",
  "Enregistrer le modèle": "Sjabloon opslaan",
  "Enregistrer le passeport": "Paspoort opslaan",
  "Enregistrer les CGV": "Algemene verkoopvoorwaarden opslaan",
  "Enregistrer une nouvelle version": "Nieuwe versie opslaan",
  "Enter": "Enter",
  "Entrepreneur général (tous corps de métier)": "Algemene aannemer (alle bouwberoepen)",
  "Entreprise": "Bedrijf",
  "Entretien": "Onderhoud",
  "Entretien chaudière": "Ketelonderhoud",
  "Entretien en retard": "Achterstallig onderhoud",
  "Entretien enregistré — la prochaine échéance est recalculée": "Onderhoud opgeslagen — de volgende vervaldatum is opnieuw berekend",
  "Entretien tous les (mois)": "Onderhoud om de (maanden)",
  "Entretien à prévoir": "Onderhoud te voorzien",
  "Entretiens des 7 prochains jours": "Onderhoudsbeurten in de komende 7 dagen",
  "Entretiens à faire": "Uit te voeren onderhoudsbeurten",
  "Entretiens à programmer": "In te plannen onderhoudsbeurten",
  "Environnement de test (sandbox)": "Testomgeving (sandbox)",
  "Envoi": "Verzending",
  "Envoi automatique activé : votre comptable recevra l'export chaque début de trimestre.": "Automatische verzending ingeschakeld: uw boekhouder ontvangt de export aan het begin van elk kwartaal.",
  "Envoi automatique chaque trimestre": "Automatische verzending elk kwartaal",
  "Envoi de la photo impossible. Réessayez.": "Foto verzenden niet mogelijk. Probeer het opnieuw.",
  "Envoi des rappels impossible.": "Herinneringen verzenden niet mogelijk.",
  "Envoi en cours…": "Bezig met verzenden…",
  "Envoi impossible, réessayez.": "Verzenden niet mogelijk, probeer het opnieuw.",
  "Envoi impossible.": "Verzenden niet mogelijk.",
  "Envoi impossible. Réessayez.": "Verzenden niet mogelijk. Probeer het opnieuw.",
  "Envoi trimestriel actif": "Verzending per kwartaal actief",
  "Envoi…": "Verzending…",
  "Envoyer": "Verzenden",
  "Envoyer au client": "Naar de klant versturen",
  "Envoyer et documents": "Versturen en documenten",
  "Envoyer la facture": "De factuur versturen",
  "Envoyer la planification": "De planning versturen",
  "Envoyer la relance avec le lien de paiement": "De herinnering met de betaallink versturen",
  "Envoyer le lien de signature": "De ondertekenlink versturen",
  "Envoyer le message": "Het bericht versturen",
  "Envoyer le rappel maintenant": "De herinnering nu versturen",
  "Envoyer les rappels": "De herinneringen versturen",
  "Envoyer ma demande": "Mijn aanvraag versturen",
  "Envoyer ma question": "Mijn vraag versturen",
  "Envoyer mon avis": "Mijn beoordeling versturen",
  "Envoyer un message…": "Een bericht versturen…",
  "Envoyer une photo": "Een foto versturen",
  "Envoyer via Peppol": "Versturen via Peppol",
  "Envoyer à": "Versturen naar",
  "Envoyer à mon comptable": "Naar mijn boekhouder versturen",
  "Envoyer à signer": "Ter ondertekening versturen",
  "Envoyez d'abord le lien de signature au client": "Verstuur eerst de ondertekenlink naar de klant",
  "Envoyez via Peppol": "Verstuur via Peppol",
  "Envoyé": "Verzonden",
  "Envoyé au client": "Naar de klant verzonden",
  "Envoyé le": "Verzonden op",
  "Envoyée": "Verzonden",
  "Envoyées": "Verzonden",
  "Envoyés": "Verzonden",
  "Envoyés depuis plus de 3 jours, sans réponse": "Meer dan 3 dagen geleden verzonden, zonder antwoord",
  "Escaliers": "Trappen",
  "Escape": "Escape",
  "Espace comptable": "Boekhoudersruimte",
  "Espace de suivi": "Opvolgruimte",
  "Espace entreprises": "Ruimte voor bedrijven",
  "Espace professionnels": "Ruimte voor professionals",
  "Espace réservé aux artisans et professionnels": "Ruimte voorbehouden aan vakmensen en professionals",
  "Espagne": "Spanje",
  "Espèces": "Contant geld",
  "Essai": "Proefperiode",
  "Essai 30 j": "Proefperiode van 30 dagen",
  "Essai gratuit jusqu'au": "Gratis proefperiode tot",
  "Essai gratuit —": "Gratis proefperiode —",
  "Essai jusqu'au": "Proefperiode tot",
  "Essai terminé": "Proefperiode afgelopen",
  "Essai —": "Proefperiode —",
  "Essayer gratuitement": "Gratis uitproberen",
  "Estimation HTVA": "Raming excl. btw",
  "Et ensuite ?": "En daarna?",
  "Et ensuite ? Compléter le rapport": "En daarna? Het verslag aanvullen",
  "Et ensuite ? Suggestions pour ce devis": "En daarna? Suggesties voor deze offerte",
  "Et mes clients particuliers ?": "En mijn particuliere klanten?",
  "Ex. : Chauffage": "Bv.: Verwarming",
  "Ex. : Démonstration pour mon entreprise": "Bv.: Demonstratie voor mijn bedrijf",
  "Ex. : Local technique -1": "Bv.: Technische ruimte -1",
  "Ex. : Mon Entreprise SRL – Rue Exemple 1, 1000 Bruxelles – TVA BE0123.456.789": "Bv.: Mijn Bedrijf BV – Voorbeeldstraat 1, 1000 Brussel – btw BE0123.456.789",
  "Ex. : Prix d'une pompe à chaleur en Belgique en 2026": "Bv.: Prijs van een warmtepomp in België in 2026",
  "Ex. : ajoute 3 mètres de tubage inox et deux heures de main-d'œuvre": "Bv.: voeg 3 meter roestvrijstalen rookgasafvoer en twee uur werkuren toe",
  "Ex. : chaudière affiche F.28, trois tentatives d'allumage puis mise en sécurité, pression 1,4 bar, gaz OK ailleurs…": "Bv.: verwarmingsketel geeft F.28 aan, drie ontstekingspogingen en gaat daarna in storing, druk 1,4 bar, gastoevoer elders OK…",
  "Ex. : chiffre le remplacement de cette chaudière": "Bv.: bereken de kosten voor de vervanging van deze verwarmingsketel",
  "Ex. : entretien annuel chaudière gaz condensation Vaillant 25 kW, maison de 1998, dépannage prioritaire sous 48 h": "Bv.: jaarlijks onderhoud van een condenserende gasketel van Vaillant, 25 kW, woning uit 1998, prioritaire herstelling binnen 48 u",
  "Ex. : la porte fait 83 cm de large · mesurer le mur du fond": "Bv.: de deur is 83 cm breed · de achterwand opmeten",
  "Ex. : le délai d'intervention est-il garanti ? La TVA à 6 % s'applique-t-elle ?": "Bv.: is de interventietermijn gegarandeerd? Is het btw-tarief van 6 % van toepassing?",
  "Ex. : le taux de TVA à 6 % est-il justifié pour ce chantier (logement > 10 ans) ?": "Bv.: is het btw-tarief van 6 % gerechtvaardigd voor deze werf (woning > 10 jaar)?",
  "Ex. : remplacement d'une chaudière gaz 24 kW, démontage de l'ancienne, raccordement, mise en service et évacuation.": "Bv.: vervanging van een gasketel van 24 kW, demontage van de oude ketel, aansluiting, inbedrijfstelling en afvoer.",
  "Ex. : remplacé le groupe de sécurité du boiler, purgé les 6 radiateurs, pression remise à 1,5 bar, le client doit surveiller la fuite au robinet de la cuisine…": "Bv.: de veiligheidsgroep van de boiler vervangen, de 6 radiatoren ontlucht, de druk weer op 1,5 bar gebracht, de klant moet het lek aan de keukenkraan in de gaten houden…",
  "Ex. acompte de 30 % à la commande, solde à la réception…": "Bv. voorschot van 30 % bij bestelling, saldo bij oplevering…",
  "Ex. mise à jour taux réduit, source BOFiP…": "Bv. update van het verlaagde tarief, bron BOFiP…",
  "Excellent": "Uitstekend",
  "Existante": "Bestaande",
  "Exonéré": "Vrijgesteld",
  "Expiré": "Verlopen",
  "Expliquez votre besoin en quelques minutes. Ajoutez des photos, précisez votre localisation et vos attentes.": "Leg in enkele minuten uit wat u nodig hebt. Voeg foto's toe en geef uw locatie en verwachtingen aan.",
  "Export": "Export",
  "Export / hors champ": "Export / buiten toepassingsgebied",
  "Export Billit / Yuki / Odoo / CSV": "Export Billit / Yuki / Odoo / CSV",
  "Export CSV": "CSV-export",
  "Export comptable": "Boekhoudexport",
  "Export comptable (ZIP)": "Boekhoudexport (ZIP)",
  "Export comptable CSV + UBL": "Boekhoudexport CSV + UBL",
  "Export impossible.": "Export niet mogelijk.",
  "Export prêt : transmettez le fichier ZIP à votre comptable.": "Export klaar: bezorg het ZIP-bestand aan uw boekhouder.",
  "Exports envoyés par l'entreprise": "Exports verzonden door het bedrijf",
  "Extension": "Uitbreiding",
  "Extrait BCE": "KBO-uittreksel",
  "Extrait BCE ou facture de frais au nom de la société (PDF ou photo, 15 Mo max).": "KBO-uittreksel of kostenfactuur op naam van de vennootschap (PDF of foto, max. 15 MB).",
  "Facile": "Eenvoudig",
  "Facturation": "Facturatie",
  "Facturation et avis clients": "Facturatie en klantbeoordelingen",
  "Facturation impossible.": "Factureren niet mogelijk.",
  "Facturation non activée": "Facturatie niet geactiveerd",
  "Facturation électronique": "Elektronische facturatie",
  "Facturation électronique Peppol": "Elektronische facturatie via Peppol",
  "Facturation électronique Peppol obligatoire en Belgique depuis le 1er janvier 2026 : ce que les artisans et indépendants du bâtiment doivent faire, et comment Devisto l'automatise pour 25 €/mois.": "Elektronische facturatie via Peppol is in België verplicht sinds 1 januari 2026: wat vakmensen en zelfstandigen in de bouw moeten doen en hoe Devisto dit automatiseert voor 25 €/maand.",
  "Facturation électronique structurée": "Gestructureerde elektronische facturatie",
  "Facture": "Factuur",
  "Facture Peppol obligatoire 2026 en Belgique — guide artisan | Devisto": "Peppol-factuur verplicht in België in 2026 — gids voor vakmensen | Devisto",
  "Facture Peppol obligatoire :": "Peppol-factuur verplicht:",
  "Facture complète": "Volledige factuur",
  "Facture créée dans": "Factuur aangemaakt in",
  "Facture créée.": "Factuur aangemaakt.",
  "Facture d'achat": "Aankoopfactuur",
  "Facture d'achat, garantie, notices et rapports d'entretien de cet équipement.": "Aankoopfactuur, garantie, handleidingen en onderhoudsrapporten van dit toestel.",
  "Facture d'acompte": "Voorschotfactuur",
  "Facture de frais au nom de la société": "Kostenfactuur op naam van de vennootschap",
  "Facture enregistrée.": "Factuur opgeslagen.",
  "Facture envoyée au client.": "Factuur naar de klant verzonden.",
  "Facture finale": "Eindfactuur",
  "Facture finale (acompte déduit)": "Eindfactuur (voorschot afgetrokken)",
  "Facture introuvable": "Factuur niet gevonden",
  "Facture introuvable.": "Factuur niet gevonden.",
  "Facture marquée payée.": "Factuur als betaald gemarkeerd.",
  "Facture réglée": "Factuur betaald",
  "Facture transmise via le réseau Peppol.": "Factuur via het Peppol-netwerk verzonden.",
  "Facturer ce devis": "Deze offerte factureren",
  "Facturer cette intervention": "Deze interventie factureren",
  "Facturer quand même ? Vous pourrez compléter les prix sur la facture.": "Toch factureren? U kunt de prijzen later op de factuur aanvullen.",
  "Factures": "Facturen",
  "Factures affichées": "Weergegeven facturen",
  "Factures d'achat": "Aankoopfacturen",
  "Factures d'achat et avoirs fournisseurs": "Aankoopfacturen en creditnota's van leveranciers",
  "Factures d'achat et avoirs fournisseurs : par Peppol, par photo/PDF lu par l'IA, ou laissés à votre comptable.": "Aankoopfacturen en creditnota's van leveranciers: via Peppol, via een foto/PDF die door AI wordt uitgelezen, of overgelaten aan uw boekhouder.",
  "Factures de vente": "Verkoopfacturen",
  "Factures de vente (PDF + UBL Peppol), notes de crédit, achats et export par période. Consultation uniquement.": "Verkoopfacturen (PDF + UBL Peppol), creditnota's, aankopen en export per periode. Alleen raadplegen.",
  "Factures de vente (PDF + UBL), achats et export comptable, en consultation uniquement.": "Verkoopfacturen (PDF + UBL), aankopen en boekhoudexport, alleen ter inzage.",
  "Factures en attente (": "Facturen in afwachting (",
  "Factures en retard": "Achterstallige facturen",
  "Factures reçues": "Ontvangen facturen",
  "Factures à encaisser": "Te innen facturen",
  "Factures émises": "Uitgereikte facturen",
  "Factures, acomptes et notes de crédit émis": "Uitgereikte facturen, voorschotten en creditnota's",
  "Facturé": "Gefactureerd",
  "Facturé TVAC": "Gefactureerd incl. btw",
  "Facturé par Devisto · TVA BE 0786.236.171": "Gefactureerd door Devisto · btw BE 0786.236.171",
  "Facturé, encaissé, à encaisser et TVA due — mois par mois.": "Gefactureerd, ontvangen, nog te ontvangen en verschuldigde btw — maand per maand.",
  "Facultatif maintenant, requis pour activer Peppol.": "Nu optioneel, vereist om Peppol te activeren.",
  "Faire signer sur place": "Ter plaatse laten ondertekenen",
  "Fais un devis pour le remplacement d'une chaudière gaz à condensation 24 kW": "Maak een offerte voor de vervanging van een condenserende gasketel van 24 kW",
  "Fait / pas fait": "Gedaan / niet gedaan",
  "Faites pointer le bouton « Demander un devis » de votre site vers cette page Devisto à votre nom. Les demandes (avec photos) apparaissent ci-dessous et vous êtes notifié.": "Laat de knop « Offerte aanvragen » op uw website verwijzen naar deze Devisto-pagina op uw naam. De aanvragen (met foto's) verschijnen hieronder en u krijgt een melding.",
  "Faites signer le client dans le cadre prévu": "Laat de klant ondertekenen in het daarvoor bestemde vak",
  "Faites signer le client dans le cadre prévu.": "Laat de klant ondertekenen in het daarvoor bestemde vak.",
  "Faites votre devis ou facture": "Maak uw offerte of factuur",
  "Faux plafond": "Verlaagd plafond",
  "Façadier / crépi et enduits": "Gevelwerker / crepi en pleisterwerk",
  "Ferme": "Boerderij",
  "Fermer": "Sluiten",
  "Ferronnerie et soudure": "Smeedwerk en laswerk",
  "Fiabilité": "Betrouwbaarheid",
  "Fiche du bâtiment": "Gebouwfiche",
  "Fiche technique": "Technische fiche",
  "Fiche technique complétée.": "Technische fiche ingevuld.",
  "Fiche technique métier": "Technische vakfiche",
  "Fichiers": "Bestanden",
  "Fichiers UBL (XML)": "UBL-bestanden (XML)",
  "Finances": "Financiën",
  "Finitions": "Afwerking",
  "Flexible inox": "Flexibele inoxslang",
  "Fonctionnalités": "Functies",
  "Format Peppol BIS": "Peppol BIS-formaat",
  "Format Peppol BIS 3.0 généré automatiquement": "Peppol BIS 3.0-formaat automatisch gegenereerd",
  "Format attendu : BE0123456789": "Verwacht formaat: BE0123456789",
  "Format audio non supporté": "Audioformaat niet ondersteund",
  "Format non supporté : envoyez un PDF ou du texte": "Formaat niet ondersteund: stuur een PDF of tekst",
  "Format prêt à publier sur Instagram Reels, TikTok, YouTube Shorts et Facebook. Voix off et sous-titres inclus — regardable sans le son.": "Formaat klaar om te publiceren op Instagram Reels, TikTok, YouTube Shorts en Facebook. Voice-over en ondertitels inbegrepen — ook zonder geluid te bekijken.",
  "Fournisseur": "Leverancier",
  "Fournisseur *": "Leverancier *",
  "Fournisseur, référence…": "Leverancier, referentie…",
  "Fournitures": "Benodigdheden",
  "France": "Frankrijk",
  "Franchise (petite entreprise)": "Vrijstellingsregeling (kleine onderneming)",
  "Français": "Frans",
  "Frigoriste": "Koeltechnicus",
  "Fréquence": "Frequentie",
  "Fréquence d'entretien": "Onderhoudsfrequentie",
  "Fév": "Feb",
  "Février": "Februari",
  "Gagnez du temps grâce à une organisation simplifiée.": "Bespaar tijd dankzij een eenvoudigere organisatie.",
  "Garantie": "Garantie",
  "Garantie décennale": "Tienjarige garantie",
  "Garantie jusqu'au": "Garantie tot",
  "Gaz naturel": "Aardgas",
  "Gestion des bâtiments": "Gebouwenbeheer",
  "Gestion indisponible.": "Beheer niet beschikbaar.",
  "Gestionnaires immobiliers": "Vastgoedbeheerders",
  "Goulotte": "Kabelgoot",
  "Grand": "Groot",
  "Grande": "Grote",
  "Gris industriel": "Industrieel grijs",
  "Gros œuvre": "Ruwbouw",
  "Guides & conseils de pros.": "Gidsen & tips van professionals.",
  "Génération de l'aperçu…": "Voorbeeld wordt gegenereerd…",
  "Génération du QR code…": "QR-code wordt gegenereerd…",
  "Génération du devis": "Offerte genereren",
  "Génération du rapport impossible.": "Rapport genereren niet mogelijk.",
  "Génération impossible.": "Genereren niet mogelijk.",
  "Générer la checklist": "Checklist genereren",
  "Géothermie": "Geothermie",
  "Gérer / résilier": "Beheren / opzeggen",
  "Gérez les interventions et le suivi technique de vos immeubles efficacement.": "Beheer de interventies en technische opvolging van uw gebouwen efficiënt.",
  "HT": "Excl. btw",
  "HTVA": "Excl. btw",
  "HTVA +": "Excl. btw +",
  "HTVA :": "Excl. btw:",
  "HTVA ·": "Excl. btw ·",
  "HTVA · TVA": "Excl. btw · btw",
  "HTVA)": "Excl. btw)",
  "HTVA, avoirs déduits": "Excl. btw, creditnota's afgetrokken",
  "HTVA/an ·": "Excl. btw/jaar ·",
  "HTVA/an. Relisez et ajustez.": "Excl. btw/jaar. Lees na en pas aan.",
  "HTVA/an. Saisissez le nouveau tarif : le contrat de renouvellement reprend les mêmes prestations, prend effet le": "Excl. btw/jaar. Voer het nieuwe tarief in: het verlengingscontract omvat dezelfde prestaties en gaat in op",
  "Heures prévues": "Geplande uren",
  "Historique": "Historiek",
  "Historique centralisé": "Gecentraliseerde historiek",
  "Historique complet ·": "Volledige historiek ·",
  "Historique d'entretien": "Onderhoudshistoriek",
  "Historique des interventions": "Interventiehistoriek",
  "Historique des modifications": "Wijzigingshistoriek",
  "Historique du bâtiment": "Historiek van het gebouw",
  "Historique technique": "Technische historiek",
  "Historique technique centralisé de votre patrimoine": "Gecentraliseerde technische historiek van uw vastgoed",
  "Hors brouillons": "Zonder concepten",
  "Hors ligne": "Offline",
  "Hors service": "Buiten dienst",
  "IBAN :": "IBAN:",
  "Identifiant Peppol": "Peppol-ID",
  "Identifiants Odoo refusés. Vérifiez la base, le login et la clé API.": "Odoo-inloggegevens geweigerd. Controleer de database, de login en de API-sleutel.",
  "Identifiants fiscaux ·": "Fiscale identificatiegegevens ·",
  "Identification de l'installation": "Identificatie van de installatie",
  "Identité fiscale · BE": "Fiscale identiteit · BE",
  "Ignorer": "Negeren",
  "Il reçoit un email, choisit son mot de passe et accède immédiatement aux dossiers de la société.": "Hij ontvangt een e-mail, kiest zijn wachtwoord en krijgt meteen toegang tot de dossiers van het bedrijf.",
  "Image de couverture (URL)": "Omslagafbeelding (URL)",
  "Immeuble Le Bosquet": "Gebouw Le Bosquet",
  "Immeuble moderne géré avec Devisto": "Modern gebouw beheerd met Devisto",
  "Immeubles": "Gebouwen",
  "Immeubles, lots et équipements au même endroit": "Gebouwen, kavels en toestellen op één plek",
  "Impayé": "Onbetaald",
  "Import impossible.": "Importeren niet mogelijk.",
  "Importer": "Importeren",
  "Importer les tarifs de dépannage et entretien": "Tarieven voor herstellingen en onderhoud importeren",
  "Importer les tarifs types chauffagiste": "Standaardtarieven voor verwarmingsinstallateurs importeren",
  "Importer les tarifs types entrepreneur général": "Standaardtarieven voor algemene aannemers importeren",
  "Importer les tarifs types électricien": "Standaardtarieven voor elektriciens importeren",
  "Importer une image": "Een afbeelding importeren",
  "Impossible d'enregistrer, réessayez.": "Opslaan niet mogelijk, probeer het opnieuw.",
  "Impossible de créer le devis.": "Kan de offerte niet aanmaken.",
  "Impossible de générer l'aperçu pour le moment.": "Kan het voorbeeld momenteel niet genereren.",
  "Impossible de lancer la remise à neuf.": "Kan de vernieuwing niet starten.",
  "Imprimer": "Afdrukken",
  "Imprimés sur vos devis et factures selon les mentions obligatoires de votre pays. Devise :": "Afgedrukt op uw offertes en facturen volgens de verplichte vermeldingen in uw land. Valuta:",
  "Inclus": "Inbegrepen",
  "Inconnu": "Onbekend",
  "Indiquez au moins le nom du client": "Geef minstens de naam van de klant op",
  "Indiquez au moins un destinataire valide.": "Geef minstens één geldige ontvanger op.",
  "Indiquez ce qui est mesuré": "Geef aan wat er gemeten wordt",
  "Indiquez l'e-mail du comptable dans Finances": "Geef het e-mailadres van de boekhouder op bij Financiën",
  "Indiquez l'e-mail du comptable pour activer l'envoi automatique": "Geef het e-mailadres van de boekhouder op om automatisch verzenden te activeren",
  "Indiquez le matériel à acheter": "Geef aan welk materiaal u moet aankopen",
  "Indiquez le nom du client qui signe": "Geef de naam van de klant die ondertekent op",
  "Indiquez le nom du client qui signe.": "Geef de naam van de klant die ondertekent op.",
  "Indiquez le nom du client.": "Geef de naam van de klant op.",
  "Indiquez un pourcentage entre 1 et 100.": "Geef een percentage tussen 1 en 100 op.",
  "Indiquez votre nom et prénom.": "Geef uw voor- en achternaam op.",
  "Indiquez votre nom et votre question.": "Geef uw naam en uw vraag op.",
  "Indiquez votre nom pour signer": "Geef uw naam op om te ondertekenen",
  "Indiquez votre nom pour signer.": "Geef uw naam op om te ondertekenen.",
  "Indiquez votre numéro de TVA.": "Geef uw btw-nummer op.",
  "Indépendants, SRL, SPRL : tous les artisans assujettis sont concernés, quel que soit le chiffre d'affaires.": "Zelfstandigen, BV's, BVBA's: dit geldt voor alle btw-plichtige vakmensen, ongeacht hun omzet.",
  "Information au client (ex. : merci de prévoir l'accès à la cave)": "Informatie voor de klant (bv.: zorg ervoor dat de kelder toegankelijk is)",
  "Informations manquantes": "Ontbrekende informatie",
  "Innovation": "Innovatie",
  "Inscription impossible.": "Registreren is niet mogelijk.",
  "Instagram": "Instagram",
  "Installation et entretien de pompe à chaleur air/eau pour réduire durablement votre facture énergétique.": "Installatie en onderhoud van een lucht-waterwarmtepomp om uw energiefactuur blijvend te verlagen.",
  "Installation et rénovation sanitaire : salles de bain, douches, WC, robinetterie et équipements.": "Installatie en renovatie van sanitair: badkamers, douches, wc's, kranen en toestellen.",
  "Installation existante": "Bestaande installatie",
  "Installation pompe à chaleur": "Installatie van een warmtepomp",
  "Installation à jour": "Installatie up-to-date",
  "Installation, dépannage, mise en conformité, tableaux électriques, bornes de recharge et domotique.": "Installatie, herstelling, conform maken, elektrische verdeelborden, laadpalen en domotica.",
  "Installation, entretien et dépannage par un professionnel chauffage qualifié : chaudière, radiateurs, chauffage central.": "Installatie, onderhoud en herstelling door een gekwalificeerde verwarmingsspecialist: verwarmingsketels, radiatoren en centrale verwarming.",
  "Installer": "Installeren",
  "Installez Devisto sur votre téléphone": "Installeer Devisto op uw telefoon",
  "Installé le": "Geïnstalleerd op",
  "Instantanée": "Onmiddellijk",
  "Insérer le modèle belge": "Belgisch sjabloon invoegen",
  "Insérer le modèle de mon pays": "Model van mijn land invoegen",
  "Interrupteurs à installer": "Te installeren schakelaars",
  "Intervention": "Interventie",
  "Intervention en cours": "Interventie bezig",
  "Intervention enregistrée.": "Interventie opgeslagen.",
  "Intervention introuvable": "Interventie niet gevonden",
  "Intervention supprimée.": "Interventie verwijderd.",
  "Intervention sur place": "Interventie ter plaatse",
  "Intervention terminée": "Interventie afgerond",
  "Intervention —": "Interventie —",
  "Interventions": "Interventies",
  "Intitulé du chantier (optionnel)": "Naam van de werf (optioneel)",
  "Intitulé du contrat": "Naam van het contract",
  "Intracommunautaire (autoliquidation)": "Intracommunautair (btw verlegd)",
  "Invitation en attente": "Uitnodiging in afwachting",
  "Invitation envoyée : votre comptable choisit son mot de passe et accède à son espace.": "Uitnodiging verzonden: uw boekhouder kiest zijn wachtwoord en krijgt toegang tot zijn omgeving.",
  "Invitation envoyée par email.": "Uitnodiging per e-mail verzonden.",
  "Invitation envoyée à votre comptable.": "Uitnodiging naar uw boekhouder verzonden.",
  "Invitation expirée : demandez un nouveau lien à votre responsable": "Uitnodiging verlopen: vraag uw verantwoordelijke om een nieuwe link",
  "Invitation impossible.": "Uitnodigen niet mogelijk.",
  "Invitation introuvable ou déjà utilisée": "Uitnodiging niet gevonden of al gebruikt",
  "Invitation introuvable ou déjà utilisée.": "Uitnodiging niet gevonden of al gebruikt.",
  "Inviter": "Uitnodigen",
  "Invitez vos ouvriers et votre comptable : chacun a son accès, limité à son rôle. Inclus dans l'abonnement.": "Nodig uw arbeiders en uw boekhouder uit: iedereen krijgt toegang volgens zijn rol. Inbegrepen in het abonnement.",
  "Isolation": "Isolatie",
  "J'ai effectué le paiement": "Ik heb de betaling uitgevoerd",
  "J'écoute… appuyez sur le carré pour terminer.": "Ik luister… druk op het vierkantje om te stoppen.",
  "JMX Énergie": "JMX Énergie",
  "JPG, PNG ou photo iPhone (HEIC) — compressées automatiquement avant l'envoi.": "JPG, PNG of iPhone-foto (HEIC) — automatisch gecomprimeerd vóór het verzenden.",
  "Jan": "Jan",
  "Janvier": "Januari",
  "Jardinier / paysagiste": "Tuinier / tuinaanlegger",
  "Je cherche un technicien": "Ik zoek een technicus",
  "Je confirme ce traitement TVA": "Ik bevestig deze btw-behandeling",
  "Je connais une dimension réelle": "Ik ken een werkelijke afmeting",
  "Je suis arrivé": "Ik ben aangekomen",
  "Je suis un particulier": "Ik ben een particulier",
  "Je suis un professionnel": "Ik ben een professional",
  "Jeu": "Do",
  "Jour du rendez-vous": "Dag van de afspraak",
  "Journaux": "Dagboeken",
  "Juil": "Jul",
  "Juillet": "Juli",
  "Juin": "Juni",
  "Jusqu'à 3 rappels envoyés au client après l'échéance, au rythme et au ton que vous choisissez ; vous êtes prévenu à chaque envoi.": "Tot 3 herinneringen worden na de vervaldatum naar de klant verstuurd, volgens het ritme en in de toon die u kiest; u krijgt bij elke verzending een melding.",
  "KBC, Belfius, ING, BNP Paribas Fortis, Argenta, Crelan… : ouvrez votre app, choisissez « Scanner / Payer par QR » — le virement est pré-rempli (bénéficiaire, montant, communication).": "KBC, Belfius, ING, BNP Paribas Fortis, Argenta, Crelan…: open uw app en kies « Scannen / Betalen via QR » — de overschrijving is vooraf ingevuld (begunstigde, bedrag, mededeling).",
  "Ko ·": "kB ·",
  "L'acompte est déduit automatiquement de la facture finale.": "Het voorschot wordt automatisch van de eindfactuur afgetrokken.",
  "L'appareil": "Het toestel",
  "L'assistant a besoin d'une précision.": "De assistent heeft een verduidelijking nodig.",
  "L'assistant a repéré des points à vérifier.": "De assistent heeft punten gevonden die u moet controleren.",
  "L'assistant applique vos prix, propose les postes manquants et signale ce qu'il reste à confirmer avec le\n        client. Rien n'est envoyé avant votre validation.": "De assistent past uw prijzen toe, stelt ontbrekende posten voor en geeft aan wat u nog met de\n        klant moet bevestigen. Er wordt niets verstuurd voordat u uw goedkeuring geeft.",
  "L'assistant applique vos prix, propose les postes manquants et signale ce qu'il reste à confirmer avec le client. Rien n'est envoyé avant votre validation.": "De assistent past uw prijzen toe, stelt ontbrekende posten voor en geeft aan wat u nog met de klant moet bevestigen. Er wordt niets verstuurd voordat u uw goedkeuring geeft.",
  "L'assistant n'a pas pu analyser la photo. Réessayez.": "De assistent kon de foto niet analyseren. Probeer het opnieuw.",
  "L'assistant n'a pas pu appliquer cette demande.": "De assistent kon dit verzoek niet uitvoeren.",
  "L'assistant n'a pas pu appliquer cette demande. Reformulez.": "De assistent kon dit verzoek niet uitvoeren. Formuleer het anders.",
  "L'assistant n'a pas pu rédiger. Réessayez.": "De assistent kon geen tekst opstellen. Probeer het opnieuw.",
  "L'assistant n'a pas pu répondre. Réessayez.": "De assistent kon niet antwoorden. Probeer het opnieuw.",
  "L'assistant n'a pas trouvé assez d'informations. Ajoutez des notes ou une dictée.": "De assistent heeft niet genoeg informatie gevonden. Voeg notities of een dictaat toe.",
  "L'assistant réfléchit": "De assistent denkt na",
  "L'assistant travaille…": "De assistent is aan het werk…",
  "L'e-mail": "De e-mail",
  "L'intervention est déjà créée : ouvrez-la pour cocher les travaux et faire signer le rapport.": "De interventie is al aangemaakt: open ze om de werkzaamheden af te vinken en het verslag te laten ondertekenen.",
  "L'intervention reprend le dossier et les lignes du devis, puis génère le rapport à remettre au client.": "De interventie neemt het dossier en de posten van de offerte over en genereert vervolgens het verslag voor de klant.",
  "L'obligation ne concerne que les factures entre professionnels (B2B). Pour les particuliers, Devisto envoie toujours un PDF par email, et le client paie en ligne.": "De verplichting geldt alleen voor facturen tussen ondernemingen (B2B). Aan particulieren stuurt Devisto nog altijd een pdf per e-mail, en de klant betaalt online.",
  "La date de fin précède la date de début": "De einddatum ligt vóór de begindatum",
  "La facturation est réservée au responsable de la société": "De facturatie is voorbehouden aan de zaakvoerder",
  "La facturation et le chiffre d'affaires sont accessibles uniquement au patron. Vous gardez l'accès aux\n              dossiers, aux devis et à vos interventions.": "Alleen de zaakvoerder heeft toegang tot de facturatie en de omzet. U behoudt toegang tot de\n              dossiers, de offertes en uw interventies.",
  "La facturation et le chiffre d'affaires sont accessibles uniquement au patron. Vous gardez l'accès aux dossiers, aux devis et à vos interventions.": "Alleen de zaakvoerder heeft toegang tot de facturatie en de omzet. U behoudt toegang tot de dossiers, de offertes en uw interventies.",
  "La facturation électronique structurée devient obligatoire entre assujettis TVA belges (B2B).": "Gestructureerde elektronische facturatie wordt verplicht tussen Belgische btw-plichtigen (B2B).",
  "La facture reprend les travaux réalisés et le matériel utilisé, avec vos prix de la bibliothèque.": "De factuur vermeldt de uitgevoerde werkzaamheden en het gebruikte materiaal, met uw prijzen uit de bibliotheek.",
  "La même histoire en 9:16, sur téléphone : dossier dicté, devis IA, PDF, signature sur place.": "Hetzelfde verhaal in 9:16, op uw telefoon: dossier gedicteerd, AI-offerte, pdf, ter plaatse ondertekend.",
  "La note est vide": "De notitie is leeg",
  "La plateforme des techniques spéciales du bâtiment": "Het platform voor speciale technieken in gebouwen",
  "La plateforme qui": "Het platform dat",
  "La réponse part à votre marque (logo, coordonnées) avec un bouton vers le document. Relisez-la : l'IA ne connaît que les données du document.": "Het antwoord wordt in uw huisstijl verstuurd (logo, contactgegevens) met een knop naar het document. Lees het na: de AI kent alleen de gegevens uit het document.",
  "La technologie au service d'un secteur essentiel.": "Technologie ten dienste van een essentiële sector.",
  "Laisser l'IA chiffrer les lignes": "De AI de posten laten berekenen",
  "Laisser un avis Google": "Een Google-review achterlaten",
  "Laissez vide pour créer un devis vierge.": "Laat dit leeg om een blanco offerte aan te maken.",
  "Lancer le diagnostic": "De diagnose starten",
  "Langue de l'application et des documents": "Taal van de applicatie en de documenten",
  "Langue de l'article": "Taal van het artikel",
  "Le PDF n'a pas pu être affiché.": "De PDF kon niet worden weergegeven.",
  "Le blog Devisto": "De blog van Devisto",
  "Le bouton «": "De knop «",
  "Le bouton « Envoyer via Peppol » est actif sur chaque facture d'un client professionnel enregistré sur le réseau.": "De knop « Verzenden via Peppol » is actief op elke factuur van een professionele klant die op het netwerk is geregistreerd.",
  "Le choix s'applique après « Enregistrer ».": "De keuze wordt toegepast na « Opslaan ».",
  "Le client a été informé de la fin de l'intervention.": "De klant is op de hoogte gebracht dat de interventie is afgerond.",
  "Le client indique avoir payé (": "De klant geeft aan betaald te hebben (",
  "Le client n'est plus sur place ? Envoyez-lui le rapport à signer.": "Is de klant niet meer ter plaatse? Stuur hem het verslag ter ondertekening.",
  "Le client reçoit un email « Visite technique – Devis » avec le jour, l'heure d'arrivée, l'adresse et le motif.": "De klant ontvangt een e-mail « Technisch bezoek – Offerte » met de dag, het aankomstuur, het adres en de reden van het bezoek.",
  "Le client reçoit un rappel 7 puis 14 jours après l'envoi du devis tant qu'il n'a pas signé ou refusé.": "De klant ontvangt 7 en vervolgens 14 dagen na verzending van de offerte een herinnering, zolang hij de offerte niet heeft ondertekend of geweigerd.",
  "Le client signe sur votre téléphone à la fin de l'intervention, ou à distance via un lien sécurisé.": "De klant ondertekent aan het einde van de interventie op uw telefoon, of op afstand via een beveiligde link.",
  "Le comptable ne voit jamais vos devis, vos chantiers ni vos marges : uniquement ventes, achats, règlements et exports.": "De boekhouder ziet nooit uw offertes, werven of marges: alleen verkopen, aankopen, betalingen en exports.",
  "Le compte n'existe pas encore sur ce site : cliquez sur « Créer / remettre à neuf ».": "Het account bestaat nog niet op deze site: klik op « Aanmaken / vernieuwen ».",
  "Le coût d'achat et la durée servent à calculer votre marge et votre temps sur chaque devis. Vous pouvez les\n        modifier directement dans la liste : c'est enregistré dès que vous quittez le champ.": "De aankoopprijs en de tijdsduur dienen om uw marge en uw tijd per offerte te berekenen. U kunt ze\n        rechtstreeks in de lijst aanpassen: uw wijzigingen worden opgeslagen zodra u het veld verlaat.",
  "Le coût d'achat et la durée servent à calculer votre marge et votre temps sur chaque devis. Vous pouvez les modifier directement dans la liste : c'est enregistré dès que vous quittez le champ.": "De aankoopprijs en de tijdsduur dienen om uw marge en uw tijd per offerte te berekenen. U kunt ze rechtstreeks in de lijst aanpassen: uw wijzigingen worden opgeslagen zodra u het veld verlaat.",
  "Le devis semble complet.": "De offerte lijkt volledig.",
  "Le lien d'avis doit commencer par https://": "De link naar de beoordelingen moet beginnen met https://",
  "Le minimum pour démarrer : le nom du client. Vous complétez le reste sur le chantier.": "Het minimum om te starten: de naam van de klant. De rest vult u aan op de werf.",
  "Le mot de passe doit contenir au moins 6 caractères": "Het wachtwoord moet minstens 6 tekens bevatten",
  "Le même ton est utilisé par le bouton « Relancer » de la liste des factures. Le lien de paiement est toujours joint.": "Dezelfde toon wordt gebruikt voor de knop « Herinneren » in de factuurlijst. De betaallink wordt altijd toegevoegd.",
  "Le nom de la prestation est obligatoire": "De naam van de dienst is verplicht",
  "Le nom du client est obligatoire": "De naam van de klant is verplicht",
  "Le paiement n'a pas abouti. Vous pouvez réessayer.": "De betaling is niet gelukt. U kunt het opnieuw proberen.",
  "Le passeport technique de chaque installation : chaudière, PAC, ventilation, PEB, numéros de série, garanties et historique d'entretien.": "Het technisch paspoort van elke installatie: verwarmingsketel, warmtepomp, ventilatie, EPB, serienummers, garanties en onderhoudshistoriek.",
  "Le premier entretien enregistré déclenchera le rappel automatique à la date suivante.": "Het eerste geregistreerde onderhoud activeert de automatische herinnering op de volgende datum.",
  "Le service email est indisponible, réessayez dans quelques minutes": "De e-maildienst is niet beschikbaar, probeer het over enkele minuten opnieuw",
  "Le service email est indisponible, réessayez dans quelques minutes. Rien n'a été envoyé.": "De e-maildienst is niet beschikbaar, probeer het over enkele minuten opnieuw. Er is niets verzonden.",
  "Le tableau de bord technique de vos immeubles.": "Het technisch dashboard van uw gebouwen.",
  "Lecture IA en cours…": "AI-herkenning bezig…",
  "Lecture en cours…": "Bezig met uitlezen…",
  "Lecture impossible.": "Uitlezen niet mogelijk.",
  "Lecture impossible. Rapprochez-vous et évitez les reflets.": "Uitlezen niet mogelijk. Ga dichterbij en vermijd weerspiegelingen.",
  "Lecture impossible. Reprenez la photo de plus près.": "Uitlezen niet mogelijk. Maak de foto opnieuw van dichterbij.",
  "Lecture seule : factures de vente, achats, export comptable": "Alleen lezen: verkoopfacturen, aankopen, boekhoudexport",
  "Les": "De",
  "Les 90 prochains jours, et tout ce qui est déjà en retard": "De komende 90 dagen, en alles wat al achterstallig is",
  "Les bons professionnels pour vos projets.": "De juiste vakmensen voor uw projecten.",
  "Les demandes de devis envoyées depuis votre site arrivent ici. Une touche : l'IA en fait un devis chiffré que vous ajustez.": "Offerteaanvragen die via uw website worden verzonden, komen hier terecht. Met één tik maakt AI er een offerte met prijzen van die u kunt aanpassen.",
  "Les dossiers rattachés à ce bâtiment apparaîtront ici.": "De dossiers die aan dit gebouw zijn gekoppeld, verschijnen hier.",
  "Les factures adressées à votre n° de TVA sur le réseau Peppol apparaissent ici « à vérifier ».": "Facturen die via het Peppol-netwerk aan uw btw-nummer zijn gericht, verschijnen hier als « te controleren ».",
  "Les factures d'achat Peppol arriveront ici.": "Uw Peppol-aankoopfacturen komen hier terecht.",
  "Les factures d'achat encodées ou reçues par Peppol apparaissent ici.": "Ingevoerde aankoopfacturen en aankoopfacturen die via Peppol zijn ontvangen, verschijnen hier.",
  "Les gestes du quotidien": "Dagelijkse handelingen",
  "Les liens raccourcis sont bloqués par les messageries. Utilisez le lien long, ": "Berichtenapps blokkeren verkorte links. Gebruik de lange link, ",
  "Les lignes ajoutées ne sont pas encore enregistrées : cliquez sur « Enregistrer » en haut du devis.": "De toegevoegde regels zijn nog niet opgeslagen: klik bovenaan de offerte op « Opslaan ».",
  "Les lignes, prix et conditions du modèle sont repris ; vous ajustez ensuite les quantités.": "De regels, prijzen en voorwaarden van het sjabloon worden overgenomen; daarna past u de hoeveelheden aan.",
  "Les lignes, prix, conditions et remarques sont copiés dans un nouveau brouillon daté d'aujourd'hui. Choisissez où le créer.": "De regels, prijzen, voorwaarden en opmerkingen worden gekopieerd naar een nieuw concept met de datum van vandaag. Kies waar u het wilt aanmaken.",
  "Les montants incluent les travaux de base et la TVA.": "De bedragen omvatten de basiswerken en de btw.",
  "Les paiements enregistrés sur vos factures apparaîtront ici.": "De betalingen die bij uw facturen zijn geregistreerd, verschijnen hier.",
  "Les photos seront classées dans «": "De foto's worden ingedeeld onder «",
  "Les professionnels qualifiés de votre région, correspondant à votre projet, reçoivent votre demande.": "Gekwalificeerde vakmensen uit uw regio die bij uw project passen, ontvangen uw aanvraag.",
  "Les questions posées sur vos devis et factures arrivent ici. Claude rédige la réponse à partir du document : relisez, ajustez, envoyez.": "Vragen over uw offertes en facturen komen hier binnen. Claude stelt op basis van het document een antwoord op: lees het na, pas het aan en verstuur het.",
  "Les rappels partent automatiquement au rythme et au ton choisis dans votre": "De herinneringen worden automatisch verstuurd volgens de frequentie en toon die u hebt gekozen in uw",
  "Libellé": "Omschrijving",
  "Libellé manquant": "Omschrijving ontbreekt",
  "Lien client": "Klantlink",
  "Lien copié": "Link gekopieerd",
  "Lien copié.": "Link gekopieerd.",
  "Lien de paiement introuvable.": "Betaallink niet gevonden.",
  "Lien de signature envoyé au client.": "Ondertekenlink naar de klant verstuurd.",
  "Lien du passeport copié": "Link naar het paspoort gekopieerd",
  "Lien « Laisser un avis Google »": "Link « Een Google-review achterlaten »",
  "Ligne": "Regel",
  "Ligne ajoutée — pensez à enregistrer le devis": "Regel toegevoegd — vergeet niet de offerte op te slaan",
  "Ligne libre": "Vrije regel",
  "Ligne « Assurance": "Regel « Verzekering",
  "Lignes ajoutées au devis.": "Regels toegevoegd aan de offerte.",
  "Lignes du devis": "Offerteregels",
  "Lignes probablement oubliées": "Mogelijk vergeten regels",
  "Lire": "Lezen",
  "Lire la photo de l'intervention (matériel, état, travaux visibles)": "Analyseer de foto van de interventie (materiaal, staat, zichtbare werken)",
  "Lire la plaque signalétique": "Lees het typeplaatje",
  "Lire les": "Lees de",
  "Liste copiée.": "Lijst gekopieerd.",
  "Liste de matériel copiée.": "Materiaallijst gekopieerd.",
  "Liste magasin": "Winkellijst",
  "Liste magasin Devisto": "Winkellijst Devisto",
  "Liste matériel —": "Materiaallijst —",
  "Livrée": "Geleverd",
  "Livrées": "Geleverd",
  "Logiciel belge ·": "Belgische software ·",
  "Login Odoo": "Login bij Odoo",
  "Logo": "Logo",
  "Logo enregistré.": "Logo opgeslagen.",
  "Logo, couleurs, police et mise en page appliqués à vos devis, rapports de visite et rapports d'intervention.": "Logo, kleuren, lettertype en lay-out toegepast op uw offertes, bezoekverslagen en interventieverslagen.",
  "Longueur de tubes à poser": "Lengte van de te plaatsen buizen",
  "Longueur des liaisons (m)": "Lengte van de verbindingsleidingen (m)",
  "Longueur totale (m)": "Totale lengte (m)",
  "Longueur tubage (m)": "Lengte van de schoorsteenvoering (m)",
  "Longueur, largeur, hauteur": "Lengte, breedte, hoogte",
  "Lu et approuvé": "Gelezen en goedgekeurd",
  "Lun": "Maa",
  "Luxembourg": "Luxemburg",
  "MRR —": "MRR —",
  "Ma couleur": "Mijn kleur",
  "Ma rentabilité": "Mijn rendabiliteit",
  "Magasin": "Magazijn",
  "Mai": "Mei",
  "Main-d'œuvre": "Arbeidskosten",
  "Main-d'œuvre (€ HTVA)": "Arbeidskosten (€ excl. btw)",
  "Maintenance en cours": "Onderhoud aan de gang",
  "Mar": "Din",
  "Marc Dupont": "Marc Dupont",
  "Marge": "Marge",
  "Marge ligne": "Marge per regel",
  "Marge matériel (%)": "Marge op materiaal (%)",
  "Marge minimum souhaitée (%)": "Gewenste minimummarge (%)",
  "Marge par heure": "Marge per uur",
  "Marge à": "Marge op",
  "Marque": "Merk",
  "Marquer comme acheté": "Markeren als aangekocht",
  "Marquer comme pris": "Markeren als meegenomen",
  "Marquer comme reçu": "Markeren als ontvangen",
  "Marquer payée": "Markeren als betaald",
  "Mars": "Maart",
  "Masquer": "Verbergen",
  "Masquer les articles achetés": "Aangekochte artikelen verbergen",
  "Masquez les informations que votre logo affiche déjà.": "Verberg de gegevens die al op uw logo staan.",
  "Matériel": "Materiaal",
  "Matériel (ex. : kit raccordement)": "Materiaal (bv.: aansluitset)",
  "Matériel :": "Materiaal:",
  "Matériel ajouté au chantier.": "Materiaal toegevoegd aan de werf.",
  "Matériel enregistré hors ligne.": "Materiaal offline opgeslagen.",
  "Matériel introuvable": "Materiaal niet gevonden",
  "Matériel noté hors ligne.": "Materiaal offline genoteerd.",
  "Matériel retiré.": "Materiaal verwijderd.",
  "Matériel utilisé": "Gebruikt materiaal",
  "Matériel à acheter": "Aan te kopen materiaal",
  "Mazout": "Stookolie",
  "Maçon / gros œuvre": "Metselaar / ruwbouw",
  "Me mettre en règle gratuitement": "Gratis in orde komen",
  "Mention autoliquidation": "Vermelding btw verlegd",
  "Mention export / hors champ": "Vermelding uitvoer / buiten toepassingsgebied",
  "Mention intracommunautaire": "Vermelding intracommunautaire levering",
  "Mention sur le document : «": "Vermelding op het document: «",
  "Mentions obligatoires (une par ligne)": "Verplichte vermeldingen (één per regel)",
  "Menuiserie extérieure (châssis, portes)": "Buitenschrijnwerk (ramen, deuren)",
  "Menuisier intérieur": "Binnenschrijnwerker",
  "Menus, devis, factures et e-mails clients dans cette langue après enregistrement.": "Menu's, offertes, facturen en klantenmails in deze taal na het opslaan.",
  "Mer": "Woe",
  "Merci ! L'entreprise est prévenue de votre paiement.": "Bedankt! Het bedrijf is op de hoogte gebracht van uw betaling.",
  "Merci de régler sous 7 jours": "Gelieve binnen 7 dagen te betalen",
  "Merci pour votre avis !": "Bedankt voor uw feedback!",
  "Merci, cette facture est déjà payée.": "Bedankt, deze factuur is al betaald.",
  "Mes 7 prochains jours": "Mijn komende 7 dagen",
  "Mes demandes": "Mijn aanvragen",
  "Mes documents": "Mijn documenten",
  "Mes factures": "Mijn facturen",
  "Mes immeubles": "Mijn gebouwen",
  "Mes interventions": "Mijn interventies",
  "Mes modèles de contrat": "Mijn contractsjablonen",
  "Mes questions": "Mijn vragen",
  "Mes tarifs": "Mijn tarieven",
  "Message": "Bericht",
  "Message envoyé !": "Bericht verzonden!",
  "Mesure enregistrée hors ligne.": "Meting offline opgeslagen.",
  "Mesurer avec la caméra": "Meten met de camera",
  "Mesures": "Metingen",
  "Mesures relevées": "Opgenomen metingen",
  "Mesures sur photo par IA — à confirmer avec une dimension connue pour une précision pro": "Metingen op foto met AI — bevestig met een bekende afmeting voor professionele nauwkeurigheid",
  "Mets 6 % de TVA partout": "Zet overal 6 % btw",
  "Mettre à jour le rapport": "Het rapport bijwerken",
  "Micro inaccessible. Autorisez l'accès au micro.": "Microfoon niet toegankelijk. Geef toegang tot de microfoon.",
  "Micro inaccessible. Autorisez le microphone dans votre navigateur.": "Microfoon niet toegankelijk. Sta de microfoon toe in uw browser.",
  "Micro indisponible. Autorisez l'accès au micro.": "Microfoon niet beschikbaar. Geef toegang tot de microfoon.",
  "Mise en conformité": "Conform maken",
  "Mise en page": "Lay-out",
  "Mise en service": "Inbedrijfstelling",
  "Mise à jour impossible.": "Bijwerken niet mogelijk.",
  "Mise à la terre": "Aarding",
  "Mixte": "Gemengd",
  "Mode chantier hors ligne — notes, mesures, matériel et photos sont conservés sur l'appareil.": "Offline werfmodus — notities, metingen, materiaal en foto's worden op het toestel bewaard.",
  "Mode clair": "Lichte modus",
  "Mode hors ligne sur chantier": "Offlinemodus op de werf",
  "Mode sombre": "Donkere modus",
  "Mode sombre pour travailler confortablement le soir. Réglage propre à cet appareil ; les pages vues par vos clients restent claires.": "Donkere modus om 's avonds comfortabel te werken. Deze instelling geldt alleen voor dit toestel; de pagina's die uw klanten zien, blijven licht.",
  "Mode édition": "Bewerkmodus",
  "Moderne": "Modern",
  "Moderne (sans empattement)": "Modern (schreefloos)",
  "Modification annulée.": "Wijziging geannuleerd.",
  "Modifier": "Bewerken",
  "Modifier (nouvelle version)": "Bewerken (nieuwe versie)",
  "Modifier l'article": "Artikel bewerken",
  "Modifiez la recherche ou le filtre.": "Pas de zoekopdracht of het filter aan.",
  "Modèle": "Sjabloon",
  "Modèle d'email enregistré.": "E-mailsjabloon opgeslagen.",
  "Modèle indisponible.": "Sjabloon niet beschikbaar.",
  "Modèle inséré : adaptez-le puis enregistrez.": "Sjabloon ingevoegd: pas het aan en sla het op.",
  "Modèle introuvable": "Sjabloon niet gevonden",
  "Modèle réinitialisé.": "Sjabloon teruggezet.",
  "Modèle supprimé.": "Sjabloon verwijderd.",
  "Modèle «": "Sjabloon «",
  "Modèles d'emails": "E-mailsjablonen",
  "Mois": "Maand",
  "Mollie (en ligne) + virement": "Mollie (online) + overschrijving",
  "Mollie + virement": "Mollie + overschrijving",
  "Mollie activé (": "Mollie geactiveerd (",
  "Mollie désactivé.": "Mollie gedeactiveerd.",
  "Mon abonnement": "Mijn abonnement",
  "Mon argent": "Mijn geld",
  "Mon assurance": "Mijn verzekering",
  "Mon comptable": "Mijn boekhouder",
  "Mon comptable peut-il récupérer mes factures ?": "Kan mijn boekhouder mijn facturen ophalen?",
  "Mon compte": "Mijn account",
  "Mon entreprise": "Mijn bedrijf",
  "Mon logiciel de facturation (Billit)": "Mijn facturatiesoftware (Billit)",
  "Mon métier par défaut": "Mijn standaardvakgebied",
  "Mon pipeline": "Mijn pipeline",
  "Mon planning": "Mijn planning",
  "Mon équipe": "Mijn team",
  "Mono-split": "Monosplit",
  "Monophasé": "Eenfasig",
  "Montant (solde": "Bedrag (saldo",
  "Montant (solde par défaut)": "Bedrag (standaard: saldo)",
  "Montant :": "Bedrag:",
  "Montant du règlement invalide": "Ongeldig betalingsbedrag",
  "Montant à payer": "Te betalen bedrag",
  "Montants": "Bedragen",
  "Montants masqués": "Bedragen verborgen",
  "Mot de passe": "Wachtwoord",
  "Mot de passe *": "Wachtwoord *",
  "Moteur IA": "AI-engine",
  "Moteur IA inconnu": "Onbekende AI-engine",
  "Moteur d'intelligence artificielle": "Artificiële-intelligentie-engine",
  "Motif :": "Reden:",
  "Motif du refus": "Reden van de weigering",
  "Moyen": "Gemiddeld",
  "Multi-split": "Multisplit",
  "Multiservices / petits travaux": "Diverse diensten / kleine werken",
  "Mur, sol, plafond en m²": "Muur, vloer, plafond in m²",
  "Méthodes :": "Methoden:",
  "Métier principal": "Hoofdvakgebied",
  "Métier principal *": "Hoofdvakgebied *",
  "Métiers couverts par Devisto": "Vakgebieden die Devisto ondersteunt",
  "Même dossier ·": "Hetzelfde dossier ·",
  "Mêmes prestations, nouveau tarif": "Dezelfde prestaties, nieuw tarief",
  "Navigation espace": "Navigatie in de werkruimte",
  "Nederlands": "Nederlands",
  "Nettoyage et fin de chantier": "Schoonmaak en afronding van de werf",
  "Neutre": "Neutraal",
  "Noir & or": "Zwart & goud",
  "Nom": "Naam",
  "Nom (ex. : Heure de main-d'œuvre) *": "Naam (bv.: Arbeidsuur) *",
  "Nom (laissez vide = auto)": "Naam (leeg laten = automatisch)",
  "Nom *": "Naam *",
  "Nom de l'assureur": "Naam van de verzekeraar",
  "Nom de l'entreprise": "Naam van het bedrijf",
  "Nom de l'option (ex. : Confort, Premium, Pompe à chaleur)": "Naam van de optie (bv.: Comfort, Premium, Warmtepomp)",
  "Nom de la base": "Naam van de basis",
  "Nom du bâtiment (ex. Villa Dupont, Résidence Les Tilleuls)": "Naam van het gebouw (bv. Villa Dupont, Résidence Les Tilleuls)",
  "Nom du client": "Naam van de klant",
  "Nom du client (sinon repris du document)": "Naam van de klant (anders overgenomen uit het document)",
  "Nom du client *": "Naam van de klant *",
  "Nom du comptable / fiduciaire": "Naam van de boekhouder / het boekhoudkantoor",
  "Nom du document (ex. : Contrat maintenance)": "Naam van het document (bv.: Onderhoudscontract)",
  "Nom du modèle (ex. Remplacement chaudière gaz 25 kW)": "Naam van het sjabloon (bv. Vervanging gasketel 25 kW)",
  "Nom du modèle de contrat :": "Naam van het contractsjabloon:",
  "Nom, adresse, TVA, IBAN et coordonnées depuis votre profil.": "Naam, adres, btw-nummer, IBAN en contactgegevens uit uw profiel.",
  "Nombre d'unités intérieures": "Aantal binnenunits",
  "Nombre de coudes": "Aantal bochten",
  "Nombre de disjoncteurs": "Aantal stroomonderbrekers",
  "Nombre de modules": "Aantal modules",
  "Non conforme": "Niet conform",
  "Non inclus": "Niet inbegrepen",
  "Non inclus (une par ligne)": "Niet inbegrepen (één per regel)",
  "Non-condensation": "Niet-condenserend",
  "Non. Devisto est connecté à un point d'accès Peppol certifié : vous envoyez depuis l'application, nous nous occupons du reste.": "Nee. Devisto is aangesloten op een gecertificeerd Peppol-toegangspunt: u verstuurt vanuit de applicatie, wij doen de rest.",
  "Normale": "Normaal",
  "Nos derniers guides pour réussir vos projets techniques.": "Onze nieuwste gidsen om uw technische projecten tot een goed einde te brengen.",
  "Note": "Notitie",
  "Note (historique)": "Notitie (historiek)",
  "Note ajoutée aux remarques du devis": "Notitie toegevoegd aan de opmerkingen bij de offerte",
  "Note de crédit": "Creditnota",
  "Note de crédit liée :": "Gekoppelde creditnota:",
  "Note enregistrée hors ligne.": "Notitie offline opgeslagen.",
  "Note moyenne des clients": "Gemiddelde beoordeling door klanten",
  "Note moyenne et meilleurs commentaires (≥ 4 étoiles) affichés sur la page de signature et dans le PDF du devis : la preuve sociale au moment de décider.": "Gemiddelde beoordeling en beste reacties (≥ 4 sterren) weergegeven op de ondertekenpagina en in de pdf van de offerte: sociale bewijskracht op het beslissende moment.",
  "Note pour vous (facultatif)": "Notitie voor uzelf (optioneel)",
  "Note rapide": "Snelle notitie",
  "Note rédigée pour le client": "Notitie opgesteld voor de klant",
  "Notes": "Notities",
  "Notes de chantier": "Werfnotities",
  "Notes de crédit": "Creditnota's",
  "Notes de crédit émises à vos clients, reliées à la facture d'origine.": "Creditnota's voor uw klanten, gekoppeld aan de oorspronkelijke factuur.",
  "Notes techniques (facultatif)": "Technische notities (optioneel)",
  "Notez sur place ce qu'il faut commander. Les matériels cités dans vos dictées s'ajoutent automatiquement.": "Noteer ter plaatse wat besteld moet worden. Het materiaal dat u in uw ingesproken notities vermeldt, wordt automatisch toegevoegd.",
  "Notification": "Melding",
  "Notifications": "Meldingen",
  "Notifications activées : vous serez prévenu même app fermée.": "Meldingen ingeschakeld: u krijgt ook een melding wanneer de app gesloten is.",
  "Notifications bloquées : autorisez-les dans les réglages du navigateur.": "Meldingen geblokkeerd: sta ze toe in de instellingen van uw browser.",
  "Notifications désactivées sur cet appareil.": "Meldingen uitgeschakeld op dit toestel.",
  "Notre objectif est simple :": "Ons doel is eenvoudig:",
  "Notre plateforme est momentanément indisponible le temps d'une mise à jour technique. Merci de votre patience — nous revenons très vite.": "Ons platform is tijdelijk niet beschikbaar wegens een technische update. Bedankt voor uw geduld — we zijn zo terug.",
  "Nous améliorons Devisto": "We verbeteren Devisto",
  "Nous appeler": "Bel ons",
  "Nous revenons vers vous au plus vite.": "We nemen zo snel mogelijk contact met u op.",
  "Nous sommes désolés que l'intervention n'ait pas été à la hauteur.": "Het spijt ons dat de interventie niet aan uw verwachtingen voldeed.",
  "Nouveau": "Nieuw",
  "Nouveau bâtiment": "Nieuw gebouw",
  "Nouveau client": "Nieuwe klant",
  "Nouveau client (saisie rapide)": "Nieuwe klant (snel invoeren)",
  "Nouveau client (à taper)": "Nieuwe klant (handmatig invoeren)",
  "Nouveau contrat": "Nieuw contract",
  "Nouveau devis": "Nieuwe offerte",
  "Nouveau dossier": "Nieuw dossier",
  "Nouveau dossier chantier": "Nieuw werfdossier",
  "Nouveau sur Devisto": "Nieuw op Devisto",
  "Nouvel article": "Nieuw artikel",
  "Nouvelle": "Nieuwe",
  "Nouvelle construction": "Nieuwbouw",
  "Nouvelle conversation": "Nieuw gesprek",
  "Nouvelle facture": "Nieuwe factuur",
  "Nouvelle installation": "Nieuwe installatie",
  "Nouvelle intervention": "Nieuwe interventie",
  "Nouvelle photo": "Nieuwe foto",
  "Nouvelle prestation": "Nieuwe prestatie",
  "Nouvelle réponse": "Nieuw antwoord",
  "Nouvelle version enregistrée pour": "Nieuwe versie opgeslagen voor",
  "Nov": "Nov",
  "Novembre": "November",
  "Numéro d'entreprise (BCE)": "Ondernemingsnummer (KBO)",
  "Numéro de TVA": "Btw-nummer",
  "Numéro de TVA / identifiant fiscal du client": "Btw-nummer / fiscaal identificatienummer van de klant",
  "Numéro de TVA inconnu dans la base officielle VIES.": "Btw-nummer niet bekend in de officiële VIES-databank.",
  "Numéro de TVA trop court": "Btw-nummer te kort",
  "Numéro de TVA vérifié à l'inscription": "Btw-nummer gecontroleerd bij de registratie",
  "Numéro de contrat": "Contractnummer",
  "Numéro inconnu dans VIES.": "Nummer niet bekend in VIES.",
  "N° TVA / identifiant fiscal du client": "Btw-nummer / fiscaal identificatienummer van de klant",
  "N° TVA intracommunautaire (si applicable)": "Intracommunautair btw-nummer (indien van toepassing)",
  "N° de TVA": "Btw-nummer",
  "N° de TVA (BE 0123.456.789)": "Btw-nummer (BE 0123.456.789)",
  "N° de TVA (ex. BE0123456789)": "Btw-nummer (bv. BE0123456789)",
  "N° de facture": "Factuurnummer",
  "N° de facture (ex. FAC-2026-0001)": "Factuurnummer (bv. FAC-2026-0001)",
  "N° de série": "Serienummer",
  "N° du devis (ex. DEV-2026-0001)": "Offertenummer (bv. DEV-2026-0001)",
  "Objectif": "Doelstelling",
  "Objectif atteint": "Doelstelling bereikt",
  "Objet": "Onderwerp",
  "Objet de l'email": "Onderwerp van de e-mail",
  "Obligation légale depuis le 1er janvier 2026": "Wettelijke verplichting sinds 1 januari 2026",
  "Obligations déclaratives": "Aangifteverplichtingen",
  "Observations": "Opmerkingen",
  "Observations et recommandations": "Opmerkingen en aanbevelingen",
  "Oct": "Okt",
  "Octobre": "Oktober",
  "Odoo": "Odoo",
  "Odoo injoignable. Vérifiez l'URL de votre instance.": "Odoo is niet bereikbaar. Controleer de URL van uw instantie.",
  "Option": "Optie",
  "Option (variante proposée au client)": "Optie (alternatief voorgesteld aan de klant)",
  "Option retenue :": "Gekozen optie:",
  "Option retenue par le client *": "Door de klant gekozen optie *",
  "Option retenue par le client :": "Door de klant gekozen optie:",
  "Ou par virement manuel": "Of via een handmatige overschrijving",
  "Ou un autre dossier (chantier similaire)": "Of een ander dossier (gelijkaardige werf)",
  "Ou écrivez la liste, une par ligne : Chaudière Vaillant ecoTEC 24 kW — 1 pièce — 1450 € Vase expansion 18 L — 1 — 65 € Tubage inox 60/100 — 6 m — 22 €/m": "Of schrijf de lijst, één item per regel: Vaillant ecoTEC-ketel 24 kW — 1 stuk — 1450 € Expansievat 18 L — 1 — 65 € RVS-rookgasafvoer 60/100 — 6 m — 22 €/m",
  "Oui : export CSV comptable en un clic, et format UBL standard accepté par les logiciels de comptabilité belges.": "Ja: boekhoudkundige CSV-export met één klik en het standaard UBL-formaat dat door Belgische boekhoudsoftware wordt aanvaard.",
  "Ouvrez un dossier chantier qui reprend automatiquement le client, l'adresse, les travaux réalisés, le matériel, les mesures et vos photos.": "Open een werfdossier waarin de klant, het adres, de uitgevoerde werken, het materiaal, de metingen en uw foto's automatisch worden overgenomen.",
  "Ouvrier": "Arbeider",
  "Ouvrir": "Openen",
  "Ouvrir l'assistant": "Assistent openen",
  "Ouvrir l'intervention": "Open de interventie",
  "Ouvrir la facture": "Open de factuur",
  "Ouvrir le chat": "Open de chat",
  "Ouvrir le devis": "Open de offerte",
  "Ouvrir « Mon comptable »": "Open « Mijn boekhouder »",
  "Où va l'argent ?": "Waar gaat het geld naartoe?",
  "P.U. HTVA": "E.P. excl. btw",
  "PDF ou photo de la facture (lecture IA du PDF)": "PDF of foto van de factuur (AI-uitlezing van de PDF)",
  "PDF trop lourd (12 Mo maximum)": "PDF te groot (maximaal 12 MB)",
  "PDF téléchargé.": "PDF gedownload.",
  "PDF, Word, JPG, PNG ou photo iPhone (HEIC) — 25 Mo max, images compressées automatiquement.": "PDF, Word, JPG, PNG of iPhone-foto (HEIC) — max. 25 MB, afbeeldingen worden automatisch gecomprimeerd.",
  "Page de suivi du client (avancement, documents, prochaine visite) :": "Opvolgpagina voor de klant (voortgang, documenten, volgend bezoek):",
  "Page précédente": "Vorige pagina",
  "Page suivante": "Volgende pagina",
  "Paiement comptant": "Contante betaling",
  "Paiement des factures clients": "Betaling van klantfacturen",
  "Paiement en ligne des factures (Mollie)": "Online betaling van facturen (Mollie)",
  "Paiement en ligne indisponible pour le moment.": "Online betalen is momenteel niet beschikbaar.",
  "Paiement indisponible. Réessayez.": "Betalen is niet beschikbaar. Probeer het opnieuw.",
  "Paiement instantané": "Onmiddellijke betaling",
  "Paiement reçu — merci !": "Betaling ontvangen — bedankt!",
  "Paiement signalé — merci, l'entreprise a été prévenue.": "Betaling gemeld — bedankt, het bedrijf is op de hoogte gebracht.",
  "Paiement sur le compte": "Betaling op de rekening",
  "Paiement sécurisé par Stripe": "Veilige betaling via Stripe",
  "Paiement sécurisé par virement SEPA vers le compte de l'entreprise · by Devisto": "Veilige betaling via SEPA-overschrijving naar de rekening van het bedrijf · door Devisto",
  "Paiements encaissés (date, moyen, facture)": "Ontvangen betalingen (datum, betaalwijze, factuur)",
  "Panneaux solaires / photovoltaïque": "Zonnepanelen / fotovoltaïek",
  "Pans, faîte, surface": "Dakvlakken, nok, oppervlakte",
  "Par mois (HTVA)": "Per maand (excl. btw)",
  "Paramètres fiscaux internationaux": "Internationale fiscale instellingen",
  "Parcours": "Leidingtraject",
  "Parcours, coudes, hauteur": "Leidingtraject, bochten, hoogte",
  "Parler à Devisto": "Spreek met Devisto",
  "Parlez ou écrivez, il modifie les lignes du devis": "Spreek of typ, hij past de offerteregels aan",
  "Parlez-en au responsable de la société": "Bespreek dit met de verantwoordelijke van het bedrijf",
  "Parquet et sols souples": "Parket en soepele vloerbekleding",
  "Partager la démo": "Deel de demo",
  "Partenaire de lancement": "Lanceringspartner",
  "Particulier": "Particulier",
  "Particuliers": "Particulieren",
  "Particuliers, professionnels, syndics et gestionnaires immobiliers réunis dans un même écosystème.": "Particulieren, professionals, syndici en vastgoedbeheerders samen in één ecosysteem.",
  "Partiel": "Gedeeltelijk",
  "Partiellement payée": "Gedeeltelijk betaald",
  "Partir d'un modèle": "Starten vanuit een sjabloon",
  "Partir d'un modèle…": "Starten vanuit een sjabloon…",
  "PartyID Billit": "PartyID Billit",
  "Pas d'IBAN": "Geen IBAN",
  "Pas de photo": "Geen foto",
  "Pas de rappel": "Geen herinnering",
  "Pas encore assuré ?": "Nog niet verzekerd?",
  "Pas encore d'historique": "Nog geen historiek",
  "Passeport mis à jour.": "Paspoort bijgewerkt.",
  "Passeport technique": "Technisch paspoort",
  "Passeport technique et équipements": "Technisch paspoort en toestellen",
  "Passeport technique généré par Devisto": "Technisch paspoort aangemaakt door Devisto",
  "Passez à la facture Peppol en 2 minutes": "Schakel in 2 minuten over op Peppol-facturatie",
  "Pavage et allées": "Bestrating en paden",
  "Payconiq": "Payconiq",
  "Payer": "Betalen",
  "Payer avec mon app bancaire": "Betalen met uw bankapp",
  "Pays": "Land",
  "Pays (ISO-2)": "Land (ISO-2)",
  "Pays de l'entreprise (devise & TVA)": "Land van het bedrijf (valuta & btw)",
  "Pays de votre entreprise *": "Land van uw bedrijf *",
  "Pays du client": "Land van de klant",
  "Pays du client non précisé : pays de l'artisan supposé.": "Land van de klant niet opgegeven: land van de vakman verondersteld.",
  "Pays non disponible": "Land niet beschikbaar",
  "Pays non disponible pour l'instant": "Land momenteel niet beschikbaar",
  "Pays, devise, taux, mentions, abonnement et change. Chaque modification crée une version datée ; les documents déjà émis gardent leurs règles.": "Land, valuta, tarieven, vermeldingen, abonnement en wisselkoers. Elke wijziging maakt een gedateerde versie aan; reeds uitgereikte documenten behouden hun regels.",
  "Payé": "Betaald",
  "Payée": "Betaald",
  "Payées": "Betaald",
  "Peintre en bâtiment": "Gebouwschilder",
  "Peppol": "Peppol",
  "Peppol (UBL)": "Peppol (UBL)",
  "Peppol :": "Peppol:",
  "Peppol : réservé aux clients professionnels avec un numéro de TVA (ajoutez-le sur la fiche client).": "Peppol: alleen voor professionele klanten met een btw-nummer (voeg dit toe aan de klantenfiche).",
  "Peppol BIS 3.0": "Peppol BIS 3.0",
  "Peppol sert uniquement à envoyer vos factures clients ; vous ajoutez ici ce que vous voulez suivre.": "Peppol dient alleen om uw klantenfacturen te versturen; hier voegt u toe wat u wilt opvolgen.",
  "Peppol ·": "Peppol ·",
  "Percements / traversées": "Doorboringen / doorvoeren",
  "Personnalisation de mes documents": "Personalisatie van mijn documenten",
  "Personnalisez simplement les emails envoyés à vos clients. Votre logo est ajouté automatiquement en en-tête.": "Personaliseer eenvoudig de e-mails die u naar uw klanten stuurt. Uw logo wordt automatisch bovenaan toegevoegd.",
  "Personnalisé": "Gepersonaliseerd",
  "Personne de contact": "Contactpersoon",
  "Petit": "Klein",
  "Photo": "Foto",
  "Photo ajoutée.": "Foto toegevoegd.",
  "Photo analysée": "Foto geanalyseerd",
  "Photo de l'intervention": "Foto van de interventie",
  "Photo envoyée": "Foto verzonden",
  "Photo illisible. Réessayez.": "Foto onleesbaar. Probeer het opnieuw.",
  "Photo introuvable": "Foto niet gevonden",
  "Photo jointe. Complétez les montants.": "Foto toegevoegd. Vul de bedragen in.",
  "Photo non enregistrée.": "Foto niet opgeslagen.",
  "Photographier la plaque": "Het typeplaatje fotograferen",
  "Photographier une plaque signalétique : j'identifie le modèle et je chiffre": "Een typeplaatje fotograferen: ik identificeer het model en maak een prijsraming",
  "Photographiez la plaque : l'IA propose marque, modèle, puissance, année et n° de série. Vous validez avant d'enregistrer.": "Fotografeer het typeplaatje: AI stelt het merk, model, vermogen, bouwjaar en serienummer voor. U bevestigt de gegevens voordat u ze opslaat.",
  "Photos + dictée": "Foto's + dicteren",
  "Photos ajoutées.": "Foto's toegevoegd.",
  "Photos de l'intervention": "Foto's van de interventie",
  "Photos de la situation actuelle (facultatif)": "Foto's van de huidige situatie (optioneel)",
  "Photos du chantier": "Foto's van de werf",
  "Photos gardées sur l'appareil — envoi au retour du réseau.": "Foto's bewaard op het toestel — verzending zodra er weer verbinding is.",
  "Photovoltaïque": "Fotovoltaïsche installaties",
  "Pied de page": "Voettekst",
  "Pied de page des documents (ex. : Chauffage Marc SPRL — IBAN BE00 0000 0000 0000 — merci de votre confiance)": "Voettekst van documenten (bv.: Verwarming Marc BV — IBAN BE00 0000 0000 0000 — bedankt voor uw vertrouwen)",
  "Pilotage": "Beheer",
  "Pilotez votre parc immobilier et vos interventions en un clic.": "Beheer uw gebouwen en interventies met één klik.",
  "Piscines et spas": "Zwembaden en spa's",
  "Pièce": "Ruimte",
  "Placez au moins": "Plaats minstens",
  "Plafonneur / enduits intérieurs": "Pleisterwerker / binnenbepleistering",
  "Plan d'entretien": "Onderhoudsplan",
  "Planification envoyée à": "Planning verzonden naar",
  "Planifier l'intervention": "De interventie plannen",
  "Planifier la visite technique": "Het technisch bezoek plannen",
  "Planifiez d'abord la visite technique": "Plan eerst het technisch bezoek",
  "Planifiez une visite technique depuis un dossier chantier, elle apparaîtra ici et le client recevra son rappel la veille.": "Plan een technisch bezoek vanuit een werfdossier. Het verschijnt hier en de klant ontvangt de dag voordien een herinnering.",
  "Planifiée": "Gepland",
  "Planning": "Planning",
  "Plaque": "Typeplaatje",
  "Plaque illisible sur cette photo. Rapprochez-vous et évitez les reflets.": "Typeplaatje onleesbaar op deze foto. Kom dichterbij en vermijd reflecties.",
  "Plaque lue (fiabilité": "Typeplaatje uitgelezen (betrouwbaarheid",
  "Plaque signalétique": "Typeplaatje",
  "Plaquiste / cloisons et faux plafonds": "Gyprocwerker / scheidingswanden en verlaagde plafonds",
  "Plein écran": "Volledig scherm",
  "Plomberie": "Sanitair",
  "Plombier / Sanitaire": "Loodgieter / sanitair",
  "Plus": "Meer",
  "Plus d'actions": "Meer acties",
  "Plus dense : idéal pour les longs devis.": "Compacter: ideaal voor lange offertes.",
  "Plus tard": "Later",
  "Point d'accès Peppol (Recommand)": "Peppol-toegangspunt (Aanbevolen)",
  "Points lumineux": "Lichtpunten",
  "Police": "Lettertype",
  "Pompe de relevage nécessaire": "Opvoerpomp nodig",
  "Pompe à chaleur": "Warmtepomp",
  "Pompe à chaleur / clim": "Warmtepomp / airco",
  "Pompe à chaleur / climatisation": "Warmtepomp / airconditioning",
  "Portail": "Poort",
  "Pose / fourniture et pose": "Plaatsing / levering en plaatsing",
  "Pose et maintenance de climatiseurs et systèmes réversibles pour votre confort en toute saison.": "Installatie en onderhoud van airco's en omkeerbare systemen voor uw comfort in elk seizoen.",
  "Poser ma question": "Mijn vraag stellen",
  "Poser une question sur cette facture": "Een vraag stellen over deze factuur",
  "Posez votre question…": "Stel uw vraag…",
  "Position non partagée (activez la géolocalisation)": "Locatie niet gedeeld (schakel de locatievoorzieningen in)",
  "Position partagée en direct": "Locatie live gedeeld",
  "Postes, quantités,": "Posten, hoeveelheden,",
  "Pour": "Voor",
  "Pour affiner le diagnostic": "Om de diagnose te verfijnen",
  "Pour le client :": "Voor de klant:",
  "Pour qui ?": "Voor wie?",
  "Pour un client": "Voor een klant",
  "Pour une mesure fiable : photo prise bien de face, et un repère de taille connue dans le cadre (porte, feuille A4, mètre déplié, carte bancaire). L'IA détecte le repère et propose les mesures ; vous ajustez les points et confirmez une dimension réelle.": "Voor een betrouwbare meting: maak de foto recht van voren en zorg dat er een voorwerp met bekende afmetingen in beeld is (deur, A4-blad, uitgevouwen vouwmeter, bankkaart). De AI herkent het voorwerp en stelt afmetingen voor; u past de punten aan en bevestigt een werkelijke afmeting.",
  "Premier partenaire Devisto dans le domaine du chauffage": "Eerste Devisto-partner in de verwarmingssector",
  "Prendre / choisir la photo": "Foto nemen / kiezen",
  "Prestation (ex. : entretien chaudière)": "Dienst (bv.: ketelonderhoud)",
  "Prestation ajoutée.": "Dienst toegevoegd.",
  "Prestation introuvable": "Dienst niet gevonden",
  "Prestations": "Prestaties",
  "Prestations et montants": "Prestaties en bedragen",
  "Prestations incluses": "Inbegrepen prestaties",
  "Prestations incluses (une par ligne)": "Inbegrepen prestaties (één per regel)",
  "Preuve de la société": "Bewijs van het bedrijf",
  "Preuve déposée": "Bewijs ingediend",
  "Preuve introuvable.": "Bewijs niet gevonden.",
  "Prises à installer": "Te installeren stopcontacten",
  "Prises, interrupteurs, éclairage": "Stopcontacten, schakelaars, verlichting",
  "Prix HTVA": "Prijs excl. btw",
  "Prix HTVA / an": "Prijs excl. btw / jaar",
  "Prix IA": "AI-prijs",
  "Problème constaté": "Vastgesteld probleem",
  "Prochain entretien": "Volgend onderhoud",
  "Prochain entretien :": "Volgend onderhoud:",
  "Prochain entretien conseillé :": "Aanbevolen volgend onderhoud:",
  "Prochaine visite": "Volgend bezoek",
  "Prochaine visite d'entretien :": "Volgend onderhoudsbezoek:",
  "Prochaine échéance": "Volgende vervaldatum",
  "Prochaine échéance le": "Volgende vervaldatum op",
  "Production": "Productie",
  "Professionnel": "Vakman",
  "Professionnel (assujetti)": "Vakman (btw-plichtig)",
  "Professionnel assigné": "Toegewezen vakman",
  "Professionnels": "Vakmensen",
  "Professionnels partenaires": "Vakmensen die partner zijn",
  "Professionnels vérifiés": "Geverifieerde vakmensen",
  "Profil": "Profiel",
  "Profil enregistré — il apparaîtra sur vos devis.": "Profiel opgeslagen — het verschijnt op uw offertes.",
  "Profil indisponible.": "Profiel niet beschikbaar.",
  "Profil introuvable.": "Profiel niet gevonden.",
  "Projets publiés": "Gepubliceerde projecten",
  "Propane": "Propaan",
  "Propose une option avec du matériel haut de gamme": "Stel een optie met hoogwaardig materiaal voor",
  "Propulsé par": "Mogelijk gemaakt door",
  "Protection dédiée": "Specifieke beveiliging",
  "Précisez de nouveaux éléments pour relancer le diagnostic…": "Geef nieuwe informatie om de diagnose opnieuw op te starten…",
  "Précisez le type de client et son pays pour déterminer le traitement TVA.": "Geef het type klant en het land op om de btw-behandeling te bepalen.",
  "Prénom / nom": "Voornaam / achternaam",
  "Prénom et nom": "Voor- en achternaam",
  "Préparation de l'email…": "E-mail voorbereiden…",
  "Préparation impossible. Réessayez.": "Voorbereiden niet mogelijk. Probeer het opnieuw.",
  "Préparer les lignes": "Regels voorbereiden",
  "Préparer mon devis": "Mijn offerte voorbereiden",
  "Présentation du devis": "Presentatie van de offerte",
  "Présente et conforme": "Aanwezig en conform",
  "Présente à vérifier": "Aanwezig, te controleren",
  "Prêt à simplifier vos interventions ?": "Klaar om uw interventies te vereenvoudigen?",
  "Publier l'article (visible sur /blog)": "Artikel publiceren (zichtbaar op /blog)",
  "Publiez une mission de sous-traitance — chauffage, plomberie, sanitaire, ventilation, climatisation, pompe à chaleur ou électricité — et trouvez des professionnels qualifiés, avec les bonnes certifications, au bon endroit.": "Plaats een opdracht voor onderaanneming — verwarming, loodgieterij, sanitair, ventilatie, airconditioning, warmtepompen of elektriciteit — en vind gekwalificeerde vakmensen met de juiste certificeringen op de juiste locatie.",
  "Publié": "Gepubliceerd",
  "Puis": "Dan",
  "Puissance": "Vermogen",
  "Puissance (kW)": "Vermogen (kW)",
  "Puissance nécessaire": "Benodigd vermogen",
  "PushManager": "PushManager",
  "Période": "Periode",
  "Période invalide": "Ongeldige periode",
  "Période invalide (AAAA-MM-JJ)": "Ongeldige periode (AAAA-MM-JJ)",
  "Périodicité": "Frequentie",
  "QR code de l'appareil": "QR-code van het toestel",
  "QR code de paiement SEPA": "QR-code voor SEPA-betaling",
  "QR code du passeport": "QR-code van het paspoort",
  "Qté": "Aant.",
  "Quantité": "Aantal",
  "Que puis-je faire pour vous ?": "Waarmee kan ik u helpen?",
  "Que se passe-t-il si le destinataire n'est pas sur Peppol ?": "Wat gebeurt er als de ontvanger niet op Peppol zit?",
  "Que voulez-vous créer ?": "Wat wilt u aanmaken?",
  "Quel est le prix de marché d'un entretien de chaudière mazout en Belgique ?": "Wat is de marktprijs voor het onderhoud van een stookolieketel in België?",
  "Quel que soit votre projet, Devisto transmet votre demande au professionnel qualifié adapté à votre besoin et à votre région, dans l'ensemble des métiers techniques de l'habitation.": "Wat uw project ook is, Devisto bezorgt uw aanvraag aan een gekwalificeerde vakman die bij uw behoeften en uw regio past, voor alle technische vakgebieden in de woning.",
  "Quelles factures sont encore impayées ?": "Welke facturen zijn nog niet betaald?",
  "Quelques secondes : l'IA relit votre bibliothèque de prix.": "Nog enkele seconden: de AI controleert uw prijzenbibliotheek.",
  "Question enregistrée.": "Vraag opgeslagen.",
  "Question envoyée : l'entreprise est notifiée pour": "Vraag verzonden: het bedrijf krijgt een melding voor",
  "Question envoyée. L'entreprise vous répond par e-mail dans les meilleurs délais.": "Vraag verzonden. Het bedrijf antwoordt u zo snel mogelijk per e-mail.",
  "Question générale": "Algemene vraag",
  "Question sur": "Vraag over",
  "Questions": "Vragen",
  "Questions clients": "Vragen van klanten",
  "Questions du client": "Vragen van de klant",
  "Questions du comptable": "Vragen van de boekhouder",
  "Questions fréquentes": "Veelgestelde vragen",
  "Quoi ? (ex. : tubage)": "Wat? (bv.: schoorsteenvoering)",
  "RC exploitation": "BA uitbating",
  "RC professionnelle": "BA beroepsaansprakelijkheid",
  "Raccordements": "Aansluitingen",
  "Radiateurs": "Radiatoren",
  "Ramonage et conduits de fumée": "Schoorsteenvegen en rookkanalen",
  "Rappel au client 3 puis 7 jours après l'envoi du lien de signature ; à la dernière relance, vous êtes prévenu pour l'appeler.": "Herinnering aan de klant 3 en vervolgens 7 dagen na het versturen van de ondertekenlink; bij de laatste herinnering krijgt u een melding om de klant te bellen.",
  "Rappel automatique la veille": "Automatische herinnering de dag voordien",
  "Rappel envoyé au client.": "Herinnering naar de klant verzonden.",
  "Rappels automatiques 30 jours avant chaque échéance.": "Automatische herinneringen 30 dagen voor elke vervaldatum.",
  "Rappels de visite, envoi de devis et rapports : votre logo apparaît en tête de l'email.": "Bezoekherinneringen, offertes en verslagen: uw logo staat bovenaan de e-mail.",
  "Rapport": "Verslag",
  "Rapport client": "Klantverslag",
  "Rapport d'intervention": "Interventieverslag",
  "Rapport de visite": "Bezoekverslag",
  "Rapport de visite envoyé au client.": "Bezoekverslag naar de klant verzonden.",
  "Rapport de visite pour le client": "Bezoekverslag voor de klant",
  "Rapport envoyé au client.": "Verslag naar de klant verzonden.",
  "Rapport introuvable": "Verslag niet gevonden",
  "Rapport rédigé": "Verslag opgesteld",
  "Rapport signé": "Verslag ondertekend",
  "Rapport signé par le client.": "Verslag ondertekend door de klant.",
  "Rapport signé. L'entreprise est prévenue.": "Verslag ondertekend. Het bedrijf krijgt een melding.",
  "Rapport technique sans montants : travaux réalisés, matériel, mesures, photos et signature.": "Technisch verslag zonder bedragen: uitgevoerde werken, materiaal, metingen, foto's en handtekening.",
  "Rapport établi avec Devisto ·": "Verslag opgesteld met Devisto ·",
  "Rassurez vos clients : les coordonnées de votre assurance apparaissent en bas de vos devis et factures.": "Stel uw klanten gerust: de gegevens van uw verzekeraar staan onderaan uw offertes en facturen.",
  "Rattachée au devis": "Gekoppeld aan de offerte",
  "Recevez des demandes correspondant à vos spécialités": "Ontvang aanvragen die aansluiten bij uw specialisaties",
  "Recevez des demandes qualifiées et développez votre activité simplement.": "Ontvang relevante aanvragen en laat uw zaak eenvoudig groeien.",
  "Recevez des demandes qualifiées, développez votre clientèle et gagnez en visibilité auprès de particuliers qui recherchent des professionnels comme vous.": "Ontvang relevante aanvragen, breid uw klantenbestand uit en word zichtbaarder voor particulieren die vakmensen zoals u zoeken.",
  "Recevoir par Peppol dans Devisto": "Via Peppol ontvangen in Devisto",
  "Recevoir une copie": "Een kopie ontvangen",
  "Recherche impossible.": "Zoeken niet mogelijk.",
  "Rechercher : initiales, nom, société, ville, TVA…": "Zoeken: initialen, naam, bedrijf, gemeente, btw-nummer…",
  "Rechercher la société": "Het bedrijf zoeken",
  "Rechercher un bâtiment, une adresse, un client…": "Een gebouw, adres of klant zoeken…",
  "Rechercher un client, un dossier…": "Een klant of dossier zoeken…",
  "Rechercher un devis…": "Een offerte zoeken…",
  "Rechercher un dossier…": "Een dossier zoeken…",
  "Rechercher un règlement…": "Een betaling zoeken…",
  "Rechercher une facture…": "Een factuur zoeken…",
  "Rechercher une intervention…": "Een interventie zoeken…",
  "Rechercher…": "Zoeken…",
  "Recherche…": "Zoeken…",
  "Recommand :": "Aanbevolen:",
  "Recommandations": "Aanbevelingen",
  "Recommandations pour le client (entretien, points à surveiller…)": "Aanbevelingen voor de klant (onderhoud, aandachtspunten…)",
  "Redevance annuelle": "Jaarlijkse bijdrage",
  "Reformuler": "Herformuleren",
  "Refus :": "Weigering:",
  "Refuser": "Weigeren",
  "Refusé": "Afgewezen",
  "Refusé par le client : vous pouvez proposer un nouveau tarif ci-dessous.": "Afgewezen door de klant: u kunt hieronder een nieuw tarief voorstellen.",
  "Refusée": "Afgewezen",
  "Refusés": "Afgewezen",
  "Regardez comment Devisto fait signer le devis chez le client, avant de partir (démo 6 min) :": "Bekijk hoe u met Devisto de offerte bij de klant laat ondertekenen voordat u vertrekt (demo van 6 min):",
  "Rejoignez Devisto dès aujourd'hui.": "Ga vandaag nog aan de slag met Devisto.",
  "Relance": "Herinnering",
  "Relance automatique 3 puis 7 jours après l'envoi si le client n'a pas signé.": "Automatische herinnering 3 en daarna 7 dagen na verzending als de klant niet heeft ondertekend.",
  "Relance automatique du client 10 jours après l'envoi d'un renouvellement.": "Automatische herinnering aan de klant 10 dagen na verzending van een verlenging.",
  "Relance email automatique si Peppol échoue": "Automatische herinnering per e-mail als Peppol niet werkt",
  "Relance envoyée à": "Herinnering verstuurd naar",
  "Relance envoyée.": "Herinnering verstuurd.",
  "Relance impossible.": "Herinnering versturen niet mogelijk.",
  "Relancer": "Herinnering sturen",
  "Relancer automatiquement les devis sans réponse": "Automatisch herinneringen sturen voor offertes zonder antwoord",
  "Relancer automatiquement les factures impayées": "Automatisch herinneringen sturen voor onbetaalde facturen",
  "Relancer le client": "De klant een herinnering sturen",
  "Relancer le diagnostic": "De diagnose opnieuw uitvoeren",
  "Relancer les rapports d'intervention non signés": "Herinneringen sturen voor niet-ondertekende interventieverslagen",
  "Relancer maintenant": "Nu een herinnering sturen",
  "Relecture de l'assistant": "Controle door de assistent",
  "Relire avec l'IA": "Laten nalezen door AI",
  "Remarques": "Opmerkingen",
  "Remarques pour le client": "Opmerkingen voor de klant",
  "Remettre le compte démo à neuf ? Toutes ses données seront recréées (environ 1 minute).": "Demoaccount opnieuw instellen? Alle gegevens worden opnieuw aangemaakt (ongeveer 1 minuut).",
  "Remettre à neuf": "Opnieuw instellen",
  "Remise à neuf en cours…": "Opnieuw instellen…",
  "Remise à neuf lancée.": "Vernieuwing gestart.",
  "Remplacement": "Vervanging",
  "Remplacement chaudière gaz": "Vervanging van gasketel",
  "Remplacement complet": "Volledige vervanging",
  "Remplacement d'une chaudière gaz Vaillant 24 kW chez Monsieur Dubois, avec démontage de l'ancienne chaudière, raccordement, mise en service et évacuation.": "Vervanging van een Vaillant-gasketel van 24 kW bij de heer Dubois, inclusief demontage van de oude ketel, aansluiting, inbedrijfstelling en afvoer.",
  "Remplacement de chaudière": "Vervanging van ketel",
  "Remplacement de tableau": "Vervanging van verdeelkast",
  "Remplacement partiel": "Gedeeltelijke vervanging",
  "Remplacer le document": "Het document vervangen",
  "Remplacer vos conditions actuelles par le modèle belge ?": "Uw huidige voorwaarden vervangen door het Belgische model?",
  "Remplacer vos conditions actuelles par le modèle de votre pays ?": "Uw huidige voorwaarden vervangen door het model van uw land?",
  "Remplacé par son renouvellement": "Vervangen door de verlenging ervan",
  "Rendu identique au document reçu par le client": "Identiek gemaakt aan het document dat de klant heeft ontvangen",
  "Renouvellement": "Verlenging",
  "Renouvellement créé en brouillon.": "Verlenging aangemaakt als concept.",
  "Renouvellement créé et envoyé au client pour signature.": "Verlenging aangemaakt en ter ondertekening naar de klant verstuurd.",
  "Renouvellement de votre contrat": "Verlenging van uw contract",
  "Renouvellement du contrat": "Verlenging van het contract",
  "Renouvellements en attente de signature": "Verlengingen die op ondertekening wachten",
  "Renseignez l'URL, la base, le login et la clé API Odoo dans Mon entreprise": "Vul de URL, de database, de gebruikersnaam en de Odoo API-sleutel in bij Mijn bedrijf",
  "Renseignez l'e-mail de votre comptable et activez l'envoi : l'export du trimestre (ventes, achats, règlements, UBL) partira seul, plus rien à préparer pour la TVA.": "Vul het e-mailadres van uw boekhouder in en activeer de verzending: de kwartaalexport (verkopen, aankopen, betalingen, UBL) wordt automatisch verstuurd. U hoeft niets meer voor te bereiden voor de btw.",
  "Renseignez votre clé API et votre PartyID Billit dans Mon entreprise": "Vul uw API-sleutel en uw Billit PartyID in bij Mijn bedrijf",
  "Renseignez votre clé d'accès et votre administration Yuki dans Mon entreprise": "Vul uw toegangssleutel en uw Yuki-administratie in bij Mijn bedrijf",
  "Rentabilité — visible par vous uniquement": "Rendabiliteit — alleen zichtbaar voor u",
  "Renvoyer": "Opnieuw verzenden",
  "Report impossible.": "Overnemen niet mogelijk.",
  "Reporter dans le rapport": "Overnemen in het verslag",
  "Reporté dans le rapport": "Overgenomen in het verslag",
  "Reprendre et valider →": "Overnemen en bevestigen →",
  "Reprendre →": "Overnemen →",
  "Repris du devis. Décochez ce qui n'a pas été fait, ajoutez ce qui s'est ajouté sur place.": "Overgenomen uit de offerte. Vink uit wat niet is uitgevoerd en voeg toe wat er ter plaatse is bijgekomen.",
  "Repère détecté :": "Markering gedetecteerd:",
  "Responsable": "Verantwoordelijke",
  "Retirer": "Verwijderen",
  "Retirer de la liste": "Uit de lijst verwijderen",
  "Retirer l'accès": "Toegang intrekken",
  "Retirer la clé": "Sleutel verwijderen",
  "Retirer la clé Recommand ? L'envoi Peppol repassera en attente d'activation.": "De Recommand-sleutel verwijderen? De verzending via Peppol wacht dan opnieuw op activering.",
  "Retirer la photo": "Foto verwijderen",
  "Retour au bâtiment": "Terug naar het gebouw",
  "Retour au devis": "Terug naar de offerte",
  "Retour au dossier": "Terug naar het dossier",
  "Retour au tableau de bord": "Terug naar het dashboard",
  "Retour prévu": "Verwachte terugkeer",
  "Retour à l'accueil": "Terug naar de startpagina",
  "Retour à l'immeuble": "Terug naar het gebouw",
  "Retour à l'édition": "Terug naar bewerken",
  "Retour à la facture": "Terug naar de factuur",
  "Retour à la liste": "Terug naar de lijst",
  "Revenu mensuel HTVA": "Maandelijkse inkomsten excl. btw",
  "Reçu": "Ontvangen",
  "Reçu le": "Ontvangen op",
  "Rien de planifié": "Niets gepland",
  "Rien de prévu ce jour.": "Vandaag niets gepland.",
  "Rien à acheter pour l'instant. Ajoutez du matériel ci-dessus ou depuis un dossier de chantier.": "Voorlopig hoeft u niets aan te kopen. Voeg hierboven materiaal toe of doe dat vanuit een werfdossier.",
  "Rigide inox": "Star roestvrij staal",
  "Rue et numéro": "Straat en huisnummer",
  "Rue, code postal, ville": "Straat, postcode, gemeente",
  "Rythme des relances": "Frequentie van de herinneringen",
  "Règlement enregistré.": "Betaling geregistreerd.",
  "Règlements": "Betalingen",
  "Règles indisponibles.": "Regels niet beschikbaar.",
  "Réalisation": "Uitvoering",
  "Réalisé par": "Uitgevoerd door",
  "Réception des factures fournisseurs": "Ontvangst van leveranciersfacturen",
  "Réception des travaux": "Oplevering van de werken",
  "Réception laissée au logiciel de votre comptable.": "Ontvangst wordt afgehandeld door de software van uw boekhouder.",
  "Rédaction assistée Devisto AI": "Schrijfhulp met Devisto AI",
  "Rédaction en cours…": "Tekst wordt opgesteld…",
  "Rédaction impossible.": "Opstellen niet mogelijk.",
  "Rédaction…": "Tekst wordt opgesteld…",
  "Rédige un SMS pour prévenir un client d'un retard de 30 minutes": "Schrijf een sms om een klant te laten weten dat u 30 minuten vertraging hebt",
  "Rédiger avec l'IA": "Opstellen met AI",
  "Rédiger depuis les photos": "Opstellen op basis van foto's",
  "Rédiger la réponse (IA)": "Antwoord opstellen (AI)",
  "Rédiger le brouillon": "Concept opstellen",
  "Rédiger le rapport": "Verslag opstellen",
  "Rédiger le rapport avec l'IA": "Verslag opstellen met AI",
  "Rédiger les descriptions avec l'IA": "Beschrijvingen opstellen met AI",
  "Rédigés par l'IA, signés en ligne, suivis automatiquement : rappel au client, intervention et facture à chaque échéance.": "Opgesteld met AI, online ondertekend en automatisch opgevolgd: een herinnering aan de klant, een interventie en een factuur op elke vervaldag.",
  "Référence": "Referentie",
  "Référence / note (facultatif)": "Referentie / opmerking (optioneel)",
  "Réglages enregistrés.": "Instellingen opgeslagen.",
  "Rénovation": "Renovatie",
  "Rénovation complète": "Volledige renovatie",
  "Rénovation générale": "Algemene renovatie",
  "Rénovation salle de bain": "Badkamerrenovatie",
  "Réparation": "Herstelling",
  "Réparation proposée": "Voorgestelde herstelling",
  "Réparation reportée dans le rapport : travaux, matériel et constat mis à jour.": "Herstelling opgenomen in het verslag: werkzaamheden, materiaal en vaststellingen bijgewerkt.",
  "Répondez à au moins une question.": "Beantwoord minstens één vraag.",
  "Répondre": "Antwoorden",
  "Répondre moi-même": "Zelf antwoorden",
  "Répondue": "Beantwoord",
  "Répondue le": "Beantwoord op",
  "Répondues": "Beantwoord",
  "Réponse (": "Antwoord (",
  "Réponse IA illisible. Réessayez.": "AI-antwoord onleesbaar. Probeer het opnieuw.",
  "Réponse IA inattendue. Réessayez.": "Onverwacht AI-antwoord. Probeer het opnieuw.",
  "Réponse IA incomplète. Réessayez.": "AI-antwoord onvolledig. Probeer het opnieuw.",
  "Réponse envoyée au comptable par e-mail.": "Antwoord per e-mail naar de boekhouder verzonden.",
  "Réponse envoyée à": "Antwoord verzonden naar",
  "Réponse envoyée.": "Antwoord verzonden.",
  "Réponse rédigée par l'IA : relisez puis envoyez.": "Antwoord opgesteld door AI: lees het na en verzend het.",
  "Réseau": "Netwerk",
  "Réserve disponible": "Beschikbare reserve",
  "Réservé au responsable de la société": "Voorbehouden aan de verantwoordelijke van het bedrijf",
  "Résidence Les Tilleuls": "Residentie Les Tilleuls",
  "Résumé (SEO)": "Samenvatting (SEO)",
  "Résumé pour le client (ex. : chaudière de 2004 en fin de vie, tubage à remplacer…)": "Samenvatting voor de klant (bv.: verwarmingsketel uit 2004 aan vervanging toe, voering van het rookkanaal te vervangen…)",
  "Rétablir le modèle par défaut": "Standaardmodel herstellen",
  "Rôle invalide": "Ongeldige rol",
  "Sam": "Sam",
  "Sanctions progressives": "Geleidelijke sancties",
  "Sanitaire": "Sanitair",
  "Sanitaire / eau chaude": "Sanitair / warm water",
  "Sans carte bancaire": "Zonder bankkaart",
  "Sans engagement": "Zonder verplichtingen",
  "Sans engagement, résiliable à tout moment": "Zonder verplichtingen, op elk moment opzegbaar",
  "Sans préférence": "Geen voorkeur",
  "Sans suite": "Zonder gevolg",
  "Sauf erreur de notre part…": "Behoudens vergissing van onze kant…",
  "Scannez avec votre app bancaire": "Scan met uw bankapp",
  "Se connecter": "Aanmelden",
  "Secret API Recommand": "API-geheim van Recommand",
  "Secret webhook (facultatif)": "Webhookgeheim (optioneel)",
  "Section (mm²)": "Doorsnede (mm²)",
  "Sep": "Sep",
  "Septembre": "September",
  "Serrurier / métallier": "Slotenmaker / metaalbewerker",
  "Sert à calculer la marge et le temps de main-d'œuvre affichés sur vos devis avant l'envoi. Ces chiffres restent\n            privés : ils n'apparaissent ni sur le PDF client ni dans les emails.": "Dient om de marge en de werkuren te berekenen die vóór verzending op uw offertes worden getoond. Deze cijfers blijven\n            privé: ze verschijnen niet op de pdf voor de klant of in e-mails.",
  "Sert à calculer la marge et le temps de main-d'œuvre affichés sur vos devis avant l'envoi. Ces chiffres restent privés : ils n'apparaissent ni sur le PDF client ni dans les emails.": "Dient om de marge en de werkuren te berekenen die vóór verzending op uw offertes worden getoond. Deze cijfers blijven privé: ze verschijnen niet op de pdf voor de klant of in e-mails.",
  "Service VIES indisponible. Réessayez dans un instant.": "VIES is niet beschikbaar. Probeer het zo meteen opnieuw.",
  "Service worker indisponible.": "Serviceworker niet beschikbaar.",
  "Seul le responsable de la société gère l'abonnement.": "Alleen de bedrijfsverantwoordelijke beheert het abonnement.",
  "Seul le responsable de la société peut gérer les accès": "Alleen de bedrijfsverantwoordelijke kan de toegangsrechten beheren",
  "Seul un brouillon peut être supprimé. Créez une note de crédit.": "Alleen een concept kan worden verwijderd. Maak een creditnota aan.",
  "Seul un devis accepté peut être transféré en facture": "Alleen een aanvaarde offerte kan worden omgezet in een factuur",
  "Seule une facture envoyée peut être relancée": "Alleen voor een verzonden factuur kan een herinnering worden verstuurd",
  "Signature": "Handtekening",
  "Signature de l'entreprise": "Handtekening van het bedrijf",
  "Signature du client": "Handtekening van de klant",
  "Signature du client, ici et maintenant": "Handtekening van de klant, hier en nu",
  "Signature enregistrée : elle apparaîtra sur vos devis, rapports et contrats.": "Handtekening opgeslagen: ze verschijnt op uw offertes, rapporten en contracten.",
  "Signature horodatée avec l'adresse IP de l'appareil, conservée comme preuve (eIDAS). Le client reçoit une copie par e-mail s'il est renseigné.": "Handtekening met tijdstempel en het IP-adres van het toestel, bewaard als bewijs (eIDAS). De klant ontvangt een kopie per e-mail als zijn e-mailadres is ingevuld.",
  "Signature impossible.": "Ondertekenen niet mogelijk.",
  "Signature invalide (image PNG trop lourde ou format inattendu)": "Ongeldige handtekening (PNG-afbeelding te groot of onverwacht formaat)",
  "Signature retirée.": "Handtekening verwijderd.",
  "Signature électronique horodatée (eIDAS) : nom, date et adresse IP conservés comme preuve.": "Elektronische handtekening met tijdstempel (eIDAS): naam, datum en IP-adres worden als bewijs bewaard.",
  "Signature électronique horodatée (règlement eIDAS). Votre nom, la date et votre adresse IP sont\n              conservés comme preuve, uniquement pour ce devis.": "Elektronische handtekening met tijdstempel (eIDAS-verordening). Uw naam, de datum en uw IP-adres worden\n              uitsluitend voor deze offerte als bewijs bewaard.",
  "Signature électronique horodatée (règlement eIDAS). Votre nom, la date et votre adresse IP sont\n              conservés comme preuve, uniquement pour ce rapport.": "Elektronische handtekening met tijdstempel (eIDAS-verordening). Uw naam, de datum en uw IP-adres worden\n              uitsluitend voor dit rapport als bewijs bewaard.",
  "Signature électronique horodatée (règlement eIDAS). Votre nom, la date et votre adresse IP sont conservés comme preuve, uniquement pour ce devis.": "Elektronische handtekening met tijdstempel (eIDAS-verordening). Uw naam, de datum en uw IP-adres worden uitsluitend voor deze offerte als bewijs bewaard.",
  "Signature électronique horodatée (règlement eIDAS). Votre nom, la date et votre adresse IP sont conservés comme preuve, uniquement pour ce rapport.": "Elektronische handtekening met tijdstempel (eIDAS-verordening). Uw naam, de datum en uw IP-adres worden uitsluitend voor dit rapport als bewijs bewaard.",
  "Signer au doigt": "Ondertekenen met uw vinger",
  "Signer le contrat": "Het contract ondertekenen",
  "Signer le rapport": "Het rapport ondertekenen",
  "Signez d'abord dans le cadre.": "Teken eerst in het vak.",
  "Signez dans le cadre prévu": "Teken in het daarvoor bestemde vak",
  "Signez dans le cadre prévu.": "Teken in het daarvoor bestemde vak.",
  "Signé": "Ondertekend",
  "Signé ce mois": "Deze maand ondertekend",
  "Signé cette année": "Dit jaar ondertekend",
  "Signé par": "Ondertekend door",
  "Signé sur place": "Ter plaatse ondertekend",
  "Signé sur place, sur votre appareil": "Ter plaatse ondertekend, op uw toestel",
  "Signé à distance via le lien sécurisé": "Op afstand ondertekend via de beveiligde link",
  "Signée": "Ondertekend",
  "Signées": "Ondertekend",
  "Signés": "Ondertekend",
  "Simple et efficace": "Eenvoudig en doeltreffend",
  "Simple, rapide et sans engagement": "Eenvoudig, snel en vrijblijvend",
  "Slug (URL)": "Slug (URL)",
  "Société": "Bedrijf",
  "Société (facultatif)": "Bedrijf (optioneel)",
  "Société activée sur Peppol.": "Bedrijf geactiveerd op Peppol.",
  "Société fictive « Thermo Confort SRL » (chauffagiste, Namur) avec clients, devis signés, factures, interventions, avis et contrats. À donner au vidéaste ou pour une démo commerciale. La remise à neuf efface et recrée toutes ses données.": "Fictief bedrijf « Thermo Confort SRL » (verwarmingsinstallateur, Namen) met klanten, ondertekende offertes, facturen, interventies, beoordelingen en contracten. Om aan de videomaker te geven of te gebruiken voor een commerciële demo. Bij het opnieuw instellen worden alle gegevens gewist en opnieuw aangemaakt.",
  "Société reconnue": "Bedrijf herkend",
  "Société trouvée. Complétez le nom du contact.": "Bedrijf gevonden. Vul de naam van de contactpersoon in.",
  "Société vérifiée (Peppol en attente de la clé).": "Bedrijf geverifieerd (Peppol wacht op de sleutel).",
  "Sociétés inscrites (": "Geregistreerde bedrijven (",
  "Solde dû": "Openstaand saldo",
  "Sombre": "Donker",
  "Soumettre mon dossier": "Mijn dossier indienen",
  "Soumis le": "Ingediend op",
  "Soumission impossible.": "Indienen niet mogelijk.",
  "Source : SPF Finances — loi du 6 février 2024 relative à la facturation électronique B2B. Informations indicatives, vérifiez auprès de votre comptable.": "Bron: FOD Financiën — wet van 6 februari 2024 betreffende elektronische B2B-facturatie. Deze informatie is indicatief, controleer ze bij uw boekhouder.",
  "Sous garantie jusqu'au": "Onder garantie tot",
  "Sous l'objectif": "Onder het streefdoel",
  "Statut": "Status",
  "Statut Peppol actualisé.": "Peppol-status bijgewerkt.",
  "Statut TVA": "Btw-statuut",
  "Statut de votre société": "Status van uw bedrijf",
  "Statut fiscal": "Fiscaal statuut",
  "Statut invalide": "Ongeldige status",
  "Stores, volets et portes de garage": "Zonwering, rolluiken en garagepoorten",
  "Studio": "Studio",
  "Suggestions pour compléter ce devis": "Suggesties om deze offerte aan te vullen",
  "Suivant": "Volgende",
  "Suivez chaque opportunité dans votre pipeline : contactée, devis envoyé, mission gagnée": "Volg elke verkoopkans in uw pipeline: gecontacteerd, offerte verzonden, opdracht binnengehaald",
  "Suivez l'avancement de vos interventions en direct.": "Volg de voortgang van uw interventies in realtime.",
  "Suivi": "Opvolging",
  "Suivi de chaque intervention, de la demande à la clôture": "Opvolging van elke interventie, van aanvraag tot afsluiting",
  "Suivi de livraison : reçue, en attente, échec": "Leveringsstatus: ontvangen, in afwachting, mislukt",
  "Suivi en temps réel": "Realtime opvolging",
  "Suivi en temps réel pour le client": "Realtime opvolging voor de klant",
  "Suivi proposé avec": "Voorgestelde opvolging met",
  "Sujet": "Onderwerp",
  "Suppression impossible": "Verwijderen niet mogelijk",
  "Suppression impossible.": "Verwijderen niet mogelijk.",
  "Supprimer": "Verwijderen",
  "Supprimer ce brouillon": "Dit concept verwijderen",
  "Supprimer ce bâtiment et tous ses équipements ?": "Dit gebouw en alle bijbehorende toestellen verwijderen?",
  "Supprimer ce devis": "Deze offerte verwijderen",
  "Supprimer ce modèle": "Dit sjabloon verwijderen",
  "Supprimer cet équipement": "Dit toestel verwijderen",
  "Supprimer cet équipement et son historique ?": "Dit toestel en de bijbehorende historiek verwijderen?",
  "Supprimer cette question ?": "Deze vraag verwijderen?",
  "Supprimer définitivement ce document ?": "Dit document definitief verwijderen?",
  "Supprimer l'intervention": "De interventie verwijderen",
  "Supprimer la photo": "De foto verwijderen",
  "Supprimer le brouillon": "Het concept verwijderen",
  "Supprimer le bâtiment": "Het gebouw verwijderen",
  "Supprimer le contrat": "Het contract verwijderen",
  "Supprimer le devis": "De offerte verwijderen",
  "Supprimer le modèle": "Het sjabloon verwijderen",
  "Supprimer le modèle «": "Sjabloon verwijderen: «",
  "Supprimer «": "Verwijderen: «",
  "Sur iPhone : Partager → « Sur l'écran d'accueil », puis ouvrez Devisto depuis l'icône.": "Op iPhone: Delen → « Zet op beginscherm ». Open Devisto vervolgens via het pictogram.",
  "Sur les devis": "Op offertes",
  "Sur les factures": "Op facturen",
  "Sur place": "Ter plaatse",
  "Sur téléphone ? Enregistrer le QR puis l'importer dans l'app bancaire": "Op uw telefoon? Sla de QR-code op en importeer die vervolgens in uw bankapp",
  "Surface": "Oppervlakte",
  "Surface chauffée": "Verwarmde oppervlakte",
  "Synchroniser": "Synchroniseren",
  "Syndics": "Syndici",
  "Sélectionner la garantie": "Garantie selecteren",
  "Sélectionnez au moins une information.": "Selecteer minstens één gegeven.",
  "TTC": "Incl. btw",
  "TVA": "Btw",
  "TVA & fiscalité du client": "Btw & fiscaliteit van de klant",
  "TVA 21 %": "Btw 21 %",
  "TVA 6 %": "Btw 6 %",
  "TVA :": "Btw:",
  "TVA =": "Btw =",
  "TVA client (BE 0123.456.789)": "Btw-nummer klant (BE 0123.456.789)",
  "TVA collectée": "Geïnde btw",
  "TVA de votre pays": "Btw van uw land",
  "TVA du pays du bien": "Btw van het land waar het goed zich bevindt",
  "TVA due": "Verschuldigde btw",
  "TVA facturée": "Gefactureerde btw",
  "TVA facturée à déclarer — déduisez votre TVA sur achats avec votre comptable.": "Aan te geven gefactureerde btw — trek de btw op uw aankopen af met uw boekhouder.",
  "TVA fournisseur": "Btw van de leverancier",
  "TVA par trimestre": "Btw per kwartaal",
  "TVA par mois": "Btw per maand",
  "Prochaines échéances TVA (trimestrielles)": "Volgende btw-deadlines (per kwartaal)",
  "Prochaines échéances TVA (mensuelles)": "Volgende btw-deadlines (maandelijks)",
  "Période en cours": "Lopende periode",
  "Période close": "Afgesloten periode",
  "Période à venir": "Toekomstige periode",
  "export envoyé au comptable": "export naar boekhouder verzonden",
  "TVA estimée à ce jour": "Geschatte btw tot vandaag",
  "TVA facturée": "Gefactureerde btw",
  "dépassée": "verstreken",
  "aujourd'hui": "vandaag",
  "· dépôt avant le": "· indienen vóór",

  "Envoi automatique chaque mois": "Automatische verzending elke maand",
  "Envoi mensuel actif": "Maandelijkse verzending actief",
  "Chaque 1er du mois, Devisto envoie à votre comptable le ZIP du mois écoulé (ventes, achats, règlements, UBL) avec un lien valable 90 jours. Vous pouvez aussi lui donner": "Elke 1e van de maand stuurt Devisto uw boekhouder een ZIP-bestand van de afgelopen maand (verkopen, aankopen, betalingen, UBL) via een link die 90 dagen geldig is. U kunt hem ook toegang geven",
  "Envoi automatique activé : votre comptable recevra l'export chaque début de mois.": "Automatische verzending ingeschakeld: uw boekhouder ontvangt de export aan het begin van elke maand.",
  "— dépôt": "— indiening",

  "TVAC": "Incl. btw",
  "TVAC / an": "Incl. btw / jaar",
  "TVAC ·": "Incl. btw ·",
  "Tableau de bord": "Dashboard",
  "Tableau de bord international": "Internationaal dashboard",
  "Tableau électrique": "Elektrisch verdeelbord",
  "Taille du logo": "Grootte van het logo",
  "Taille du texte": "Tekstgrootte",
  "Tapez au moins 2 lettres. La recherche couvre vos clients, dossiers chantier, devis, interventions et\n              factures.": "Typ minstens 2 letters. De zoekfunctie doorzoekt uw klanten, werfdossiers, offertes, interventies en\n              facturen.",
  "Tapez au moins 2 lettres. La recherche couvre vos clients, dossiers chantier, devis, interventions et factures.": "Typ minstens 2 letters. De zoekfunctie doorzoekt uw klanten, werfdossiers, offertes, interventies en facturen.",
  "Tapissier / décoration murale": "Behanger / wanddecoratie",
  "Tarif actuel": "Huidig tarief",
  "Taux de TVA": "Btw-tarief",
  "Taux de change → EUR (statistiques consolidées)": "Wisselkoers → EUR (geconsolideerde statistieken)",
  "Taux normal": "Normaal tarief",
  "Taux réduit 12 % (logement social, restauration…)": "Verlaagd tarief 12 % (sociale huisvesting, horeca…)",
  "Taux réduit 6 % (rénovation logement > 10 ans)": "Verlaagd tarief 6 % (renovatie woning > 10 jaar)",
  "Technicien": "Technieker",
  "Technicien en route": "Technieker onderweg",
  "Technique (chasse fixe)": "Techniek (vaste spoeling)",
  "Temps de main-d'œuvre": "Arbeidstijd",
  "Temps de trajet estimé (minutes)": "Geschatte reistijd (minuten)",
  "Tendez votre téléphone au client : il relit le total et signe au doigt.": "Geef uw telefoon aan de klant: die controleert het totaalbedrag en ondertekent met een vinger.",
  "Tension": "Spanning",
  "Terminer": "Afronden",
  "Terminer (": "Afronden (",
  "Terminer ce contrat ? Les échéances automatiques s'arrêtent.": "Dit contract beëindigen? De automatische vervaldata worden stopgezet.",
  "Terminer l'intervention": "De interventie afronden",
  "Terminer la dictée": "Dicteren beëindigen",
  "Terminer le contrat": "Het contract beëindigen",
  "Terminé": "Afgerond",
  "Terminée": "Afgerond",
  "Terminés": "Afgerond",
  "Terrassement et égouttage": "Grondwerken en rioleringswerken",
  "Terrasses et aménagements extérieurs": "Terrassen en buitenaanleg",
  "Tester": "Testen",
  "Texte généré automatiquement": "Automatisch gegenereerde tekst",
  "Texte libre": "Vrije tekst",
  "Thème": "Thema",
  "Titre": "Titel",
  "Titre et encarts en teinte douce, modes de paiement et totaux côte à côte.": "Titel en kaders in een zachte tint, betaalmethoden en totalen naast elkaar.",
  "Titres et en-têtes de tableau dans votre couleur pleine, plus sobre.": "Titels en tabelkoppen in uw volle kleur, voor een soberdere uitstraling.",
  "Toiture": "Dakwerken",
  "Ton du message": "Toon van het bericht",
  "Total": "Totaal",
  "Total HTVA": "Totaal excl. btw",
  "Total HTVA :": "Totaal excl. btw:",
  "Total TVAC": "Totaal incl. btw",
  "Total TVAC *": "Totaal incl. btw *",
  "Total avec option": "Totaal met optie",
  "Total base TVAC": "Basistotaal incl. btw",
  "Total encaissé": "Totaal ontvangen",
  "Touchez la photo pour placer les points (": "Tik op de foto om de punten te plaatsen (",
  "Tous": "Alle",
  "Tous fournisseurs": "Alle leveranciers",
  "Tous les 12 mois": "Om de 12 maanden",
  "Tous les 2 ans": "Om de 2 jaar",
  "Tous les 6 mois": "Om de 6 maanden",
  "Tous les bâtiments": "Alle gebouwen",
  "Tous les chantiers": "Alle werven",
  "Tous les comptes de vos ouvriers inclus": "Alle accounts van uw arbeiders inbegrepen",
  "Tous les contrats": "Alle contracten",
  "Tous les dossiers": "Alle dossiers",
  "Tous les entretiens et réparations": "Alle onderhoudsbeurten en herstellingen",
  "Tous les guides": "Alle handleidingen",
  "Tous les mois": "Elke maand",
  "Tous les métiers du CVC": "Alle HVAC-vakgebieden",
  "Tous les paiements encaissés sur vos factures, du plus récent au plus ancien.": "Alle ontvangen betalingen voor uw facturen, van de recentste tot de oudste.",
  "Tous risques chantier": "Alle risico's op de werf",
  "Tous vos devis, du brouillon à la signature.": "Al uw offertes, van concept tot ondertekening.",
  "Tous vos documents et rapports accessibles en un seul endroit.": "Al uw documenten en rapporten toegankelijk op één plek.",
  "Tout Devisto Studio": "Alles van Devisto Studio",
  "Tout Devisto, en quelques fonctionnalités clés.": "Heel Devisto in enkele kernfuncties.",
  "Tout ce qui concerne votre comptable au même endroit : envoi automatique chaque trimestre, accès à l'application en lecture seule, questions sur vos factures.": "Alles voor uw boekhouder op één plek: automatische verzending per kwartaal, alleen-lezen toegang tot de applicatie en vragen over uw facturen.",
  "Tout est en ordre : aucune action urgente aujourd'hui.": "Alles is in orde: vandaag zijn er geen dringende acties.",
  "Tout le matériel à emporter, tous vos chantiers en cours réunis. Cochez au comptoir, le dossier se met à jour.": "Al het materiaal dat u moet meenemen en al uw lopende werven op één plek. Vink het af aan de balie en het dossier wordt bijgewerkt.",
  "Tout lu": "Alles gelezen",
  "Tout marquer comme lu": "Alles als gelezen markeren",
  "Toute la Belgique": "Heel België",
  "Toutes": "Alle",
  "Toutes les 2 semaines": "Om de 2 weken",
  "Toutes les factures": "Alle facturen",
  "Toutes les périodes": "Alle periodes",
  "Toutes les questions": "Alle vragen",
  "Toutes les semaines": "Elke week",
  "Toutes les tailles": "Alle maten",
  "Toutes répondues": "Allemaal beantwoord",
  "Traitement de l'eau": "Waterbehandeling",
  "Traitement de l'humidité et des caves": "Vochtbestrijding en kelderbehandeling",
  "Traitement du bois et de la charpente": "Hout- en dakgebintebehandeling",
  "Transcription en cours…": "Transcriptie wordt gemaakt…",
  "Transcription impossible.": "Transcriptie niet mogelijk.",
  "Transcription impossible. Réessayez.": "Transcriptie niet mogelijk. Probeer het opnieuw.",
  "Transcription…": "Transcriptie…",
  "Transfert impossible.": "Overdracht niet mogelijk.",
  "Transformation / extension": "Verbouwing / uitbreiding",
  "Transformer en devis (IA)": "Omzetten naar offerte (AI)",
  "Transmettre à ma comptabilité": "Doorsturen naar mijn boekhouding",
  "Transmises via Peppol": "Verzonden via Peppol",
  "Transparence": "Transparantie",
  "Travail réalisé": "Uitgevoerd werk",
  "Travaux :": "Werken:",
  "Travaux réalisés": "Uitgevoerde werken",
  "Trimestre": "Kwartaal",
  "Triphasé": "Driefasig",
  "Triphasé 230V": "Driefasig 230V",
  "Triphasé 400V": "Driefasig 400V",
  "Trouver un chauffagiste, un plombier, un électricien ou un spécialiste HVAC": "Een verwarmingsinstallateur, loodgieter, elektricien of HVAC-specialist vinden",
  "Trouver un plombier pour vos installations sanitaires, réparations de fuites et rénovations de salle de bain.": "Vind een loodgieter voor uw sanitaire installaties, lekherstellingen en badkamerrenovaties.",
  "Trouvez facilement un professionnel qualifié pour vos travaux et besoins techniques, partout en Belgique.": "Vind gemakkelijk een gekwalificeerde vakman voor uw werken en technische behoeften, overal in België.",
  "Trouvez le bon professionnel": "Vind de juiste vakman",
  "Trouvez rapidement un professionnel de confiance et suivez votre intervention en toute transparence.": "Vind snel een betrouwbare vakman en volg uw interventie op de voet.",
  "Très bien": "Heel goed",
  "Tubage / cheminée": "Schoorsteenvoering / schoorsteen",
  "Tubage cheminée": "Schoorsteenvoering",
  "Tube encastré": "Ingebouwde buis",
  "Tuyauterie": "Leidingen",
  "Type": "Type",
  "Type d'installation": "Type installatie",
  "Type d'équipement": "Type toestel",
  "Type de bâtiment": "Type gebouw",
  "Type de client": "Type klant",
  "Type de conduit": "Type kanaal",
  "Type de câble": "Type kabel",
  "Type de facture invalide": "Ongeldig factuurtype",
  "Type de garantie": "Type garantie",
  "Type de pose": "Type plaatsing",
  "Type de poste (détecté automatiquement, modifiable)": "Type post (automatisch gedetecteerd, aanpasbaar)",
  "Type de production": "Type productie",
  "Type de raccordement": "Type aansluiting",
  "Téléchargement impossible.": "Downloaden niet mogelijk.",
  "Téléchargement impossible. Réessayez.": "Downloaden niet mogelijk. Probeer het opnieuw.",
  "Télécharger": "Downloaden",
  "Télécharger PDF": "PDF downloaden",
  "Télécharger la version verticale": "De verticale versie downloaden",
  "Télécharger le CSV": "Het CSV-bestand downloaden",
  "Télécharger le PDF": "Het PDF-bestand downloaden",
  "Télécharger le ZIP": "Het ZIP-bestand downloaden",
  "Téléphone": "Telefoon",
  "Téléphone *": "Telefoon *",
  "Téléversement impossible.": "Uploaden niet mogelijk.",
  "UBL Peppol": "UBL Peppol",
  "URL webhook à déclarer chez Recommand :": "Webhook-URL die u bij Recommand moet opgeven:",
  "Un PDF envoyé par email ne suffit plus : la facture doit transiter par le réseau Peppol au format UBL.": "Een PDF per e-mail volstaat niet meer: de factuur moet in UBL-formaat via het Peppol-netwerk worden verzonden.",
  "Un ZIP avec vos journaux en CSV (Excel, WinBooks, Exact, Yuki…) et les factures de vente en UBL.": "Een ZIP-bestand met uw boekhoudkundige dagboeken in CSV-formaat (Excel, WinBooks, Exact, Yuki…) en uw verkoopfacturen in UBL-formaat.",
  "Un accès direct depuis votre écran d'accueil, même sur chantier.": "Rechtstreekse toegang vanaf uw startscherm, zelfs op de werf.",
  "Un clic : la facture part au format officiel. Vous suivez la livraison (reçue, en attente, échec).": "Eén klik: de factuur wordt in het officiële formaat verzonden. U volgt de aflevering op (ontvangen, in afwachting, mislukt).",
  "Un commentaire ? (facultatif)": "Een opmerking? (optioneel)",
  "Un compte Devisto existe déjà avec cet email": "Er bestaat al een Devisto-account met dit e-mailadres",
  "Un compte existe déjà avec cet email": "Er bestaat al een account met dit e-mailadres",
  "Un devis en 5 minutes, pas en 3 heures ce soir": "Een offerte in 5 minuten, in plaats van er vanavond 3 uur aan te besteden",
  "Un devis signé ne peut pas être supprimé": "Een ondertekende offerte kan niet worden verwijderd",
  "Un document clair à laisser au client à la fin de la visite : constats, mesures, matériel prévu et photos. Aucun prix, aucun engagement.": "Een duidelijk document om na het bezoek bij de klant achter te laten: vaststellingen, opmetingen, voorzien materiaal en foto's. Geen prijzen, geen verplichtingen.",
  "Un dossier par chantier : capturez sur place, complétez pendant la journée.": "Eén dossier per werf: leg alles ter plaatse vast en vul het in de loop van de dag aan.",
  "Un fichier Peppol BIS 3 par facture de vente, importable directement dans le logiciel du comptable": "Eén Peppol BIS 3-bestand per verkoopfactuur, rechtstreeks te importeren in de software van uw boekhouder",
  "Un grand merci ! Pourriez-vous partager votre expérience publiquement ?": "Hartelijk dank! Zou u uw ervaring openbaar willen delen?",
  "Un modèle portant le même nom sera remplacé.": "Een sjabloon met dezelfde naam wordt vervangen.",
  "Un mot sur l'intervention ? (facultatif)": "Een woordje over de interventie? (optioneel)",
  "Un professionnel HVAC pour vos systèmes de chauffage, ventilation et conditionnement d'air, en résidentiel comme en tertiaire.": "Een HVAC-vakman voor uw verwarmings-, ventilatie- en airconditioningsystemen, zowel in woningen als in bedrijfsgebouwen.",
  "Un réseau de professionnels qualifiés et évalués.": "Een netwerk van gekwalificeerde en beoordeelde vakmensen.",
  "Une erreur est survenue. Réessayez.": "Er is een fout opgetreden. Probeer het opnieuw.",
  "Une facture envoyée ne se supprime pas : créez une note de crédit depuis la facture concernée.": "Een verzonden factuur kan niet worden verwijderd: maak een creditnota aan vanuit de betrokken factuur.",
  "Une facture payée ne peut plus être modifiée": "Een betaalde factuur kan niet meer worden gewijzigd",
  "Une invitation est déjà en attente pour cet email": "Er staat al een uitnodiging voor dit e-mailadres open",
  "Une ligne par facture : numéro, date, client, n° de TVA, base HTVA, TVA 21 %, total TVAC et référence Stripe. Fichier prêt à envoyer à votre comptable (séparateur point-virgule, ouvrable dans Excel).": "Eén regel per factuur: nummer, datum, klant, btw-nummer, bedrag excl. btw, btw 21 %, totaal incl. btw en Stripe-referentie. Bestand klaar om naar uw boekhouder te sturen (gescheiden door puntkomma's, te openen in Excel).",
  "Une minute suffit, cela nous aide énormément.": "Eén minuutje volstaat. U helpt ons er enorm mee.",
  "Une note de crédit ne peut pas être créditée": "Voor een creditnota kan geen creditnota worden aangemaakt",
  "Une nouvelle façon de gérer les interventions techniques": "Een nieuwe manier om technische interventies te beheren",
  "Une phrase dictée ou écrite, et le devis est chiffré": "Eén ingesproken of geschreven zin volstaat om de offerte te berekenen",
  "Une question ? Parlons-en.": "Een vraag? Laten we erover praten.",
  "Une question sur": "Een vraag over",
  "Une question sur Devisto Studio, une démonstration pour votre équipe, un besoin particulier pour votre métier ? Écrivez-nous, nous répondons rapidement.": "Een vraag over Devisto Studio, een demonstratie voor uw team of een specifieke behoefte voor uw vak? Schrijf ons, we antwoorden snel.",
  "Une remarque ? (facultatif)": "Een opmerking? (optioneel)",
  "Une seule clé Devisto pour toutes les sociétés. Créez-la sur app.recommand.eu → Paramètres → API, puis collez-la ici : l'envoi réel s'active sans redéploiement.": "Eén Devisto-sleutel voor alle bedrijven. Maak die aan op app.recommand.eu → Instellingen → API en plak die hier: het daadwerkelijk verzenden wordt geactiveerd zonder nieuwe uitrol.",
  "Unité": "Eenheid",
  "Urgence": "Dringend",
  "Utilisé dans l'e-mail de rapport et sur la page d'avis après intervention.": "Wordt gebruikt in de e-mail met het rapport en op de beoordelingspagina na de interventie.",
  "Utilisé pour les devis dictés, rapports, réponses aux clients, contrats et modèles suggérés. Si le moteur choisi ne répond pas, Devisto bascule automatiquement sur l'autre.": "Wordt gebruikt voor ingesproken offertes, rapporten, antwoorden aan klanten, contracten en voorgestelde sjablonen. Als de gekozen engine niet reageert, schakelt Devisto automatisch over naar de andere.",
  "VMC simple et double flux : une ventilation performante pour une qualité d'air intérieur optimale.": "Mechanische ventilatie met enkele en dubbele luchtstroom: efficiënte ventilatie voor een optimale binnenluchtkwaliteit.",
  "Va-et-vient": "Wisselschakelaar",
  "Valable jusqu'au": "Geldig tot",
  "Valeur": "Waarde",
  "Valider": "Bevestigen",
  "Valider la signature": "Handtekening bevestigen",
  "Validité des devis (jours)": "Geldigheid van offertes (dagen)",
  "Validé le": "Bevestigd op",
  "Valorisez votre Devisto Score : réactivité, qualifications et avis clients": "Zet uw Devisto Score in de kijker: reactiesnelheid, kwalificaties en klantbeoordelingen",
  "Variante ou nouvelle version pour ce chantier": "Variant of nieuwe versie voor deze werf",
  "Variateur": "Dimmer",
  "Ven": "Vr",
  "Ventes": "Verkopen",
  "Ventilation": "Ventilatie",
  "Ventilation du local": "Ventilatie van de ruimte",
  "Ventouse horizontale": "Horizontale rookgasafvoer",
  "Ventouse verticale": "Verticale rookgasafvoer",
  "Version liée (autre langue)": "Gekoppelde versie (andere taal)",
  "Version verticale · Reels & TikTok": "Verticale versie · Reels & TikTok",
  "Vert atelier": "Ateliergroen",
  "Via le logiciel de mon comptable": "Via de software van mijn boekhouder",
  "Vide technique": "Technische ruimte",
  "Vidéophone": "Videofoon",
  "Ville": "Gemeente",
  "Ville du chantier": "Gemeente van de werf",
  "Virement": "Overschrijving",
  "Virement bancaire uniquement": "Uitsluitend via bankoverschrijving",
  "Virement effectué ?": "Overschrijving uitgevoerd?",
  "Visite envoyée au client ·": "Bezoek naar de klant verstuurd ·",
  "Visite et conseil": "Bezoek en advies",
  "Visite à effectuer": "Nog af te leggen bezoek",
  "Visites et interventions": "Bezoeken en interventies",
  "Visites techniques et interventions": "Technische bezoeken en interventies",
  "Visualiser": "Bekijken",
  "Visualiser le devis": "De offerte bekijken",
  "Vitrier": "Glaszetter",
  "Voici une photo.": "Hier is een foto.",
  "Voir": "Bekijken",
  "Voir l'abonnement": "Het abonnement bekijken",
  "Voir la page": "De pagina bekijken",
  "Voir la preuve": "Het bewijs bekijken",
  "Voir la réponse envoyée": "Het verzonden antwoord bekijken",
  "Vos clients paient par Bancontact, Payconiq ou virement depuis le bouton « Payer maintenant » de l'e-mail : leur app bancaire s'ouvre pré-remplie et la facture passe": "Uw klanten betalen met Bancontact, Payconiq of via overschrijving met de knop « Nu betalen » in de e-mail: hun bankapp opent met vooraf ingevulde gegevens en de factuur wordt",
  "Vos clients peuvent poser une question depuis la page de leur devis ou facture. Vous pouvez aussi coller un e-mail reçu.": "Uw klanten kunnen een vraag stellen via de pagina van hun offerte of factuur. U kunt ook een ontvangen e-mail plakken.",
  "Vos clients verront votre RC professionnelle en bas des devis et factures.": "Uw klanten zien uw beroepsaansprakelijkheidsverzekering onderaan uw offertes en facturen.",
  "Vos coûts sont déjà renseignés.": "Uw kosten zijn al ingevuld.",
  "Vos devis acceptés et signés, depuis le 1er janvier, par trimestre et par mois.": "Uw aanvaarde en ondertekende offertes sinds 1 januari, per kwartaal en per maand.",
  "Vos documents sont à votre charte.": "Uw documenten volgen uw huisstijl.",
  "Vos documents à votre image": "Uw documenten in uw huisstijl",
  "Vos données et vos demandes sont conservées en sécurité.": "Uw gegevens en aanvragen worden veilig bewaard.",
  "Vos données ne servent qu'à établir votre devis. Page sécurisée by Devisto.": "Uw gegevens worden alleen gebruikt om uw offerte op te stellen. Door Devisto beveiligde pagina.",
  "Vos factures clients continuent de partir par Peppol depuis": "Uw klantfacturen blijven via Peppol verstuurd worden vanuit",
  "Vos nom et prénom *": "Uw naam en voornaam *",
  "Vos visites techniques et interventions du mois. Touchez un jour pour y ajouter une intervention.": "Uw technische bezoeken en interventies van deze maand. Tik op een dag om een interventie toe te voegen.",
  "Votre abonnement est en cours.": "Uw abonnement is actief.",
  "Votre avis Google aide d'autres clients à nous faire confiance.": "Uw Google-review helpt andere klanten om ons te vertrouwen.",
  "Votre bibliothèque de prestations : l'assistant l'utilise pour chiffrer vos devis avec VOS prix.": "Uw bibliotheek met diensten: de assistent gebruikt die om uw offertes te berekenen met UW prijzen.",
  "Votre carnet d'adresses : réutilisez un client en un tap lors de la création d'un dossier.": "Uw adresboek: selecteer met één tik een bestaande klant wanneer u een dossier aanmaakt.",
  "Votre comptable n'a pas encore son envoi trimestriel automatique": "Uw boekhouder ontvangt nog geen automatische driemaandelijkse verzending",
  "Votre comptable reçoit un email, choisit son mot de passe et consulte vos factures, achats et exports quand il en a besoin : plus rien à lui envoyer.": "Uw boekhouder ontvangt een e-mail, kiest een wachtwoord en raadpleegt uw facturen, aankopen en exports wanneer dat nodig is: u hoeft niets meer door te sturen.",
  "Votre comptable se connecte sur Devisto avec son propre mot de passe et ne voit que vos factures de vente (PDF + UBL), vos achats et l'export comptable. Ni devis, ni chantiers, aucune modification possible.": "Uw boekhouder meldt zich met een eigen wachtwoord aan bij Devisto en ziet alleen uw verkoopfacturen (PDF + UBL), uw aankopen en de boekhoudexport. Geen offertes of werven, en wijzigingen zijn niet mogelijk.",
  "Votre dossier a été refusé :": "Uw dossier werd geweigerd:",
  "Votre e-mail (facultatif)": "Uw e-mailadres (optioneel)",
  "Votre e-mail pour la réponse": "Uw e-mailadres voor het antwoord",
  "Votre essai est terminé": "Uw proefperiode is afgelopen",
  "Votre installateur": "Uw installateur",
  "Votre message…": "Uw bericht…",
  "Votre nom": "Uw naam",
  "Votre nom *": "Uw naam *",
  "Votre nom et prénom *": "Uw achternaam en voornaam *",
  "Votre retour a bien été transmis à l'équipe.": "Uw feedback is doorgestuurd naar het team.",
  "Votre réponse": "Uw antwoord",
  "Votre réponse (envoyée par e-mail au comptable)": "Uw antwoord (per e-mail verstuurd naar de boekhouder)",
  "Votre société": "Uw bedrijf",
  "Votre société est vérifiée. Le point d'accès Peppol de Devisto est en cours d'activation : vos factures partent par email ou en fichier UBL en attendant.": "Uw bedrijf is geverifieerd. Het Peppol-toegangspunt van Devisto wordt geactiveerd: in afwachting daarvan worden uw facturen per e-mail of als UBL-bestand verstuurd.",
  "Votre statut est « non assujetti / franchise » : pas de TVA à facturer, mention d'exonération obligatoire.": "Uw status is « niet-btw-plichtig / vrijstellingsregeling »: u mag geen btw aanrekenen en een vrijstellingsvermelding is verplicht.",
  "Vous cherchez un technicien pour vos chantiers ?": "Zoekt u een technieker voor uw werven?",
  "Vous intervenez d'abord, vous ouvrez le dossier ensuite si un devis est nécessaire.": "U voert eerst de interventie uit, daarna opent u het dossier als een offerte nodig is.",
  "Vous pourrez le relire, télécharger le PDF, l'envoyer à signer et l'enregistrer comme modèle.": "U kunt het nalezen, de PDF downloaden, het ter ondertekening versturen en het als sjabloon opslaan.",
  "Vous refusez ce contrat. Un mot pour l'entreprise ? (facultatif)": "U weigert dit contract. Wilt u het bedrijf iets laten weten? (optioneel)",
  "Vous rédigez le pied de page vous-même.": "U stelt de voettekst zelf op.",
  "Vous êtes déjà le responsable de la société": "U bent al de verantwoordelijke van het bedrijf",
  "Vu par le client": "Bekeken door de klant",
  "Vue": "Weergave",
  "Vérification du paiement…": "Betaling controleren…",
  "Vérification impossible.": "Controle niet mogelijk.",
  "Vérifications sur place": "Controles ter plaatse",
  "Vérifier": "Controleren",
  "Vérifier et activer": "Controleren en activeren",
  "Vérifier et envoyer": "Controleren en verzenden",
  "Vérifiez d'abord votre numéro de TVA.": "Controleer eerst uw btw-nummer.",
  "Vérifiez le QR code ou contactez votre installateur.": "Controleer de QR-code of neem contact op met uw installateur.",
  "Vérifiez votre TVA et déposez votre preuve pour débloquer les factures Peppol.": "Controleer uw btw-gegevens en upload uw bewijsstuk om Peppol-facturen te deblokkeren.",
  "Vérifié en direct dans la base officielle européenne VIES.": "Rechtstreeks gecontroleerd in de officiële Europese VIES-databank.",
  "Vétuste": "Verouderd",
  "WhatsApp": "WhatsApp",
  "XML Peppol": "XML Peppol",
  "Yuki": "Yuki",
  "Yuki injoignable. Réessayez dans un instant.": "Yuki is niet bereikbaar. Probeer het zo meteen opnieuw.",
  "ZIP du trimestre (CSV + UBL), lien valable 90 jours. Confirmez la réception pour prévenir l'entreprise.": "ZIP-bestand van het kwartaal (CSV + UBL), link 90 dagen geldig. Bevestig de ontvangst om het bedrijf op de hoogte te brengen.",
  "Zinguerie et corniches": "Zinkwerk en kroonlijsten",
  "Zone de couverture": "Werkgebied",
  "Zoom arrière": "Uitzoomen",
  "Zoom avant": "Inzoomen",
  "[aria-current=\"page\"]": "[aria-current=\"page\"]",
  "[data-testid=email-template-": "[data-testid=email-template-",
  "],\n            [\"En retard\", eur(summary.late_amount),": "],\n            [\"Achterstallig\", eur(summary.late_amount),",
  "],\n    [\"En retard\", eur(summary.late_amount),": "],\n    [\"Achterstallig\", eur(summary.late_amount),",
  "a reçu votre demande et vous recontacte rapidement avec un devis.": "heeft uw aanvraag ontvangen en neemt binnenkort contact met u op met een offerte.",
  "a répondu en": "antwoordde in",
  "acceptés": "aanvaard",
  "adresse VIES indisponible": "VIES-adres niet beschikbaar",
  "adresse@email.be": "adresse@email.be",
  "ajouté au bâtiment": "toegevoegd aan het gebouw",
  "ajoutée": "toegevoegd",
  "annulés": "geannuleerd",
  "ans d'expérience": "jaar ervaring",
  "application/ld+json": "application/ld+json",
  "article(s) à acheter sur": "artikel(en) aan te kopen op",
  "article(s) à prendre": "artikel(en) mee te nemen",
  "au devis": "aan de offerte",
  "au devis — complétez le prix unitaire.": "aan de offerte — vul de eenheidsprijs in.",
  "aucun retard": "geen achterstand",
  "avec la communication": "met de mededeling",
  "avec le lien de paiement.": "met de betaallink.",
  "avec mon app bancaire": "met mijn bankapp",
  "avis client": "klantbeoordeling",
  "basculées par email automatiquement": "automatisch per e-mail doorgestuurd",
  "bg-[#0F2645]": "bg-[#0F2645]",
  "bg-[#3A5CC8]": "bg-[#3A5CC8]",
  "bg-[#EEF1FC]": "bg-[#EEF1FC]",
  "bg-[#F3F5FC]": "bg-[#F3F5FC]",
  "border-[#3A5CC8]": "border-[#3A5CC8]",
  "border-[#C9D4F4]": "border-[#C9D4F4]",
  "border-[#E2E7F7]": "border-[#E2E7F7]",
  "boîte": "doos",
  "caractères ·": "tekens ·",
  "ce devis": "deze offerte",
  "cette facture": "deze factuur",
  "cette note de crédit": "deze creditnota",
  "chaudière": "verwarmingsketel",
  "chiffré par l'IA :": "geraamd door AI:",
  "children ? (": "children? (",
  "châssis": "schrijnwerk",
  "cm (trait jaune)": "cm (gele lijn)",
  "collée par vous": "door u geplakt",
  "complétude": "volledigheid",
  "compte Mollie, puis viré sur": "Mollie-rekening, daarna overgeschreven naar",
  "connecter les bonnes compétences au bon moment": "de juiste vaardigheden op het juiste moment inzetten",
  "contrat(s) actif(s)": "actief(e) contract(en)",
  "contrôle": "controle",
  "copié": "gekopieerd",
  "créé avec": "aangemaakt met",
  "créé depuis l'intervention.": "aangemaakt vanuit de interventie.",
  "créé depuis le diagnostic : à faire signer par le client avant travaux.": "aangemaakt op basis van de diagnose: door de klant te ondertekenen vóór de werkzaamheden.",
  "créé en brouillon à partir de": "als concept aangemaakt op basis van",
  "créé en brouillon.": "als concept aangemaakt.",
  "créé à partir de votre modèle «": "aangemaakt op basis van uw sjabloon «",
  "créé.": "aangemaakt.",
  "créée depuis le diagnostic.": "aangemaakt op basis van de diagnose.",
  "créée.": "aangemaakt.",
  "câblage": "bekabeling",
  "câble": "kabel",
  "de CA ·": "van de omzet ·",
  "de devis (il choisit le plus proche)": "van offertes (hij kiest de meest vergelijkbare)",
  "de main-d'œuvre": "aan arbeidsuren",
  "depuis la page du document": "vanaf de documentpagina",
  "depuis le": "vanuit de",
  "devFadeUp .16s ease-out": "devFadeUp .16s ease-out",
  "devFadeUp .18s ease-out": "devFadeUp .18s ease-out",
  "devFadeUp .25s ease-out": "devFadeUp .25s ease-out",
  "devSlideUp .22s ease-out": "devSlideUp .22s ease-out",
  "devSlideUp .2s ease-out": "devSlideUp .2s ease-out",
  "devis en attente de réponse": "offertes in afwachting van antwoord",
  "devis signés": "ondertekende offertes",
  "devis ·": "offertes ·",
  "démolition": "sloop",
  "démontage": "demonteren",
  "déplacement": "verplaatsing",
  "dépose": "verwijderen",
  "email@fiduciaire.be": "email@fiduciaire.be",
  "email@ouvrier.be": "email@ouvrier.be",
  "en attente": "in afwachting",
  "en attente de réponse": "in afwachting van antwoord",
  "en cours de livraison": "wordt geleverd",
  "en retard": "te laat",
  "encaissés": "geïnd",
  "end start": "end start",
  "enregistrée.": "opgeslagen.",
  "ensuite, vos ouvriers inclus.": "daarna, inclusief uw arbeiders.",
  "envoyé": "verzonden",
  "envoyé à": "verzonden naar",
  "est renseigné : activez l'envoi pour que l'export (ventes, achats, règlements, UBL) parte seul chaque 1er janvier, avril, juillet et octobre.": "is ingevuld: schakel de verzending in zodat de export (verkopen, aankopen, betalingen, UBL) automatisch wordt verzonden op 1 januari, 1 april, 1 juli en 1 oktober.",
  "et le client le signe en un clic.": "en de klant ondertekent die met één klik.",
  "et rendre chaque intervention plus transparente, plus réactive et mieux suivie.": "en elke interventie transparanter, sneller en beter opgevolgd maken.",
  "et simplifie les techniques spéciales du bâtiment.": "en vereenvoudigt de speciale technieken in gebouwen.",
  "et vos": "en uw",
  "ex. 2,40": "bv. 2,40",
  "facture(s)": "factuur/facturen",
  "facture(s) —": "factuur/facturen —",
  "factures et notes de crédit": "facturen en creditnota’s",
  "facturés ·": "gefactureerd ·",
  "facturés)": "gefactureerd)",
  "fenêtre": "raam",
  "forfait": "forfait",
  "heure": "uur",
  "hover:bg-[#F6F8FD]": "hover:bg-[#F6F8FD]",
  "iPhone : Partager → « Sur l'écran d'accueil », puis activez depuis l'icône Devisto.": "iPhone: Delen → ‘Zet op beginscherm’, activeer vervolgens via het Devisto-pictogram.",
  "il y a": "geleden",
  "image/*": "image/*",
  "info@devis-to.be": "info@devis-to.be",
  "it.separator ? (": "it.separator? (",
  "j de retard": "d vertraging",
  "jour(s) restant(s)": "resterende dag(en)",
  "journée": "dag",
  "ligne(s) proposée(s)": "voorgestelde regel(s)",
  "ligne(s) préparée(s).": "voorbereide regel(s).",
  "ligne(s), durée manquante sur": "regel(s), duur ontbreekt bij",
  "ligne(s).": "regel(s).",
  "lignes : ajustez les prix puis envoyez.": "regels: pas de prijzen aan en verzend vervolgens.",
  "lignes), ajusté par l'IA.": "regels), aangepast door AI.",
  "lignes).": "regels).",
  "lignes). Retrouvez-le dans « Nouveau devis ».": "regels). U vindt het terug onder « Nieuwe offerte ».",
  "lignes, prix, conditions et remarques de": "regels, prijzen, voorwaarden en opmerkingen van",
  "linear-gradient(168deg, #163663 0%, #0F2645 55%, #0A1B33 100%)": "linear-gradient(168deg, #163663 0%, #0F2645 55%, #0A1B33 100%)",
  "linear-gradient(to top, rgba(15,38,69,0.9), rgba(15,38,69,0))": "linear-gradient(to top, rgba(15,38,69,0.9), rgba(15,38,69,0))",
  "main d": "arbeid",
  "marqué comme reçu : l'entreprise est prévenue.": "gemarkeerd als ontvangen: het bedrijf is op de hoogte gebracht.",
  "matériaux": "materialen",
  "matériel": "materiaal",
  "meta[name=\"description\"]": "meta[name=\"description\"]",
  "min de trajet": "min reistijd",
  "mise en conformité": "aanpassing aan de normen",
  "mise en route": "opstart",
  "mise en service": "inbedrijfstelling",
  "ml-auto shrink-0": "ml-auto shrink-0",
  "modèle": "sjabloon",
  "mètre": "meter",
  "méthodes à activer dans Mollie": "methoden die u in Mollie moet activeren",
  "no token": "no token",
  "noopener noreferrer": "noopener noreferrer",
  "nouvelle version (effet": "nieuwe versie (effect",
  "ouvrier(s)": "arbeider(s)",
  "paiements reçus cette année": "dit jaar ontvangen betalingen",
  "par mois pour toute votre société, ouvriers inclus.": "per maand voor uw hele bedrijf, inclusief arbeiders.",
  "payée": "betaald",
  "photos de l'intervention (matériel, état, travaux visibles)": "foto's van de interventie (materiaal, toestand, zichtbare werkzaamheden)",
  "pièce": "onderdeel",
  "pièces": "onderdelen",
  "planifiée.": "ingepland.",
  "ponçage": "schuren",
  "pour ce document (vérifié avec mon comptable si nécessaire). Sans confirmation, l'envoi est bloqué.": "voor dit document (indien nodig nagekeken met mijn boekhouder). Zonder bevestiging wordt de verzending geblokkeerd.",
  "prestations ajoutées.": "toegevoegde prestaties.",
  "prestations complétées.": "prestaties afgerond.",
  "prestations incluses,": "inbegrepen prestaties,",
  "profilé": "profiel",
  "préparation": "voorbereiding",
  "pts ·": "pts ·",
  "radial-gradient(110% 80% at 80% 6%, rgba(58,92,200,0.26) 0%, rgba(58,92,200,0) 60%)": "radial-gradient(110% 80% at 80% 6%, rgba(58,92,200,0.26) 0%, rgba(58,92,200,0) 60%)",
  "rappel(s) envoyé(s) par email.": "herinnering(en) verzonden via e-mail.",
  "rappel(s) envoyé(s) — dernier le": "herinnering(en) verzonden — laatste op",
  "refusés": "geweigerd",
  "relance(s)": "herinnering(en)",
  "relance(s) déjà envoyée(s)": "herinnering(en) al verzonden",
  "relance(s) · dernière le": "herinnering(en) · laatste op",
  "remise en service": "heringebruikname",
  "rendez-vous sur 7 jours": "afspraken over 7 dagen",
  "repeat(": "repeat(",
  "resize-none pr-14": "resize-none pr-14",
  "retenue par le client": "ingehouden door de klant",
  "reçu le": "ontvangen op",
  "reçues par le client": "ontvangen door de klant",
  "rien de planifié cette semaine": "niets gepland deze week",
  "ring-[#C9D4F4]": "ring-[#C9D4F4]",
  "ring-[#E2E7F7]": "ring-[#E2E7F7]",
  "règlement": "betaling",
  "réel": "werkelijk",
  "réglage": "afstelling",
  "réparation": "herstelling",
  "répondue": "beantwoord",
  "sans tarif": "zonder tarief",
  "seront proposés à la création d'un nouveau devis.": "worden voorgesteld bij het aanmaken van een nieuwe offerte.",
  "signé": "ondertekend",
  "soumis le": "ingediend op",
  "start start": "start start",
  "supposé)": "verondersteld)",
  "supprimé.": "verwijderd.",
  "sur 5": "op 5",
  "sur l'année": "op jaarbasis",
  "tarifs d'intervention ajoutés.": "interventietarieven toegevoegd.",
  "text-[#0F2645]": "text-[#0F2645]",
  "text-[#3A5CC8]": "text-[#3A5CC8]",
  "text-[#5C6A87]": "text-[#5C6A87]",
  "text-[#93A0BC]": "text-[#93A0BC]",
  "text-[#9FB4F2]": "text-[#9FB4F2]",
  "text-[#C9D4F4]": "text-[#C9D4F4]",
  "text-[#E2E7F7]": "text-[#E2E7F7]",
  "text-[#F97316]": "text-[#F97316]",
  "text/csv;charset=utf-8": "text/csv;charset=utf-8",
  "tous les": "alle",
  "toute seule.": "helemaal alleen.",
  "un accès direct en consultation": "rechtstreekse inzagetoegang",
  "unité": "eenheid",
  "valable jusqu'au": "geldig tot",
  "virement uniquement": "enkel via overschrijving",
  "voir le dossier": "het dossier bekijken",
  "votre assureur": "uw verzekeraar",
  "votre compte bancaire": "uw bankrekening",
  "votre profil": "uw profiel",
  "vous invite": "nodigt u uit",
  "vous recontactera rapidement": "neemt binnenkort opnieuw contact met u op",
  "vous@entreprise.": "u@bedrijf.",
  "vous@exemple.be": "u@voorbeeld.be",
  "vérification": "controle",
  "vérifiés après intervention": "gecontroleerd na de interventie",
  "· Connexion itsme : bientôt, dès l'agrément partenaire": "· Aanmelden met itsme: binnenkort, zodra de partnergoedkeuring rond is",
  "· Création de factures débloquée immédiatement": "· Facturen aanmaken meteen beschikbaar",
  "· Devis": "· Offerte",
  "· Devis gratuit – 0 €": "· Gratis offerte – 0 €",
  "· Envoi Peppol via le point d'accès unique Devisto": "· Verzending via Peppol langs het unieke toegangspunt van Devisto",
  "· IP": "· IP",
  "· Peppol": "· Peppol",
  "· TVA": "· Btw",
  "· Vérification du document par Devisto sous 24 h ouvrées": "· Controle van het document door Devisto binnen 24 werkuren",
  "· accès actif depuis le": "· toegang actief sinds",
  "· acompte déjà facturé déduit": "· reeds gefactureerd voorschot afgetrokken",
  "· ancien tarif": "· vorig tarief",
  "· change → EUR": "· omrekening → EUR",
  "· consultation des ventes, achats et exports": "· inzage in verkopen, aankopen en exports",
  "· depuis «": "· sinds «",
  "· en attente de réponse": "· wacht op antwoord",
  "· en vigueur depuis le": "· van kracht sinds",
  "· encaissé": "· ontvangen",
  "· envoyé le": "· verzonden op",
  "· envoyé à": "· verzonden naar",
  "· fin le": "· eindigt op",
  "· horodatage conservé comme preuve (eIDAS)": "· tijdstempel bewaard als bewijs (eIDAS)",
  "· invitation envoyée le": "· uitnodiging verzonden op",
  "· l'entreprise reçoit une notification et vous répond par e-mail.": "· het bedrijf ontvangt een melding en antwoordt u per e-mail.",
  "· main-d'œuvre": "· werkuren",
  "· mode": "· modus",
  "· modèle «": "· model «",
  "· prend effet le": "· gaat in op",
  "· prochaine visite": "· volgend bezoek",
  "· rappel envoyé": "· herinnering verzonden",
  "· rappel prévu la veille": "· herinnering gepland de dag voordien",
  "· renouvelle": "· wordt verlengd",
  "· reçu le": "· ontvangen op",
  "· sans dossier": "· zonder dossier",
  "· sans rappel": "· zonder herinnering",
  "· signée": "· ondertekend",
  "· solde": "· saldo",
  "· téléchargé": "· gedownload",
  "· utilisé": "· gebruikt",
  "· valable jusqu'au": "· geldig tot",
  "· à payer": "· te betalen",
  "· éch.": "· verv.",
  "· échue le": "· vervallen op",
  "· échéance": "· vervaldatum",
  "» créé": "» aangemaakt",
  "» enregistré (": "» opgeslagen (",
  "» enregistré : proposé à la création d'un contrat.": "» opgeslagen: voorgesteld bij het aanmaken van een contract.",
  "» est ajouté automatiquement sous votre texte.": "» wordt automatisch onder uw tekst toegevoegd.",
  "À adapter": "Aan te passen",
  "À coller sur l'équipement": "Op het toestel te kleven",
  "À coller sur la chaudière : le client voit son historique et vos coordonnées": "Op de verwarmingsketel te kleven: de klant ziet de onderhoudshistoriek en uw contactgegevens",
  "À compléter :": "Aan te vullen:",
  "À créer": "Aan te maken",
  "À encaisser": "Te innen",
  "À faire valider et signer par le client avant les travaux": "Voor de werken door de klant te laten goedkeuren en ondertekenen",
  "À jour": "Up-to-date",
  "À partir d'un devis": "Op basis van een offerte",
  "À payer": "Te betalen",
  "À perte": "Met verlies",
  "À programmer": "In te plannen",
  "À prévoir": "Te voorzien",
  "À relancer": "Herinnering te versturen",
  "À renouveler": "Te vernieuwen",
  "À renouveler · fin": "Te vernieuwen · einde",
  "À réception de facture": "Bij ontvangst van de factuur",
  "À répondre": "Te beantwoorden",
  "À signer": "Te ondertekenen",
  "À traiter": "Te verwerken",
  "À traiter ·": "Te verwerken ·",
  "À venir": "Binnenkort",
  "À vérifier": "Te controleren",
  "Ébéniste": "Meubelmaker",
  "Échangez et avancez sur votre projet": "Overleg en werk verder aan uw project",
  "Échec": "Mislukt",
  "Échec de la remise à neuf.": "Het opknappen is mislukt.",
  "Échec pour :": "Mislukt voor:",
  "Échec → envoyée par email": "Mislukt → verzonden per e-mail",
  "Échecs": "Mislukte pogingen",
  "Échelle recalibrée : toutes les mesures ont été recalculées.": "Schaal opnieuw gekalibreerd: alle metingen zijn opnieuw berekend.",
  "Échéance": "Vervaldatum",
  "Échéance :": "Vervaldatum:",
  "Échéances traitées": "Afgehandelde vervaldagen",
  "Écrire": "Schrijven",
  "Électricien": "Elektricien",
  "Électricité": "Elektriciteit",
  "Électrique": "Elektrisch",
  "Élément introuvable": "Element niet gevonden",
  "Éléments enregistrés hors ligne, prêts à être synchronisés.": "Elementen offline opgeslagen, klaar om te synchroniseren.",
  "Émis le": "Uitgereikt op",
  "Équipe": "Team",
  "Équipement": "Toestel",
  "Équipement concerné": "Betrokken toestel",
  "Équipement introuvable.": "Toestel niet gevonden.",
  "Équipement supprimé": "Toestel verwijderd",
  "Équipements": "Toestellen",
  "Équipements spécifiques": "Specifieke toestellen",
  "Étape 1": "Stap 1",
  "Étape 2": "Stap 2",
  "Étape 3": "Stap 3",
  "Étape obligatoire": "Verplichte stap",
  "Étape obligatoire avant de créer vos factures : société vérifiée, puis envoi Peppol via le point d'accès Devisto.": "Verplichte stap voordat u facturen aanmaakt: eerst uw bedrijf laten verifiëren, daarna verzenden via Peppol met het toegangspunt van Devisto.",
  "État": "Staat",
  "État de l'installation": "Staat van de installatie",
  "État général": "Algemene staat",
  "Évacuation condensats": "Afvoer van condenswater",
  "à chiffrer": "te begroten",
  "à facturer": "te factureren",
  "à l'instant": "zojuist",
  "à la facture": "op de factuur",
  "à partir de": "vanaf",
  "à reverser (déclarations)": "door te storten (aangiften)",
  "à répondre": "te beantwoorden",
  "à vérifier)": "te controleren)",
  "échéance": "vervaldatum",
  "élément(s) capturé(s)": "vastgelegd(e) item(s)",
  "élément(s) n'ont pas pu être envoyés — nouvel essai plus tard.": "item(s) konden niet worden verzonden — probeer het later opnieuw.",
  "élément(s) synchronisé(s).": "item(s) gesynchroniseerd.",
  "équipement": "toestel",
  "équipements": "toestellen",
  "étoiles": "sterren",
  "évacuation": "afvoer",
  "êtes-vous en règle ?": "bent u in orde?",
  "– contrat n° … » en pied de page des devis et factures PDF.": "– contract n° … » onderaan de offertes en facturen in PDF-formaat.",
  "— aperçu client": "— klantvoorbeeld",
  "— base": "— basis",
  "— choisir": "— kiezen",
  "— choisissez celle qui vous convient": "— kies de optie die bij u past",
  "— email envoyé à": "— e-mail verzonden naar",
  "— figé pour préserver le référencement": "— vastgezet om de zoekmachine-indexering te behouden",
  "— fin du contrat le": "— einde van het contract op",
  "— mesure caméra": "— camerameting",
  "— non précisé (": "— niet opgegeven (",
  "— votre app bancaire s'ouvre avec le virement pré-rempli ; la facture est marquée payée automatiquement.": "— uw bankapp opent met de vooraf ingevulde overschrijving; de factuur wordt automatisch als betaald gemarkeerd.",
  "— à faire avant le": "— uit te voeren vóór",
  "— à préciser": "— nader te bepalen",
  "€ HTVA + TVA": "€ excl. btw + btw",
  "← Tous les modèles": "← Alle sjablonen",
  "≈ EUR": "≈ EUR",
  "Quel est le prix de marché d'un entretien de chaudière gaz en Espagne ?": "Wat is de marktprijs voor het onderhoud van een gasketel in Spanje?",
  "Quel est le prix de marché d'un entretien de chaudière gaz en France ?": "Wat is de marktprijs voor het onderhoud van een gasketel in Frankrijk?",
  "Quel est le prix de marché d'un entretien de chaudière mazout au Luxembourg ?": "Wat is de marktprijs voor het onderhoud van een stookolieketel in Luxemburg?"
};
